import { inject as ht, reactive as Gt, watch as me, ref as z, computed as B, shallowRef as co, markRaw as ds, defineComponent as le, onMounted as Fe, nextTick as Ve, openBlock as c, createElementBlock as _, withKeys as yt, unref as s, createElementVNode as i, withModifiers as ge, renderSlot as Ce, createCommentVNode as V, toDisplayString as w, createBlock as Y, resolveDynamicComponent as Ge, withCtx as ae, createVNode as j, Fragment as he, renderList as ke, normalizeClass as re, withDirectives as xe, vModelText as bt, vModelCheckbox as Wt, resolveComponent as uo, normalizeStyle as Be, normalizeProps as We, guardReactiveProps as Ye, createTextVNode as ye, customRef as cs, onUnmounted as Te, Teleport as Et, useTemplateRef as Ft, isRef as us, onBeforeUnmount as fo, vModelSelect as yn, vModelRadio as pn, mergeProps as je, toHandlers as nt, vShow as ze, onUpdated as fs, onActivated as vs, useModel as vo, mergeModels as _s, createSlots as hs, Transition as ps, provide as ms } from "vue";
import gs from "mitt";
import { useStore as Z } from "@nanostores/vue";
import { persistentAtom as In } from "@nanostores/persistent";
import { toast as zt, Toaster as ws } from "vue-sonner";
import { atom as Pe, computed as Ze } from "nanostores";
import { QueryClient as ys } from "@tanstack/vue-query";
import { OverlayScrollbars as Dt, SizeObserverPlugin as bs } from "overlayscrollbars";
import { computePosition as lt, offset as pt, flip as mt, shift as gt, autoUpdate as Tn } from "@floating-ui/dom";
import _o from "@uppy/core";
import ks from "@viselect/vanilla";
import xs from "vanilla-lazyload";
import $s from "@uppy/xhr-upload";
const Mn = /* @__PURE__ */ new Map(), bn = /* @__PURE__ */ Symbol("ServiceContainerId");
function Ss(n, e) {
  Mn.set(n, e);
}
function Cs(n) {
  Mn.delete(n);
}
function fe(n) {
  const e = n ?? ht(bn);
  if (!e)
    throw new Error(
      "No VueFinder app instance found. Make sure VueFinder component is mounted and provide the id explicitly or use within a VueFinder component tree."
    );
  const t = Mn.get(e);
  if (!t)
    throw new Error(
      `VueFinder app instance with id "${e}" was not found. Make sure the VueFinder component with id="${e}" is mounted.`
    );
  return t;
}
function An(n) {
  const e = localStorage.getItem(n + "_storage"), t = Gt(JSON.parse(e ?? "{}"));
  me(t, o);
  function o() {
    Object.keys(t).length ? localStorage.setItem(n + "_storage", JSON.stringify(t)) : localStorage.removeItem(n + "_storage");
  }
  function r(u, f) {
    t[u] = f;
  }
  function l(u) {
    delete t[u];
  }
  function d() {
    Object.keys(t).forEach((u) => l(u));
  }
  return { getStore: (u, f = null) => u in t ? t[u] : f, setStore: r, removeStore: l, clearStore: d };
}
function $t(n, e, t) {
  const o = `HTTP ${e}: ${t}`, r = n?.trim();
  if (!r || /^<!doctype html/i.test(r) || /^<html[\s>]/i.test(r))
    return { message: o };
  try {
    const l = JSON.parse(r), d = typeof l.code == "string" && l.code ? l.code : void 0, a = l.params && typeof l.params == "object" && !Array.isArray(l.params) ? l.params : void 0;
    if (d)
      return { message: "", code: d, params: a };
  } catch (l) {
    console.warn("parseBackendErrorPayload: non-JSON body", l);
  }
  return { message: o };
}
function Wp(n, e, t) {
  return $t(n, e, t).message;
}
class St extends Error {
  constructor(e, t, o, r) {
    super(e), this.code = t, this.statusCode = o, this.params = r, this.name = "AdapterError";
  }
  code;
  statusCode;
  params;
}
function Ae(n, e = "An error occurred", t) {
  if (!n)
    return e;
  if (n instanceof St) {
    if (typeof t == "function" && n.code) {
      const o = `errors.${n.code}`, r = n.params && typeof n.params == "object" ? n.params : void 0, l = typeof r?.name == "string" ? r.name : void 0, d = r?.max, a = l != null ? t(o, l) : d != null ? t(o, d) : t(o);
      if (a && a !== o)
        return a;
    }
    return e;
  }
  if (typeof n == "string")
    return n || e;
  if (n instanceof Error)
    return n.message || e;
  if (typeof n == "object" && n !== null) {
    const o = n;
    if (typeof o.message == "string" && o.message)
      return o.message;
    if (typeof o.error == "string" && o.error)
      return o.error;
  }
  return e;
}
function Fs(n, e) {
  return In(n, e, {
    encode: JSON.stringify,
    decode: JSON.parse
  });
}
function Es(n) {
  if (!n?.config?.get)
    return !0;
  try {
    return !!n.config.get("notificationsEnabled");
  } catch {
    return !0;
  }
}
function at(n, e, t) {
  const o = { type: e, message: t };
  if (n?.emitter?.emit?.("vf-notify", o), !!Es(n))
    switch (e) {
      case "success":
        zt.success(t);
        break;
      case "error":
        zt.error(t);
        break;
      case "warning":
        zt.warning(t);
        break;
      default:
        zt.info(t);
        break;
    }
}
function Ne(n) {
  return {
    success(e) {
      at(n, "success", e);
    },
    error(e) {
      at(n, "error", e);
    },
    info(e) {
      at(n, "info", e);
    },
    warning(e) {
      at(n, "warning", e);
    },
    emit(e, t) {
      at(n, e, t);
    }
  };
}
const mn = /* @__PURE__ */ new Map();
async function gn(n, e) {
  const t = e[n];
  return typeof t == "function" ? (await t()).default : t;
}
function On(n, e, t, o, r) {
  const l = Ne({ emitter: t, config: r }), d = "vuefinder_locale", a = "global";
  let u;
  if (mn.has(a))
    u = mn.get(a), e && e !== u.get() && u.set(e);
  else {
    const p = localStorage.getItem(d) ? JSON.parse(localStorage.getItem(d)) : null;
    u = Fs(d, e || p || "en"), mn.set(a, u);
  }
  const f = "vuefinder_translations", g = (p) => {
    try {
      const F = localStorage.getItem(f);
      if (F)
        return JSON.parse(F)[p] || null;
    } catch {
    }
    return null;
  }, h = (p, F) => {
    try {
      const C = localStorage.getItem(f), E = C ? JSON.parse(C) : {};
      E[p] = F, localStorage.setItem(f, JSON.stringify(E));
    } catch {
    }
  }, v = Z(u), x = String(v.value), y = g(x), m = z(y || {});
  let b = !1;
  Object.keys(o).length > 0 && gn(x, o).then((p) => {
    m.value = p, h(x, p);
  }).catch(() => {
  }), me(
    v,
    async (p, F) => {
      if (F && p === F)
        return;
      if (!b) {
        b = !0;
        const E = g(String(p));
        if (E && (m.value = E), Object.keys(o).length > 0)
          try {
            const P = await gn(String(p), o);
            m.value = P, h(String(p), P);
          } catch {
          }
        return;
      }
      const C = g(String(p));
      if (C && (m.value = C), Object.keys(o).length > 0)
        try {
          const E = await gn(String(p), o);
          m.value = E, h(String(p), E);
        } catch (E) {
          const P = Ae(E, "Locale cannot be loaded!");
          l.error(P);
          return;
        }
      Object.values(o).length > 1 && t.emit("vf-language-saved");
    },
    { immediate: !1 }
  );
  const I = (p, ...F) => F.length ? I(p = p.replace("%s", String(F.shift())), ...F) : p;
  function L(p, ...F) {
    return m.value && Object.prototype.hasOwnProperty.call(m.value, p) ? I(m.value[p] || p, ...F) : I(p, ...F);
  }
  const S = B({
    get: () => v.value,
    set: (p) => {
      u.set(p);
    }
  });
  return Gt({ t: L, locale: S, localeAtom: u });
}
const Ds = [
  "edit",
  "newfile",
  "newfolder",
  "archive",
  "unarchive",
  "search",
  "filter",
  "rename",
  "upload",
  "delete",
  "fullscreen",
  "viewToggle",
  "download",
  "language",
  "move",
  "copy",
  "history",
  "theme",
  "pinned"
], ho = {
  simple: {
    search: !0,
    filter: !0,
    rename: !0,
    upload: !0,
    delete: !0,
    newfile: !0,
    newfolder: !0,
    download: !0
  },
  advanced: Ds.reduce((n, e) => (n[e] = !0, n), {})
};
function Wn() {
  return ho.advanced;
}
function po(n) {
  return n ? n === "simple" || n === "advanced" ? { ...ho[n] } : { ...Wn(), ...n } : Wn();
}
const Ps = "4.1.2";
function mo(n) {
  return typeof n == "number" && Number.isFinite(n) && n >= 0 ? n : null;
}
function Yt(n, e, t, o, r) {
  const l = mo(n);
  return l === null ? "" : (e = Math, t = e.log, o = 1024, r = t(l) / t(o) | 0, (l / e.pow(o, r)).toFixed(0) + " " + (r ? "KMGTPEZY"[--r] + "iB" : "B"));
}
function go(n, e, t, o, r) {
  const l = mo(n);
  return l === null ? "" : (e = Math, t = e.log, o = 1e3, r = t(l) / t(o) | 0, (l / e.pow(o, r)).toFixed(0) + " " + (r ? "KMGTPEZY"[--r] + "B" : "B"));
}
function Is(n) {
  if (typeof n == "number") return n;
  const e = { k: 1, m: 2, g: 3, t: 4 }, o = /(\d+(?:\.\d+)?)\s?(k|m|g|t)?b?/i.exec(n);
  if (!o) return 0;
  const r = parseFloat(o[1] || "0"), l = (o[2] || "").toLowerCase(), d = e[l] ?? 0;
  return Math.round(r * Math.pow(1024, d));
}
function Ts(n) {
  const e = co(null), t = z(!1), o = z(), r = z(!1);
  return { visible: t, type: e, data: o, open: (u, f = null) => {
    n.get("fullScreen") || (document.querySelector("body").style.overflow = "hidden"), t.value = !0, e.value = u, o.value = f;
  }, close: () => {
    n.get("fullScreen") || (document.querySelector("body").style.overflow = ""), t.value = !1, e.value = null;
  }, setEditMode: (u) => {
    r.value = u;
  }, editMode: r };
}
const Nt = {
  view: "grid",
  theme: "silver",
  fullScreen: !1,
  showTreeView: !1,
  showHiddenFiles: !0,
  metricUnits: !1,
  showThumbnails: !0,
  persist: !1,
  path: "",
  pinnedFolders: [],
  favoriteItems: [],
  favoritePanelWidth: 180,
  notificationsEnabled: !0,
  expandTreeByDefault: !1,
  expandedTreePaths: [],
  trashMineOnly: !0
}, Ut = {
  initialPath: null,
  maxFileSize: null,
  loadingIndicator: "circular",
  showMenuBar: !0,
  showToolbar: !0,
  showStatusBar: !0,
  windowsExplorer: !1,
  gridItemWidth: 96,
  gridItemHeight: 96,
  gridItemGap: 8,
  gridIconSize: 48,
  listItemHeight: 32,
  listItemGap: 2,
  listIconSize: 16,
  notificationPosition: "bottom-center",
  notificationDuration: 3e3,
  notificationVisibleToasts: 4,
  notificationRichColors: !0,
  accessSubjects: [],
  storageLabels: {}
}, Ms = new Set(
  Object.keys(Ut)
);
function As(n) {
  return n || "silver";
}
function wo(n) {
  return Ms.has(n);
}
function Yn(n) {
  const e = {}, t = {}, o = n;
  for (const r in o)
    if (wo(r))
      t[r] = o[r];
    else if (r in Nt) {
      const l = r;
      e[l] = o[r];
    }
  return { persistenceConfig: e, nonPersistenceConfig: t };
}
function Qn(n, e) {
  const t = { ...Nt, ...e, ...n };
  return t.theme = As(t.theme), t;
}
function Xn(n, e) {
  return { ...Ut, ...e, ...n };
}
const Os = (n, e = {}) => {
  const t = `vuefinder_config_${n}`, { persistenceConfig: o, nonPersistenceConfig: r } = Yn(e), l = Qn(
    o,
    Nt
  ), d = Xn(
    r,
    Ut
  ), a = In(
    t,
    l,
    {
      encode: JSON.stringify,
      decode: JSON.parse
    }
  ), u = Pe(d), f = Ze(
    [a, u],
    (b, I) => ({
      ...b,
      ...I
    })
  ), g = (b = {}) => {
    const I = a.get(), L = u.get(), { persistenceConfig: S, nonPersistenceConfig: p } = Yn(b), F = Qn(S, I), C = Xn(
      p,
      L
    );
    a.set(F), u.set(C);
  }, h = (b) => wo(b) ? u.get()[b] : a.get()[b], v = () => ({
    ...a.get(),
    ...u.get()
  }), x = (b, I) => {
    const L = a.get();
    typeof b == "object" && b !== null ? a.set({ ...L, ...b }) : a.set({
      ...L,
      [b]: I
    });
  };
  return {
    // Store atom (combined)
    state: f,
    // Methods
    init: g,
    get: h,
    set: x,
    toggle: (b) => {
      const I = a.get();
      x(b, !I[b]);
    },
    all: v,
    reset: () => {
      a.set({ ...Nt }), u.set({ ...Ut });
    }
  };
}, zs = {
  "application/pdf": "PDF",
  "application/msword": "Word",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
  "application/vnd.ms-excel": "Excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
  "application/zip": "ZIP archive",
  "text/plain": "Text document"
};
function Rs(n) {
  return n.type === "dir" ? "folder" : (n.extension || n.mime_type || "file").toLowerCase();
}
function kn(n, e) {
  if (n.type === "dir")
    return e ? e("File folder") : "File folder";
  const t = n.mime_type ? zs[n.mime_type] : void 0;
  return t || (n.extension ? `${n.extension.toUpperCase()} ${e ? e("File") : "File"}` : e ? e("File") : "File");
}
function xn(n) {
  if (!n)
    return "";
  const e = n > 1e11 ? n : n * 1e3;
  return new Date(e).toLocaleString();
}
function Ls(n, e) {
  if (typeof n == "string" && typeof e == "string")
    return n.toLowerCase().localeCompare(e.toLowerCase());
  const t = Number(n) || 0, o = Number(e) || 0;
  return t === o ? 0 : t < o ? -1 : 1;
}
function Jn(n, e) {
  return e === "type" ? Rs(n) : n[e];
}
function Zn(n) {
  return n.is_trash_root ? 0 : n.is_storage_mount ? 1 : 2;
}
function yo(n, e) {
  return Zn(n) - Zn(e);
}
function bo(n, e) {
  return n && e === "asc" ? "desc" : "asc";
}
function Ht(n, e, t) {
  const o = t === "asc" ? 1 : -1;
  return n.slice().sort(
    (r, l) => yo(r, l) || Ls(Jn(r, e), Jn(l, e)) * o
  );
}
function J(n) {
  return String(n.id);
}
function _t(n) {
  return { id: n.id, type: n.type };
}
function ko(n) {
  const e = n.indexOf("://");
  return e < 0 ? ["", n] : [n.slice(0, e), n.slice(e + 3)];
}
function xo(n, e = {}, t = 0) {
  const o = (n ?? "").trim(), [r, l] = ko(o), d = r ? e[r] : void 0, a = !!d?.read_only;
  let u = "";
  const f = l.split("/").filter(Boolean).map((v) => {
    u = u ? `${u}/${v}` : v;
    const x = {
      basename: v,
      name: v,
      path: r ? `${r}://${u}` : u,
      type: "dir"
    };
    return a && (x.read_only = !0), x;
  });
  if (!d || t > 4)
    return { storage: r, breadcrumb: f, path: o };
  const g = xo(d.parent, e, t + 1), h = {
    basename: d.label,
    name: d.label,
    path: `${r}://`,
    type: "dir"
  };
  return a && (h.read_only = !0), {
    storage: g.storage,
    mountedStorage: r,
    breadcrumb: [...g.breadcrumb, h, ...f],
    path: o
  };
}
function Vs(n, e) {
  const [t] = ko(String(n || ""));
  return !!(t && e[t]?.read_only);
}
function Bs(n, e) {
  return (n ?? []).filter((t) => !e[t]);
}
const Ns = () => {
  const n = Pe(""), e = Pe([]), t = Pe({}), o = Pe([]), r = Pe(null), l = Pe("modified"), d = Pe(!1), a = Pe([]), u = Pe([]), f = Pe({ active: !0, column: "basename", order: "asc" }), g = Pe({
    kind: "all",
    showHidden: !1
  }), h = Pe(/* @__PURE__ */ new Set()), v = Pe({
    type: "copy",
    path: "",
    items: /* @__PURE__ */ new Set()
  }), x = Pe(null), y = Pe(0), m = Pe(!1), b = Pe([]), I = Pe(-1), L = Ze(
    [n, t],
    (G, oe) => xo(G ?? "", oe)
  ), S = Ze(
    [e, t],
    (G, oe) => Bs(G, oe)
  ), p = Ze([a, f, g], (G, oe, de) => {
    let ve = G;
    de.kind === "files" ? ve = ve.filter((Je) => Je.type === "file") : de.kind === "folders" && (ve = ve.filter((Je) => Je.type === "dir")), de.showHidden || (ve = ve.filter((Je) => !Je.basename.startsWith(".")));
    const Ke = ve.filter((Je) => Je.type === "dir"), Me = ve.filter((Je) => Je.type === "file"), { active: Xe, column: _n, order: hn } = oe;
    return !Xe || !_n || !hn ? [...Ke.sort(yo), ...Me] : [
      ...Ht(Ke, _n, hn),
      ...Ht(
        Me,
        _n,
        hn
      )
    ];
  }), F = Ze(
    [a, h, u],
    (G, oe, de) => {
      if (oe.size === 0) return [];
      const ve = /* @__PURE__ */ new Map();
      for (const Me of G)
        ve.set(J(Me), Me);
      for (const Me of de) {
        const Xe = J(Me);
        ve.has(Xe) || ve.set(Xe, Me);
      }
      const Ke = [];
      for (const Me of oe) {
        const Xe = ve.get(Me);
        Xe && Ke.push(Xe);
      }
      return Ke;
    }
  ), C = (G) => {
    u.set(Array.isArray(G) ? G : []);
  }, E = (G, oe) => {
    const de = n.get();
    if ((oe ?? !0) && de !== G) {
      const ve = b.get(), Ke = I.get();
      Ke < ve.length - 1 && ve.splice(Ke + 1), ve.length === 0 && de && ve.push(de), ve.push(G), b.set([...ve]), I.set(ve.length - 1);
    }
    n.set(G);
  }, P = (G) => {
    a.set(G ?? []);
  }, N = (G) => {
    e.set(G ?? []);
  }, te = (G) => {
    !G || Object.keys(G).length === 0 || t.set({ ...t.get(), ...G });
  }, W = (G) => {
    o.set(G ?? []);
  }, se = (G) => o.get().includes(G), $ = (G) => {
    r.set(G ?? null);
  }, k = (G) => {
    l.set(G === "uploaded" ? "uploaded" : "modified");
  }, T = (G, oe) => {
    f.set({ active: !0, column: G, order: oe });
  }, M = (G) => {
    const oe = f.get(), de = oe.active && oe.column === G;
    f.set({
      active: !0,
      column: G,
      order: bo(de, oe.order || "asc")
    });
  }, q = () => {
    f.set({ active: !1, column: "", order: "" });
  }, pe = (G, oe) => {
    g.set({ kind: G, showHidden: oe });
  }, R = () => {
    g.set({ kind: "all", showHidden: !1 });
  }, D = (G, oe = "multiple") => {
    const de = new Set(h.get());
    oe === "single" && de.clear(), de.add(G), h.set(de);
  }, A = (G, oe = "multiple") => {
    const de = new Set(h.get());
    oe === "single" && de.clear(), G.forEach((ve) => de.add(ve)), h.set(de);
  }, H = (G) => {
    const oe = new Set(h.get());
    oe.delete(G), h.set(oe);
  }, U = (G) => h.get().has(G), O = (G, oe = "multiple") => {
    const de = new Set(h.get());
    de.has(G) ? de.delete(G) : (oe === "single" && de.clear(), de.add(G)), h.set(de);
  }, X = (G = "multiple", oe) => {
    if (G === "single") {
      const de = a.get()[0];
      if (de) {
        const ve = J(de);
        h.set(/* @__PURE__ */ new Set([ve])), y.set(1);
      }
    } else {
      if (oe?.selectionFilterType || oe?.selectionFilterMimeIncludes && oe.selectionFilterMimeIncludes.length > 0) {
        const de = a.get().filter((ve) => {
          const Ke = oe.selectionFilterType, Me = oe.selectionFilterMimeIncludes;
          return Ke === "files" && ve.type === "dir" || Ke === "dirs" && ve.type === "file" ? !1 : Me && Array.isArray(Me) && Me.length > 0 && ve.type !== "dir" ? ve.mime_type ? Me.some((Xe) => ve.mime_type?.startsWith(Xe)) : !1 : !0;
        }).map((ve) => J(ve));
        h.set(new Set(de));
      } else {
        const de = new Set(a.get().map((ve) => J(ve)));
        h.set(de);
      }
      _e(h.get().size);
    }
  }, ne = () => {
    h.set(/* @__PURE__ */ new Set()), y.set(0);
  }, ue = (G) => {
    const oe = new Set(G ?? []);
    h.set(oe), y.set(oe.size);
  }, _e = (G) => {
    y.set(G);
  }, K = (G) => {
    m.set(!!G);
  }, ee = () => m.get(), Q = (G, oe) => {
    const de = a.get().filter((ve) => oe.has(J(ve)));
    v.set({
      type: G,
      path: L.get().path,
      items: new Set(de)
    });
  }, ce = (G, oe) => {
    v.set({
      type: G,
      path: L.get().path,
      items: new Set(oe)
    });
  }, Se = (G) => Ze([v], (oe) => oe.type === "cut" && Array.from(oe.items).some((de) => J(de) === G)), Qe = (G) => Ze([v], (oe) => oe.type === "copy" && Array.from(oe.items).some((de) => J(de) === G)), He = (G) => {
    const oe = Se(G);
    return Z(oe).value ?? !1;
  }, tt = (G) => {
    const oe = Qe(G);
    return Z(oe).value ?? !1;
  }, ie = () => {
    v.set({ type: "copy", path: "", items: /* @__PURE__ */ new Set() });
  }, be = () => v.get(), we = (G) => {
    x.set(G);
  }, Ie = () => x.get(), it = () => {
    x.set(null);
  }, dn = () => {
    const G = b.get(), oe = I.get();
    if (oe > 0) {
      const de = oe - 1, ve = G[de];
      ve && (I.set(de), E(ve, !1));
    }
  }, cn = () => {
    const G = b.get(), oe = I.get();
    if (oe < G.length - 1) {
      const de = oe + 1, ve = G[de];
      ve && (I.set(de), E(ve, !1));
    }
  }, un = Ze([I], (G) => G > 0), fn = Ze(
    [b, I],
    (G, oe) => oe < G.length - 1
  ), vn = (G) => {
    d.set(G);
  }, Ot = () => d.get(), ct = (G) => Vs(G, t.get());
  return {
    // Atoms (state)
    files: a,
    storages: e,
    rootStorages: S,
    mounts: t,
    disabledFeatures: o,
    notice: r,
    dateColumn: l,
    currentPath: n,
    sort: f,
    filter: g,
    selectedKeys: h,
    selectedCount: y,
    loading: m,
    draggedItem: x,
    clipboardItems: v,
    // Computed values
    path: L,
    sortedFiles: p,
    selectedItems: F,
    // Actions
    setPath: E,
    setFiles: P,
    setStorages: N,
    setMounts: te,
    setDisabledFeatures: W,
    isFeatureDisabled: se,
    setNotice: $,
    setDateColumn: k,
    setSort: T,
    toggleSort: M,
    clearSort: q,
    setFilter: pe,
    clearFilter: R,
    setSelectionPool: C,
    select: D,
    selectMultiple: A,
    deselect: H,
    toggleSelect: O,
    selectAll: X,
    isSelected: U,
    clearSelection: ne,
    setSelection: ue,
    setSelectedCount: _e,
    setLoading: K,
    isLoading: ee,
    setClipboard: Q,
    setClipboardItems: ce,
    createIsCut: Se,
    createIsCopied: Qe,
    isCut: He,
    isCopied: tt,
    clearClipboard: ie,
    getClipboard: be,
    setDraggedItem: we,
    getDraggedItem: Ie,
    clearDraggedItem: it,
    setReadOnly: vn,
    getReadOnly: Ot,
    isReadOnly: (G) => d.get() ? !0 : (G.read_only ?? !1) || ct(G.path),
    isReadOnlyPath: ct,
    // Navigation
    goBack: dn,
    goForward: cn,
    canGoBack: un,
    canGoForward: fn,
    navigationHistory: b,
    historyIndex: I
  };
};
class zn {
  /**
   * Validate that required parameters are provided
   */
  validateParam(e, t) {
    if (e == null)
      throw new Error(`${t} is required`);
  }
  /**
   * Validate that a file path is provided
   */
  validatePath(e) {
    if (!e)
      throw new Error("Path must be a non-empty string");
  }
  /**
   * Extract storage and path from a combined path string
   * Format: "storage://path" or just "path"
   */
  parsePath(e) {
    if (!e)
      return {};
    if (e.includes("://")) {
      const [t, ...o] = e.split("://");
      return { storage: t, path: o.join("://") };
    }
    return { path: e };
  }
  /**
   * Combine storage and path into a single path string
   */
  combinePath(e, t) {
    return e && t ? `${e}://${t}` : t || "";
  }
  /**
   * Checks a local adapter through its listing. Remote adapters may override this
   * to delegate access checks and conflict detection to their backend.
   */
  async checkUploadConflicts(e) {
    this.validatePath(e.path);
    const t = await this.list({ path: e.path }), o = new Set(
      (t.files ?? []).filter((r) => r.type === "file").map((r) => r.basename || r.name)
    );
    return { conflicts: e.names.filter((r) => o.has(r)) };
  }
  /**
   * Download a file
   */
  async download(e) {
    const t = this.getDownloadUrl(e);
    if (!t)
      throw new Error("Download URL is not available");
    const o = await fetch(t);
    if (!o.ok)
      throw new Error(`HTTP ${o.status}: ${o.statusText}`);
    return {
      blob: await o.blob(),
      mimeType: o.headers.get("Content-Type") || void 0
    };
  }
}
class Us extends zn {
  filesSource;
  defaultStorage;
  storages;
  storagesSet;
  readOnly;
  contentStore;
  constructor(e) {
    super(), this.filesSource = e.files;
    const t = e.storages && e.storages.length > 0 ? e.storages : [e.storage || "memory"];
    this.storages = [...new Set(t)], this.defaultStorage = e.storage || this.storages[0] || "memory", this.storages.includes(this.defaultStorage) || this.storages.unshift(this.defaultStorage), this.storagesSet = new Set(this.storages), this.readOnly = !!e.readOnly, this.contentStore = e.contentStore || /* @__PURE__ */ new Map();
  }
  get files() {
    return Array.isArray(this.filesSource) ? this.filesSource : this.filesSource.value;
  }
  set files(e) {
    Array.isArray(this.filesSource) ? (this.filesSource.length = 0, this.filesSource.push(...e)) : this.filesSource.value = e;
  }
  ensureWritable() {
    if (this.readOnly)
      throw new Error("Driver is read-only");
  }
  ensureStorageSupported(e) {
    if (!this.storagesSet.has(e))
      throw new Error(`Unsupported storage: ${e}`);
  }
  combine(e, t = this.defaultStorage) {
    this.ensureStorageSupported(t);
    const o = e ?? "";
    return o === "" ? `${t}://` : `${t}://${o}`;
  }
  split(e) {
    return this.parsePath(e);
  }
  normalizePath(e, t = this.defaultStorage) {
    const { storage: o, path: r } = this.split(e || ""), l = o || t;
    return this.combine(r ?? "", l);
  }
  parent(e) {
    const { storage: t, path: o } = this.split(e), r = t || this.defaultStorage;
    if (!o) return this.combine("", r);
    const l = o.replace(/\/+$/g, "").replace(/^\/+/, ""), d = l.lastIndexOf("/");
    return d <= 0 ? this.combine("", r) : this.combine(l.slice(0, d), r);
  }
  join(e, t) {
    const { storage: o, path: r } = this.split(e), l = o || this.defaultStorage, d = (r ?? "").replace(/\/$/, ""), a = d ? `${d}/${t}` : t;
    return this.combine(a, l);
  }
  getExtension(e) {
    const t = e.lastIndexOf(".");
    return t > 0 ? e.slice(t + 1) : "";
  }
  cloneEntry(e, t = {}) {
    return { ...e, ...t };
  }
  findByPath(e) {
    return this.files.find((t) => t.path === e);
  }
  listChildren(e) {
    return this.files.filter((t) => t.dir === e).map((t) => this.withId(t));
  }
  /** Путь локальной записи уникален — он же id (ключ выделения во vue-finder). */
  withId(e) {
    return { ...e, id: e.path };
  }
  replaceAll(e) {
    this.files = e;
  }
  upsert(e) {
    const t = this.files.slice(), o = t.findIndex((r) => r.path === e.path);
    o === -1 ? t.push(e) : t[o] = e, this.replaceAll(t);
  }
  removeExact(e) {
    const t = this.files.filter((o) => o.path !== e);
    this.replaceAll(t);
  }
  removeTree(e) {
    const t = [], o = [];
    for (const r of this.files)
      this.isInTree(r.path, e) ? t.push(r) : o.push(r);
    this.replaceAll(o);
    for (const r of t)
      this.contentStore.delete(r.path);
    return t;
  }
  isInTree(e, t) {
    return e === t || e.startsWith(`${t}/`);
  }
  getTree(e, t = this.files) {
    return t.filter((o) => this.isInTree(o.path, e)).sort((o, r) => o.path.length - r.path.length);
  }
  uniqueName(e, t, o) {
    if (!o.has(this.join(e, t))) return t;
    const r = t.lastIndexOf("."), l = r > 0 ? t.slice(0, r) : t, d = r > 0 ? t.slice(r) : "";
    let a = 1;
    for (; ; ) {
      const u = `${l} copy ${a}${d}`, f = this.join(e, u);
      if (!o.has(f)) return u;
      a++;
    }
  }
  topLevelSources(e, t = this.defaultStorage) {
    const o = [...new Set(e)].map((l) => this.normalizePath(l, t)).filter((l) => this.findByPath(l)).sort((l, d) => l.length - d.length), r = [];
    for (const l of o)
      r.some((d) => this.isInTree(l, d)) || r.push(l);
    return r;
  }
  makeDirEntry(e, t) {
    const o = this.join(e, t), { storage: r } = this.split(o);
    return {
      storage: r || this.defaultStorage,
      dir: e,
      id: o,
      basename: t,
      extension: "",
      path: o,
      type: "dir",
      file_size: null,
      last_modified: Date.now(),
      mime_type: null,
      visibility: "public"
    };
  }
  makeFileEntry(e, t, o = 0, r = null) {
    const l = this.join(e, t), { storage: d } = this.split(l);
    return {
      storage: d || this.defaultStorage,
      dir: e,
      id: l,
      basename: t,
      extension: this.getExtension(t),
      path: l,
      type: "file",
      file_size: o,
      last_modified: Date.now(),
      mime_type: r,
      visibility: "public"
    };
  }
  resultForDir(e) {
    return {
      files: this.listChildren(e),
      storages: this.storages,
      read_only: this.readOnly,
      dirname: e
    };
  }
  async list(e) {
    const t = this.normalizePath(e?.path);
    return {
      storages: this.storages,
      dirname: t,
      files: this.listChildren(t),
      read_only: this.readOnly
    };
  }
  async delete(e) {
    this.ensureWritable(), this.validateParam(e.items, "items"), this.validateParam(e.path, "path");
    const t = this.normalizePath(e.path), { storage: o } = this.split(t), r = [];
    for (const d of e.items) {
      const a = this.normalizePath(String(d.id), o || this.defaultStorage), u = this.findByPath(a);
      u && (u.type === "dir" ? r.push(...this.removeTree(u.path)) : (this.removeExact(u.path), this.contentStore.delete(u.path), r.push(u)));
    }
    return { ...this.resultForDir(t), deleted: r };
  }
  async rename(e) {
    this.ensureWritable(), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), { storage: o } = this.split(t), r = this.normalizePath(
      e.item || e.path,
      o || this.defaultStorage
    ), l = this.findByPath(r);
    if (!l) throw new Error("Item not found");
    const d = l.dir, a = this.join(d, e.name);
    if (a !== l.path && this.findByPath(a))
      throw new Error("Target already exists");
    if (l.type === "dir") {
      const f = l.path, g = a, h = this.files.map((v) => {
        if (v.storage !== l.storage || !this.isInTree(v.path, f)) return v;
        const x = g + v.path.slice(f.length);
        return this.cloneEntry(v, {
          path: x,
          dir: this.parent(x),
          basename: v.path === f ? e.name : v.basename,
          last_modified: Date.now()
        });
      });
      for (const [v, x] of Array.from(this.contentStore.entries()))
        this.isInTree(v, f) && (this.contentStore.delete(v), this.contentStore.set(g + v.slice(f.length), x));
      this.replaceAll(h);
    } else {
      const f = this.cloneEntry(l, {
        path: a,
        basename: e.name,
        extension: this.getExtension(e.name),
        last_modified: Date.now()
      });
      this.upsert(f), this.removeExact(l.path);
      const g = this.contentStore.get(l.path);
      g !== void 0 && (this.contentStore.delete(l.path), this.contentStore.set(f.path, g));
    }
    const u = e.path ? this.normalizePath(e.path, l.storage || this.defaultStorage) : d;
    return this.resultForDir(u || d);
  }
  async copy(e) {
    this.ensureWritable(), this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination");
    const t = this.normalizePath(
      e.destination,
      e.path ? this.split(this.normalizePath(e.path)).storage || this.defaultStorage : this.defaultStorage
    ), { storage: o } = this.split(t), r = this.topLevelSources(
      e.sources.map((a) => String(a.id)),
      o || this.defaultStorage
    ), l = new Set(this.files.map((a) => a.path)), d = [];
    for (const a of r) {
      const u = this.findByPath(a);
      if (!u) continue;
      if (u.type === "file") {
        const v = this.uniqueName(t, u.basename, l), x = this.makeFileEntry(
          t,
          v,
          u.file_size || 0,
          u.mime_type
        );
        d.push(x), l.add(x.path);
        const y = this.contentStore.get(u.path);
        y !== void 0 && this.contentStore.set(x.path, y);
        continue;
      }
      const f = this.getTree(u.path), g = this.uniqueName(t, u.basename, l), h = /* @__PURE__ */ new Map();
      h.set(u.path, this.join(t, g));
      for (const v of f) {
        const x = v.path === u.path ? h.get(u.path) : this.join(h.get(v.dir), v.basename);
        h.set(v.path, x);
        const y = v.path === u.path ? t : h.get(v.dir), m = v.path === u.path ? g : v.basename, b = this.cloneEntry(v, {
          path: x,
          dir: y,
          basename: m,
          extension: v.type === "file" ? this.getExtension(m) : "",
          last_modified: Date.now()
        });
        if (d.push(b), l.add(b.path), v.type === "file") {
          const I = this.contentStore.get(v.path);
          I !== void 0 && this.contentStore.set(b.path, I);
        }
      }
    }
    return this.replaceAll(this.files.concat(d)), this.resultForDir(t);
  }
  async move(e) {
    this.ensureWritable(), this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination");
    const t = this.normalizePath(
      e.destination,
      e.path ? this.split(this.normalizePath(e.path)).storage || this.defaultStorage : this.defaultStorage
    ), { storage: o } = this.split(t), r = this.topLevelSources(
      e.sources.map((d) => String(d.id)),
      o || this.defaultStorage
    );
    let l = this.files.slice();
    for (const d of r) {
      const a = l.find((y) => y.path === d);
      if (!a) continue;
      if (a.type === "dir" && this.isInTree(t, a.path))
        throw new Error("Cannot move directory into itself");
      if (a.dir === t)
        continue;
      const u = this.getTree(a.path, l), f = new Set(u.map((y) => y.path)), g = new Set(l.filter((y) => !f.has(y.path)).map((y) => y.path)), h = this.uniqueName(t, a.basename, g), v = /* @__PURE__ */ new Map();
      v.set(a.path, this.join(t, h));
      const x = /* @__PURE__ */ new Map();
      for (const y of u) {
        const m = y.path === a.path ? v.get(a.path) : this.join(v.get(y.dir), y.basename);
        v.set(y.path, m);
        const b = y.path === a.path ? t : v.get(y.dir), I = y.path === a.path ? h : y.basename;
        x.set(
          y.path,
          this.cloneEntry(y, {
            path: m,
            dir: b,
            basename: I,
            extension: y.type === "file" ? this.getExtension(I) : "",
            last_modified: Date.now()
          })
        );
      }
      l = l.map((y) => x.get(y.path) || y);
      for (const [y, m] of v.entries()) {
        if (y === m) continue;
        const b = this.contentStore.get(y);
        b !== void 0 && (this.contentStore.delete(y), this.contentStore.set(m, b));
      }
    }
    return this.replaceAll(l), this.resultForDir(t);
  }
  async archive(e) {
    this.ensureWritable(), this.validateParam(e.path, "path"), this.validateParam(e.items, "items"), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), o = e.name.endsWith(".zip") ? e.name : `${e.name}.zip`, r = this.makeFileEntry(t, o, 0, "application/zip");
    return this.upsert(r), this.resultForDir(t);
  }
  async unarchive(e) {
    this.ensureWritable(), this.validateParam(e.item, "item"), this.validateParam(e.path, "path");
    const t = this.normalizePath(e.item), o = this.normalizePath(e.path), r = this.findByPath(t);
    if (!r) throw new Error("Archive not found");
    const l = r.basename.replace(/\.zip$/i, ""), d = this.makeDirEntry(o, l);
    return this.upsert(d), this.resultForDir(o);
  }
  async createFile(e) {
    this.ensureWritable(), this.validateParam(e.path, "path"), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), o = this.makeFileEntry(t, e.name, 0, null);
    return this.upsert(o), this.contentStore.set(o.path, ""), this.resultForDir(t);
  }
  async createFolder(e) {
    this.ensureWritable(), this.validateParam(e.path, "path"), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), o = this.makeDirEntry(t, e.name);
    return this.upsert(o), this.resultForDir(t);
  }
  getPreviewUrl(e) {
    return "";
  }
  async getContent(e) {
    this.validatePath(e.path);
    const t = this.normalizePath(e.path), o = this.contentStore.get(t);
    if (typeof o == "string" || o === void 0)
      return {
        content: o ?? "",
        mimeType: this.findByPath(t)?.mime_type || void 0
      };
    const r = new Uint8Array(o);
    let l = "";
    for (let d = 0; d < r.length; d++) l += String.fromCharCode(r[d]);
    return {
      content: btoa(l),
      mimeType: this.findByPath(t)?.mime_type || void 0
    };
  }
  getDownloadUrl(e) {
    return "";
  }
  async download(e) {
    this.validatePath(e.path);
    const t = this.normalizePath(e.path), o = this.findByPath(t), r = this.contentStore.get(t), l = o?.mime_type || void 0;
    return {
      blob: new Blob([r ?? ""], { type: l }),
      filename: o?.basename,
      mimeType: l
    };
  }
  async search(e) {
    const t = (e.filter || "").toLowerCase(), o = e.path ? this.normalizePath(e.path) : void 0;
    return this.files.filter((r) => {
      if (o) {
        if (e.deep) {
          if (!this.isInTree(r.path, o)) return !1;
        } else if (r.dir !== o)
          return !1;
      }
      return r.basename.toLowerCase().includes(t) || r.path.toLowerCase().includes(t);
    }).map((r) => this.withId(r));
  }
  async save(e) {
    this.ensureWritable(), this.validateParam(e.path, "path");
    const t = this.normalizePath(e.path), o = this.findByPath(t);
    if (!o) throw new Error("File not found");
    if (o.type !== "file") throw new Error("Can only save file content");
    return this.contentStore.set(t, e.content), this.upsert(
      this.cloneEntry(o, { file_size: e.content.length, last_modified: Date.now() })
    ), t;
  }
  configureUploader(e, t) {
    e && e.on("upload-success", async (o) => {
      try {
        this.ensureWritable();
        const r = this.normalizePath(t.getTargetPath()), l = o?.name || "file", d = o?.type || null, a = o?.data, u = o?.size || 0, f = this.makeFileEntry(r, l, u, d);
        if (this.upsert(f), a)
          try {
            const g = await a.arrayBuffer();
            this.contentStore.set(f.path, g);
          } catch {
            this.contentStore.set(f.path, "");
          }
        else
          this.contentStore.set(f.path, "");
      } catch {
      }
    });
  }
}
function ut(n, e) {
  return e ? `${n}${n.includes("?") ? "&" : "?"}${e}` : n;
}
function Rt(n) {
  return new URLSearchParams({ id: String(n.id) });
}
function Hs(n) {
  if (!n) return;
  const e = n.match(/filename\*=([^;]+)/i);
  if (e?.[1]) {
    const r = e[1].trim().replace(/^UTF-8''/i, "").replace(/^"|"$/g, "");
    try {
      return decodeURIComponent(r);
    } catch {
      return r;
    }
  }
  const t = n.match(/filename="([^"]+)"/i);
  return t?.[1] ? t[1] : n.match(/filename=([^;]+)/i)?.[1]?.trim().replace(/^"|"$/g, "");
}
class $o extends zn {
  config;
  /**
   * Default URL endpoints
   */
  static DEFAULT_URLS = {
    list: "",
    upload: "/upload",
    checkUploadConflicts: "/upload/conflicts",
    delete: "/delete",
    rename: "/rename",
    copy: "/copy",
    move: "/move",
    archive: "/archive",
    unarchive: "/unarchive",
    createFile: "/create-file",
    createFolder: "/create-folder",
    preview: "/preview",
    // Finder: файлы по Structure.id (в т.ч. корзина). Общий `/download` ждёт UUID Uploads.
    download: "finder/download",
    search: "/search",
    save: "/save",
    access: "/access"
  };
  constructor(e) {
    super();
    const t = {
      ...$o.DEFAULT_URLS,
      ...e.url || {}
    };
    this.config = {
      ...e,
      baseURL: e.baseURL || "",
      url: t
    };
  }
  /**
   * Set or update the base URL for API requests
   */
  setBaseURL(e) {
    this.config.baseURL = e || "";
  }
  /**
   * Set or update the authentication token
   * Pass undefined to remove the token
   */
  setToken(e) {
    this.config.token = e;
  }
  configureUploader(e, t) {
    const o = this.getHeaders();
    delete o["Content-Type"], e.use($s, {
      endpoint: `${this.config.baseURL}${this.config.url.upload}`,
      fieldName: "file",
      bundle: !1,
      headers: o,
      formData: !0,
      onAfterResponse: (r) => {
        if (r.status < 200 || r.status >= 300) {
          const l = $t(r.responseText, r.status, r.statusText);
          throw new St(l.message, l.code, r.status, l.params);
        }
      }
    }), e.on("upload", () => {
      const r = t.getTargetPath();
      e.getFiles().forEach((d) => {
        e.setFileMeta(d.id, {
          path: r,
          conflict: t.getConflictAction?.() ?? "error"
        });
      });
    });
  }
  getHeaders() {
    const e = {
      "Content-Type": "application/json",
      ...this.config.headers
    };
    return this.config.token && (e.Authorization = `Bearer ${this.config.token}`), e;
  }
  async request(e, t = {}) {
    const o = `${this.config.baseURL}${e}`, r = await fetch(o, {
      ...t,
      headers: {
        ...this.getHeaders(),
        ...t.headers
      }
    });
    if (!r.ok) {
      const d = await r.text(), a = $t(d, r.status, r.statusText);
      throw new St(a.message, a.code, r.status, a.params);
    }
    return (r.headers.get("content-type") || "").includes("application/json") ? await r.json() : await r.text();
  }
  async list(e) {
    const t = new URLSearchParams();
    e?.path && t.append("path", e.path), e?.trashMineOnly !== void 0 && t.append("trash_mine", e.trashMineOnly ? "1" : "0");
    const o = ut(this.config.url.list, t.toString());
    return await this.request(o, { method: "GET" });
  }
  async checkUploadConflicts(e) {
    return this.validatePath(e.path), await this.request(this.config.url.checkUploadConflicts, {
      method: "POST",
      body: JSON.stringify(e)
    });
  }
  async delete(e) {
    return this.validateParam(e.items, "items"), this.validateParam(e.path, "path"), await this.request(this.config.url.delete, {
      method: "POST",
      body: JSON.stringify({
        path: e.path,
        items: e.items,
        ...e.passwords ? { passwords: e.passwords } : {}
      })
    });
  }
  async rename(e) {
    return this.validateParam(e.path, "path"), this.validateParam(e.item, "item"), this.validateParam(e.name, "name"), this.validatePath(e.path), await this.request(this.config.url.rename, {
      method: "POST",
      body: JSON.stringify({
        path: e.path,
        item: e.item,
        id: e.id,
        name: e.name
      })
    });
  }
  async copy(e) {
    return this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination"), e.path && this.validatePath(e.path), await this.request(this.config.url.copy, {
      method: "POST",
      body: JSON.stringify({
        sources: e.sources,
        destination: e.destination,
        path: e.path
      })
    });
  }
  async move(e) {
    return this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination"), e.path && this.validatePath(e.path), await this.request(this.config.url.move, {
      method: "POST",
      body: JSON.stringify({
        sources: e.sources,
        destination: e.destination,
        path: e.path
      })
    });
  }
  async archive(e) {
    return this.validateParam(e.items, "items"), this.validateParam(e.name, "name"), this.validateParam(e.path, "path"), await this.request(this.config.url.archive, {
      method: "POST",
      body: JSON.stringify({ items: e.items, path: e.path, name: e.name })
    });
  }
  async unarchive(e) {
    return this.validateParam(e.item, "item"), this.validateParam(e.path, "path"), await this.request(this.config.url.unarchive, {
      method: "POST",
      body: JSON.stringify({
        item: e.item,
        id: e.id,
        path: e.path
      })
    });
  }
  async createFile(e) {
    return this.validateParam(e.name, "name"), this.validateParam(e.path, "path"), await this.request(this.config.url.createFile, {
      method: "POST",
      body: JSON.stringify({ path: e.path, name: e.name, kind: e.kind })
    });
  }
  async createFolder(e) {
    return this.validateParam(e.name, "name"), this.validateParam(e.path, "path"), await this.request(this.config.url.createFolder, {
      method: "POST",
      body: JSON.stringify({ path: e.path, name: e.name })
    });
  }
  getPreviewUrl(e) {
    this.validatePath(e.path);
    const t = Rt(e);
    return `${this.config.baseURL}${ut(this.config.url.preview, t.toString())}`;
  }
  async getContent(e) {
    this.validatePath(e.path);
    const t = Rt(e), o = `${this.config.baseURL}${ut(this.config.url.preview, t.toString())}`, r = await fetch(o, { headers: this.getHeaders() });
    if (!r.ok) {
      const d = await r.text(), a = $t(d, r.status, r.statusText);
      throw new St(a.message, a.code, r.status, a.params);
    }
    return { content: await r.text(), mimeType: r.headers.get("Content-Type") || void 0 };
  }
  getDownloadUrl(e) {
    this.validatePath(e.path);
    const t = Rt(e);
    return `${this.config.baseURL}${ut(this.config.url.download, t.toString())}`;
  }
  async download(e) {
    const t = this.getDownloadUrl(e), o = await fetch(t, { method: "GET", headers: this.getHeaders() });
    if (!o.ok) {
      const r = await o.text(), l = $t(r, o.status, o.statusText);
      throw new St(l.message, l.code, o.status, l.params);
    }
    return {
      blob: await o.blob(),
      filename: Hs(o.headers.get("Content-Disposition")),
      mimeType: o.headers.get("Content-Type") || void 0
    };
  }
  async search(e) {
    const t = new URLSearchParams();
    e.path && t.set("path", e.path), e.filter && t.set("filter", e.filter), e.deep && t.set("deep", "1"), e.size && e.size !== "all" && t.set("size", e.size), e.trashMineOnly !== void 0 && t.set("trash_mine", e.trashMineOnly ? "1" : "0");
    const o = ut(this.config.url.search, t.toString());
    return (await this.request(o, {
      method: "GET"
    })).files || [];
  }
  async save(e) {
    return this.validateParam(e.id, "id"), await this.request(this.config.url.save, {
      method: "POST",
      body: JSON.stringify({ id: e.id, content: e.content }),
      headers: this.getHeaders()
    });
  }
  /**
   * Загружает ACL выбранного файла или папки; /finder/access ищет объект по id.
   *
   * @param params Объект, для которого открываются настройки доступа.
   * @returns Прямые и унаследованные правила доступа.
   */
  async getAccess(e) {
    this.validateParam(e.id, "id");
    const t = Rt(e), o = ut(this.config.url.access, t.toString());
    return await this.request(o, { method: "GET" });
  }
}
class Yp extends zn {
  dbName;
  defaultStorage;
  storages;
  storagesSet;
  readOnly;
  version;
  db = null;
  dbPromise = null;
  entries = [];
  contentStore = /* @__PURE__ */ new Map();
  driver;
  readyPromise = null;
  constructor(e = {}) {
    super(), this.dbName = e.dbName || "vuefinder";
    const t = e.storages && e.storages.length > 0 ? e.storages : [e.storage || "indexeddb"];
    this.storages = [...new Set(t)], this.defaultStorage = e.storage || this.storages[0] || "indexeddb", this.storages.includes(this.defaultStorage) || this.storages.unshift(this.defaultStorage), this.storagesSet = new Set(this.storages), this.readOnly = !!e.readOnly, this.version = e.version || 1, this.driver = new Us({
      files: this.entries,
      storage: this.defaultStorage,
      storages: this.storages,
      readOnly: this.readOnly,
      contentStore: this.contentStore
    }), this.readyPromise = this.loadSnapshotFromDB();
  }
  isManagedStorage(e) {
    return !!(e && this.storagesSet.has(e));
  }
  isManagedPath(e) {
    if (!e) return !1;
    const { storage: t } = this.parsePath(e);
    return this.isManagedStorage(t);
  }
  async initDB() {
    return this.dbPromise ? this.dbPromise : (this.dbPromise = new Promise((e, t) => {
      const o = indexedDB.open(this.dbName, this.version);
      o.onerror = () => t(o.error), o.onsuccess = () => {
        this.db = o.result, e(this.db);
      }, o.onupgradeneeded = (r) => {
        const l = r.target.result;
        if (!l.objectStoreNames.contains("files")) {
          const d = l.createObjectStore("files", { keyPath: "path" });
          d.createIndex("storage", "storage", { unique: !1 }), d.createIndex("dir", "dir", { unique: !1 });
        }
        l.objectStoreNames.contains("content") || l.createObjectStore("content", { keyPath: "path" });
      };
    }), this.dbPromise);
  }
  async getDB() {
    return this.db ? this.db : this.initDB();
  }
  requestToPromise(e) {
    return new Promise((t, o) => {
      e.onsuccess = () => t(e.result), e.onerror = () => o(e.error);
    });
  }
  waitTransaction(e) {
    return new Promise((t, o) => {
      e.oncomplete = () => t(), e.onerror = () => o(e.error), e.onabort = () => o(e.error);
    });
  }
  async loadSnapshotFromDB() {
    const t = (await this.getDB()).transaction(["files", "content"], "readonly"), o = t.objectStore("files"), r = t.objectStore("content"), [l, d] = await Promise.all([
      this.requestToPromise(o.getAll()),
      this.requestToPromise(r.getAll())
    ]);
    await this.waitTransaction(t), this.entries.length = 0, this.entries.push(...l.filter((a) => this.isManagedStorage(a.storage))), this.contentStore.clear();
    for (const a of d)
      this.isManagedPath(a?.path) && this.contentStore.set(a.path, a.content);
  }
  async persistSnapshot() {
    if (this.readOnly) return;
    const t = (await this.getDB()).transaction(["files", "content"], "readwrite"), o = t.objectStore("files"), r = t.objectStore("content"), l = this.requestToPromise(
      o.getAll()
    ), d = this.requestToPromise(
      r.getAll()
    ), [a, u] = await Promise.all([
      l,
      d
    ]);
    o.clear(), r.clear();
    for (const f of a)
      this.isManagedStorage(f.storage) || o.put(f);
    for (const f of u)
      this.isManagedPath(f.path) || r.put(f);
    for (const f of this.entries)
      this.isManagedStorage(f.storage) && o.put(f);
    for (const [f, g] of this.contentStore.entries())
      this.isManagedPath(f) && r.put({ path: f, content: g });
    await this.waitTransaction(t);
  }
  async ensureReady() {
    this.readyPromise || (this.readyPromise = this.loadSnapshotFromDB()), await this.readyPromise;
  }
  async list(e) {
    return await this.ensureReady(), this.driver.list(e);
  }
  async delete(e) {
    await this.ensureReady();
    const t = await this.driver.delete(e);
    return await this.persistSnapshot(), t;
  }
  async rename(e) {
    await this.ensureReady();
    const t = await this.driver.rename(e);
    return await this.persistSnapshot(), t;
  }
  async copy(e) {
    await this.ensureReady();
    const t = await this.driver.copy(e);
    return await this.persistSnapshot(), t;
  }
  async move(e) {
    await this.ensureReady();
    const t = await this.driver.move(e);
    return await this.persistSnapshot(), t;
  }
  async archive(e) {
    await this.ensureReady();
    const t = await this.driver.archive(e);
    return await this.persistSnapshot(), t;
  }
  async unarchive(e) {
    await this.ensureReady();
    const t = await this.driver.unarchive(e);
    return await this.persistSnapshot(), t;
  }
  async createFile(e) {
    await this.ensureReady();
    const t = await this.driver.createFile(e);
    return await this.persistSnapshot(), t;
  }
  async createFolder(e) {
    await this.ensureReady();
    const t = await this.driver.createFolder(e);
    return await this.persistSnapshot(), t;
  }
  getPreviewUrl(e) {
    return this.driver.getPreviewUrl(e);
  }
  async getContent(e) {
    return await this.ensureReady(), this.driver.getContent(e);
  }
  getDownloadUrl(e) {
    return this.driver.getDownloadUrl(e);
  }
  async download(e) {
    return await this.ensureReady(), this.driver.download(e);
  }
  async search(e) {
    return await this.ensureReady(), this.driver.search(e);
  }
  async save(e) {
    await this.ensureReady();
    const t = await this.driver.save(e);
    return await this.persistSnapshot(), t;
  }
  configureUploader(e, t) {
    this.ensureReady(), this.driver.configureUploader?.(e, t), e && e.on("upload-success", async () => {
      try {
        await this.ensureReady(), await this.persistSnapshot();
      } catch {
      }
    });
  }
}
const eo = {
  list: (n, e = {}) => ["adapter", "list", n, { trashMineOnly: e.trashMineOnly }],
  search: (n, e, t, o, r = {}) => [
    "adapter",
    "search",
    n,
    e,
    t,
    o,
    { trashMineOnly: r.trashMineOnly }
  ],
  delete: (n) => ["adapter", "delete", n],
  rename: () => ["adapter", "rename"],
  copy: () => ["adapter", "copy"],
  move: () => ["adapter", "move"],
  archive: () => ["adapter", "archive"],
  unarchive: () => ["adapter", "unarchive"],
  createFile: () => ["adapter", "createFile"],
  createFolder: () => ["adapter", "createFolder"]
};
class Ks {
  driver;
  queryClient;
  config;
  onBeforeOpen;
  onAfterOpen;
  constructor(e, t = {}) {
    this.driver = e, this.onBeforeOpen = t.onBeforeOpen, this.onAfterOpen = t.onAfterOpen, this.queryClient = t.queryClient || new ys({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: t.refetchOnWindowFocus ?? !1,
          staleTime: t.staleTime ?? 120 * 1e3,
          retry: t.retry ?? 2
        },
        mutations: {
          retry: t.retry ?? 1
        }
      }
    }), this.config = {
      queryClient: this.queryClient,
      refetchOnWindowFocus: t.refetchOnWindowFocus ?? !1,
      staleTime: t.staleTime ?? 120 * 1e3,
      cacheTime: t.cacheTime ?? 600 * 1e3,
      retry: t.retry ?? 2,
      getListParams: t.getListParams ?? (() => ({})),
      onBeforeOpen: this.onBeforeOpen ?? (() => {
      }),
      onAfterOpen: this.onAfterOpen ?? (() => {
      })
    };
  }
  /**
   * Get the underlying driver instance
   */
  getDriver() {
    return this.driver;
  }
  /**
   * Get the query client instance
   */
  getQueryClient() {
    return this.queryClient;
  }
  /**
   * List files with caching and automatic refetching
   */
  async list(e) {
    const t = this.config.getListParams(), o = eo.list(e, t);
    return await this.queryClient.fetchQuery({
      queryKey: o,
      queryFn: () => this.driver.list({ ...t, path: e }),
      staleTime: this.config.staleTime
    });
  }
  /**
   * Open a path and optionally update state
   * @param path
   * @returns
   */
  async open(e) {
    this.onBeforeOpen && this.onBeforeOpen();
    const t = await this.list(e);
    return this.onAfterOpen && this.onAfterOpen(t), t;
  }
  /**
   * Delete files with optimistic updates
   */
  async delete(e) {
    const t = await this.driver.delete(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Rename a file or folder
   */
  async rename(e) {
    const t = await this.driver.rename(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Copy files to a destination
   */
  async copy(e) {
    const t = await this.driver.copy(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Move files to a destination
   */
  async move(e) {
    const t = await this.driver.move(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Create a zip archive
   */
  async archive(e) {
    const t = await this.driver.archive(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Extract files from a zip archive
   */
  async unarchive(e) {
    const t = await this.driver.unarchive(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Create a new file
   */
  async createFile(e) {
    const t = await this.driver.createFile(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Create a new folder
   */
  async createFolder(e) {
    const t = await this.driver.createFolder(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Get file content (cached)
   */
  async getContent(e) {
    const t = ["adapter", "content", e.path];
    return await this.queryClient.fetchQuery({
      queryKey: t,
      queryFn: () => this.driver.getContent(e),
      staleTime: this.config.staleTime
    });
  }
  /**
   * Get preview URL
   */
  getPreviewUrl(e) {
    return this.driver.getPreviewUrl(e);
  }
  /**
   * Get download URL
   */
  getDownloadUrl(e) {
    return this.driver.getDownloadUrl(e);
  }
  /**
   * Download a file
   */
  async download(e) {
    if (this.driver.download)
      return await this.driver.download(e);
    const t = this.driver.getDownloadUrl(e);
    if (!t)
      throw new Error("Download URL is not available");
    const o = await fetch(t);
    if (!o.ok)
      throw new Error(`HTTP ${o.status}: ${o.statusText}`);
    return {
      blob: await o.blob(),
      mimeType: o.headers.get("Content-Type") || void 0
    };
  }
  /**
   * Search files (cached per path+filter)
   */
  async search(e) {
    const t = this.config.getListParams(), o = { ...t, ...e }, r = eo.search(
      e.path,
      e.filter,
      e.deep,
      e.size,
      t
    );
    return await this.queryClient.fetchQuery({
      queryKey: r,
      queryFn: () => this.driver.search(o),
      staleTime: this.config.staleTime
    });
  }
  /**
   * Save content to file (and invalidate list cache)
   */
  async save(e) {
    const t = await this.driver.save(e);
    return this.invalidateListQueries(), t;
  }
  /** Fresh full ACL for the access modal (not cached with list). */
  async getAccess(e) {
    if (!this.driver.getAccess)
      throw new Error("Access API is not available for this adapter");
    return await this.driver.getAccess(e);
  }
  /**
   * Invalidate all list queries
   */
  invalidateListQueries() {
    this.queryClient.invalidateQueries({
      queryKey: ["adapter"],
      exact: !1
    });
  }
  invalidateListQuery(e) {
    this.queryClient.invalidateQueries({
      queryKey: ["adapter", "list", e],
      exact: !1
    });
  }
  /**
   * Clear all cached queries
   */
  clearCache() {
    this.queryClient.clear();
  }
}
function js(n) {
  const e = Z(n.state);
  return {
    current: B(() => e.value.theme || "silver"),
    set: (r) => {
      n.set("theme", r);
    }
  };
}
const qs = (n, e) => {
  const t = An(n.id ?? "vf"), o = gs(), r = e.i18n, l = n.locale ?? e.locale, d = Os(n.id ?? "vf", n.config ?? {}), a = Ns();
  if (!n.driver)
    throw new Error("Driver is required for VueFinder");
  const u = new Ks(n.driver, {
    getListParams: () => ({
      trashMineOnly: d.get("trashMineOnly") ?? !0
    })
  });
  return Gt({
    // app version
    version: Ps,
    // config store
    config: d,
    // Theme
    theme: (() => {
      const f = js(d);
      return {
        current: f.current,
        set: f.set
      };
    })(),
    // files store
    fs: a,
    // root element
    root: null,
    // app id
    debug: n.debug ?? !1,
    // Event Bus
    emitter: o,
    // storage
    storage: t,
    // localization object
    i18n: On(
      t,
      l,
      o,
      r,
      d
    ),
    // modal state
    modal: Ts(d),
    // adapter for file operations (always wrapped with AdapterManager)
    // Use markRaw to prevent TanStack Query from being made reactive
    adapter: ds(u),
    // active features
    features: po(n.features),
    // selection mode
    selectionMode: n.selectionMode || "multiple",
    // selection filters - computed properties for better reactivity
    selectionFilterType: B(() => n.selectionFilterType || "both"),
    selectionFilterMimeIncludes: B(() => n.selectionFilterMimeIncludes || []),
    // treeViewData - temp. opened folders
    treeViewData: [],
    // human readable file sizes
    filesize: d.get("metricUnits") ? go : Yt,
    // possible items of the context menu
    contextMenuItems: n.contextMenuItems,
    // host-defined path copy (format + notification), see VueFinderProps.copyPath
    copyPath: n.copyPath,
    // expose custom uploader if provided
    customUploader: n.customUploader
  });
}, Gs = ["data-theme"], Ws = { class: "vuefinder__modal-layout__container" }, Ys = { class: "vuefinder__modal-layout__content" }, Qs = {
  key: 0,
  class: "vuefinder__modal-layout__footer"
}, Xs = {
  key: 0,
  class: "vuefinder__modal-drag-overlay"
}, Js = { class: "vuefinder__modal-drag-message" }, Re = /* @__PURE__ */ le({
  __name: "ModalLayout",
  props: {
    showDragOverlay: { type: Boolean },
    dragOverlayText: {}
  },
  setup(n) {
    const e = z(null), t = fe();
    t.config;
    const o = n;
    Fe(() => {
      const l = document.querySelector(".v-f-modal input");
      l && l.focus(), Ve(() => {
        if (document.querySelector(".v-f-modal input") && window.innerWidth < 768 && e.value) {
          const d = e.value.getBoundingClientRect().bottom + 16;
          window.scrollTo({
            top: d,
            left: 0,
            behavior: "smooth"
          });
        }
      });
    });
    const r = (l) => {
      l.target.classList.contains(
        "vuefinder__modal-layout__wrapper"
      ) && (l.preventDefault(), l.stopPropagation());
    };
    return (l, d) => (c(), _("div", {
      "data-theme": s(t).theme.current,
      class: "vuefinder__themer vuefinder__modal-layout",
      "aria-labelledby": "modal-title",
      role: "dialog",
      "aria-modal": "true",
      tabindex: "0",
      onKeyup: d[1] || (d[1] = yt((a) => s(t).modal.close(), ["esc"]))
    }, [
      d[2] || (d[2] = i("div", { class: "vuefinder__modal-layout__overlay" }, null, -1)),
      i("div", Ws, [
        i("div", {
          class: "vuefinder__modal-layout__wrapper",
          onContextmenu: r,
          onMousedown: d[0] || (d[0] = ge((a) => s(t).modal.close(), ["self"]))
        }, [
          i("div", {
            ref_key: "modalBody",
            ref: e,
            class: "vuefinder__modal-layout__body"
          }, [
            i("div", Ys, [
              Ce(l.$slots, "default")
            ]),
            l.$slots.buttons ? (c(), _("div", Qs, [
              Ce(l.$slots, "buttons")
            ])) : V("", !0)
          ], 512)
        ], 32)
      ]),
      o.showDragOverlay ? (c(), _("div", Xs, [
        i("div", Js, w(o.dragOverlayText || "Drag and drop the files/folders to here."), 1)
      ])) : V("", !0)
    ], 40, Gs));
  }
}), Zs = { class: "vuefinder__modal-header" }, ei = { class: "vuefinder__modal-header__icon-container" }, ti = {
  id: "modal-title",
  class: "vuefinder__modal-header__title"
}, Le = /* @__PURE__ */ le({
  __name: "ModalHeader",
  props: {
    title: {},
    icon: {}
  },
  setup(n) {
    return (e, t) => (c(), _("div", Zs, [
      i("div", ei, [
        (c(), Y(Ge(n.icon), { class: "vuefinder__modal-header__icon" }))
      ]),
      i("div", ti, w(n.title), 1)
    ]));
  }
}), ni = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function oi(n, e) {
  return c(), _("svg", ni, [...e[0] || (e[0] = [
    i("circle", {
      cx: "12",
      cy: "12",
      r: "9"
    }, null, -1),
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 8.2h.01M10.75 11.25H12v4.5m0 0h1.25m-1.25 0h-2"
    }, null, -1)
  ])]);
}
const So = { render: oi }, si = { class: "vuefinder__about-modal__content" }, ii = { class: "vuefinder__about-modal__main" }, ri = { class: "vuefinder__about-modal__tab-content" }, ai = { class: "vuefinder__about-modal__lead" }, li = { class: "vuefinder__about-modal__description" }, di = { class: "vuefinder__about-modal__links" }, ci = {
  href: "https://vuefinder.ozdemir.be",
  class: "vuefinder__about-modal__link-btn",
  target: "_blank",
  rel: "noopener noreferrer"
}, ui = { class: "vuefinder__about-modal__meta" }, fi = { class: "vuefinder__about-modal__meta-item" }, vi = { class: "vuefinder__about-modal__meta-label" }, _i = { class: "vuefinder__about-modal__meta-value" }, hi = { class: "vuefinder__about-modal__meta-item" }, pi = { class: "vuefinder__about-modal__meta-label" }, Co = /* @__PURE__ */ le({
  __name: "ModalAbout",
  setup(n) {
    const e = fe(), { t } = e.i18n;
    return (o, r) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: r[0] || (r[0] = (l) => s(e).modal.close())
        }, w(s(t)("Close")), 1)
      ]),
      default: ae(() => [
        i("div", si, [
          j(Le, {
            icon: s(So),
            title: "Vuefinder " + s(e).version
          }, null, 8, ["icon", "title"]),
          i("div", ii, [
            i("div", ri, [
              i("div", ai, w(s(t)("A modern, customizable file manager component built for Vue.")), 1),
              i("div", li, w(s(t)("If you like it, please follow and ⭐ star on GitHub.")), 1),
              i("div", di, [
                i("a", ci, w(s(t)("Project Home")), 1),
                r[1] || (r[1] = i("a", {
                  href: "https://github.com/n1crack/vuefinder",
                  class: "vuefinder__about-modal__link-btn",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, " GitHub ", -1))
              ]),
              i("div", ui, [
                i("div", fi, [
                  i("span", vi, w(s(t)("Version")), 1),
                  i("span", _i, w(s(e).version), 1)
                ]),
                i("div", hi, [
                  i("span", pi, w(s(t)("License")), 1),
                  r[2] || (r[2] = i("span", { class: "vuefinder__about-modal__meta-value" }, "MIT", -1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), mi = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function gi(n, e) {
  return c(), _("svg", mi, [...e[0] || (e[0] = [
    i("path", { d: "M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14m-7 4v6m4-6v6" }, null, -1)
  ])]);
}
const It = { render: gi }, wi = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function yi(n, e) {
  return c(), _("svg", wi, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 21h10a2 2 0 0 0 2-2V9.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 12.586 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
    }, null, -1)
  ])]);
}
const Rn = { render: yi }, bi = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function ki(n, e) {
  return c(), _("svg", bi, [...e[0] || (e[0] = [
    i("path", {
      fill: "#737E88",
      "fill-rule": "evenodd",
      d: "M6 6h6c2 0 1.5 2 4 2h10a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "#B8BEC3",
      "fill-rule": "evenodd",
      d: "M26 11a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V14a3 3 0 0 1 3-3zm-10 3c-2.77 0-5 2.23-5 5s2.23 5 5 5 5-2.23 5-5-2.23-5-5-5m-3.923 4.077 2.385 2.385V21c0 .538.461 1 1 1v1C13.538 22.692 12 21.077 12 19c0-.308.077-.615.077-.923m5.461-2.77C19 15.924 20 17.308 20 19c0 1.077-.385 2-1.077 2.692C18.77 21.308 18.385 21 18 21h-.538v-1.538c0-.231-.154-.462-.462-.462h-3v-1h1c.308 0 .538-.23.538-.538v-.924h1c.539 0 1-.461 1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const et = { render: ki }, xi = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function $i(n, e) {
  return c(), _("svg", xi, [...e[0] || (e[0] = [
    i("path", { d: "M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14" }, null, -1)
  ])]);
}
const Si = { render: $i }, Ci = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function Fi(n, e) {
  return c(), _("svg", Ci, [...e[0] || (e[0] = [
    i("path", {
      fill: "#185ABD",
      d: "M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 0 1 .293.707V26A3 3 0 0 1 23 29H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
    }, null, -1),
    i("path", {
      fill: "#8BACDE",
      d: "m19.286 3.286 6.422 6.421a1 1 0 0 1 .203.293H21a2 2 0 0 1-1.995-1.85L19 8V3.09q.159.072.286.196"
    }, null, -1),
    i("path", {
      fill: "#fff",
      d: "M20.25 25a.75.75 0 0 0 .75-.75v-10.5a.75.75 0 0 0-.75-.75H12a.75.75 0 0 0-.75.75v1.5h-1.5A.75.75 0 0 0 9 16v6a.75.75 0 0 0 .75.75h1.5v1.5A.75.75 0 0 0 12 25zm0-9.75H12v-1.5h8.25zm0 3H16.5V16h3.75zm-8.104 3.188h-1.26l-1.083-4.875h1.207l.55 2.8.61-2.8h1.184l.638 2.783.51-2.784h1.195l-1.078 4.875h-1.242l-.633-2.8zm8.104-.188H16.5V19h3.75zm0 3H12v-1.5h3.75a.75.75 0 0 0 .75-.75h3.75z"
    }, null, -1)
  ])]);
}
const Fo = { render: Fi }, Ei = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function Di(n, e) {
  return c(), _("svg", Ei, [...e[0] || (e[0] = [
    i("path", {
      fill: "#107C41",
      d: "M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 0 1 .293.707V26A3 3 0 0 1 23 29H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
    }, null, -1),
    i("path", {
      fill: "#87BDA0",
      d: "m19.286 3.286 6.422 6.421a1 1 0 0 1 .203.293H21a2 2 0 0 1-1.995-1.85L19 8V3.09q.159.072.286.196"
    }, null, -1),
    i("path", {
      fill: "#fff",
      d: "M20.25 25a.75.75 0 0 0 .75-.75v-10.5a.75.75 0 0 0-.75-.75H12a.75.75 0 0 0-.75.75v1.5h-1.5A.75.75 0 0 0 9 16v6a.75.75 0 0 0 .75.75h1.5v1.5A.75.75 0 0 0 12 25zm-4.5-9.75H12v-1.5h3.75zm4.5 0H16.5v-1.5h3.75zm0 3H16.5V16h3.75zm-8.344 3.188h-1.511l1.582-2.45-1.442-2.425h1.518l.756 1.494.82-1.494h1.43l-1.483 2.42 1.518 2.454H13.6l-.838-1.564-.856 1.564zm8.344-.188H16.5V19h3.75zm0 3H16.5V22h3.75zm-4.5 0H12v-1.5h3.75z"
    }, null, -1)
  ])]);
}
const Eo = { render: Di }, Pi = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function Ii(n, e) {
  return c(), _("svg", Pi, [...e[0] || (e[0] = [
    i("path", {
      fill: "#D0021B",
      d: "M9 3h9.586a1 1 0 0 1 .707.293l6.415 6.414a1 1 0 0 1 .293.707V26A3 3 0 0 1 23 29H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
    }, null, -1),
    i("path", {
      fill: "#fff",
      "fill-opacity": ".5",
      d: "m19.286 3.286 5.01 5.009 1.412 1.412a1 1 0 0 1 .203.293H21a2 2 0 0 1-2-2V3.09a1 1 0 0 1 .286.196"
    }, null, -1),
    i("path", {
      fill: "#fff",
      d: "M13.133 16.998q0 .531-.162.918a1.74 1.74 0 0 1-1.044 1.012c-.222.08-.457.121-.693.122h-.62v2.322H9.2V15h1.98q.342 0 .688.099a1.66 1.66 0 0 1 1.09.945q.175.387.175.954m-1.35.027q0-.432-.207-.621a.72.72 0 0 0-.504-.189h-.459v1.665h.46a.66.66 0 0 0 .503-.22q.207-.221.207-.635m6.854 1.179q0 .72-.157 1.305-.159.585-.482.999a2.14 2.14 0 0 1-.824.639q-.5.225-1.183.225h-1.79V15h1.79q.684 0 1.183.225.5.225.824.643.324.42.482 1.008.157.59.157 1.328m-1.449 0q0-.962-.328-1.454-.33-.49-.85-.49h-.352v3.852h.351q.522 0 .85-.49.33-.492.33-1.418Zm3.961-1.899v1.296h1.521v1.233h-1.512v2.538H19.7V15h3.105v1.305z"
    }, null, -1)
  ])]);
}
const Do = { render: Ii }, Ti = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function Mi(n, e) {
  return c(), _("svg", Ti, [...e[0] || (e[0] = [
    i("path", {
      fill: "#F7931D",
      d: "M9 3h9.586a1 1 0 0 1 .707.293l6.415 6.414a1 1 0 0 1 .293.707V26A3 3 0 0 1 23 29H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
    }, null, -1),
    i("path", {
      fill: "#fff",
      "fill-opacity": ".5",
      d: "m19.286 3.286 5.01 5.009 1.412 1.412a1 1 0 0 1 .203.293H21a2 2 0 0 1-2-2V3.09a1 1 0 0 1 .286.196"
    }, null, -1),
    i("path", {
      fill: "#fff",
      d: "M15.643 20.354a.5.5 0 0 0 .707 0l5.003-5a.5.5 0 1 0-.706-.708l-4.65 4.647-1.647-1.647a.5.5 0 0 0-.707 0L9.646 21.65a.5.5 0 0 0 .708.707l3.643-3.649z"
    }, null, -1)
  ])]);
}
const Po = { render: Mi }, Ai = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function Oi(n, e) {
  return c(), _("svg", Ai, [...e[0] || (e[0] = [
    i("path", {
      fill: "#3FB87F",
      d: "M9 3h9.586a1 1 0 0 1 .707.293l6.415 6.414a1 1 0 0 1 .293.707V26A3 3 0 0 1 23 29H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
    }, null, -1),
    i("path", {
      fill: "#fff",
      "fill-opacity": ".5",
      d: "m19.286 3.286 5.01 5.009 1.412 1.412a1 1 0 0 1 .203.293H21a2 2 0 0 1-2-2V3.09a1 1 0 0 1 .286.196"
    }, null, -1),
    i("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "m14.754 18.128 3.102 3.204 1.327-1.625c.158-.193.415-.193.575 0l2.06 2.485c.37.446.159.808-.472.808H10.63c-.633 0-.82-.341-.414-.767l3.9-4.089a.444.444 0 0 1 .64-.016zM17.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Io = { render: Oi }, zi = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 410 512"
};
function Ri(n, e) {
  return c(), _("svg", zi, [...e[0] || (e[0] = [
    i("path", {
      fill: "#FFB11F",
      "fill-rule": "evenodd",
      d: "M80.1 0h171.2l145.1 151.3v294.2c0 36.7-29.9 66.6-66.6 66.6H80.1c-36.8 0-66.6-29.9-66.6-66.6V66.6C13.5 29.7 43.3 0 80.1 0",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "#FFF",
      "fill-rule": "evenodd",
      d: "M251.2 0v150h145.3z",
      "clip-rule": "evenodd",
      opacity: ".302"
    }, null, -1),
    i("path", {
      fill: "#FFF",
      d: "M154.6 266v-34.9c0-3.8-3-6.8-6.8-6.8h-18.9c-3.8 0-6.8 3-6.8 6.8V266l-10.5 30.8c-3 8.7-1.6 18.3 3.8 25.7 5.2 7.4 13.9 11.8 23 11.8s17.6-4.4 23-11.8 6.8-17 3.8-25.7zm-4.5 48.5c-5.4 7.7-18.3 7.7-23.8 0-2.7-3.8-3.5-8.8-1.9-13.2l3.5-10.4h20.6l3.6 10.4c1.5 4.4.9 9.4-2 13.2M96.5 36.7v19.2c0 3.8 3 6.8 6.8 6.8H129v28.6h-25.7c-3.8 0-6.8 3-6.8 6.8v14.8c0 3.8 3 6.9 6.8 6.9H129v28.5h-25.7c-3.8 0-6.8 3-6.8 6.8v15c0 3.8 3 6.8 6.8 6.8H129v21.7c0 3.8 3.1 6.8 6.9 6.8h37.6c3.6 0 6.8-3 6.8-6.8v-15c0-3.6-3.1-6.8-6.8-6.8h-25.8v-28.5h25.8c3.6 0 6.8-3 6.8-6.8v-15c0-3.8-3.1-6.8-6.8-6.8h-25.8V91.3h25.8c3.6 0 6.8-3.1 6.8-6.9V69.6c0-3.8-3.1-6.9-6.8-6.9h-25.8V36.5z"
    }, null, -1)
  ])]);
}
const To = { render: Ri }, $n = "Корзина";
function Mo(n) {
  const e = String(n || ""), t = "://", o = e.indexOf(t);
  return o >= 0 ? e.slice(o + t.length) : e;
}
function Qt(n) {
  return !!n.is_trash_root || Mo(n.path) === $n;
}
function to(n) {
  const e = Mo(n);
  return e === $n || e.startsWith(`${$n}/`);
}
function Ue(n, e) {
  return Qt(n) ? e("Trash") : String(n.name || n.basename || "");
}
function Xt(n, e, t) {
  const o = String(n || "").trim();
  return o ? `${t && t[o] || (o === "ltms" ? e("Dossier") : o)}://` : "";
}
function Ao(n, e, t, o, r = 0) {
  const l = String(n || "").trim(), d = l.indexOf("://");
  if (d < 0)
    return l;
  const a = l.slice(0, d), u = l.slice(d + 3), f = o?.[a];
  if (f && r < 5) {
    const h = Ao(f.parent, e, t, o, r + 1), v = h.endsWith("/") ? `${h}${f.label}` : `${h}/${f.label}`;
    return u ? `${v}/${u}` : v;
  }
  const g = Xt(a, e, t);
  return u ? `${g}${u}` : g;
}
const Li = /* @__PURE__ */ new Set(["doc", "docx", "docm", "dot", "dotx", "dotm", "odt", "rtf"]), Vi = /* @__PURE__ */ new Set([
  "csv",
  "ods",
  "ots",
  "xls",
  "xlsb",
  "xlsm",
  "xlsx",
  "xlt",
  "xltm",
  "xltx"
]), Bi = /* @__PURE__ */ new Set([
  "odp",
  "pot",
  "potm",
  "potx",
  "pps",
  "ppsm",
  "ppsx",
  "ppt",
  "pptm",
  "pptx"
]), Ni = /* @__PURE__ */ new Set([
  "avif",
  "bmp",
  "gif",
  "heic",
  "jpeg",
  "jpg",
  "png",
  "svg",
  "tif",
  "tiff",
  "webp"
]), Ui = /* @__PURE__ */ new Set([
  "7z",
  "ace",
  "apk",
  "arj",
  "bz",
  "bz2",
  "cab",
  "cpio",
  "deb",
  "dmg",
  "gz",
  "gzip",
  "iso",
  "jar",
  "lha",
  "lz",
  "lzma",
  "lzo",
  "rar",
  "rpm",
  "tar",
  "tbz",
  "tbz2",
  "tgz",
  "txz",
  "war",
  "xz",
  "z",
  "zip",
  "zipx",
  "zst"
]), Hi = ["tar.bz2", "tar.gz", "tar.xz", "tar.zst"];
function Oo(n) {
  return String(n.basename || n.name || "").trim();
}
function no(n) {
  return String(n || "").trim().replace(/^\.+/, "").toLowerCase();
}
function Ki(n) {
  const e = no(n.extension);
  if (e) return e;
  const t = Oo(n), o = t.lastIndexOf(".");
  return o >= 0 ? no(t.slice(o + 1)) : "";
}
function zo(n) {
  if (n.type === "dir") return null;
  const e = Ki(n), t = Oo(n).toLowerCase(), o = String(n.mime_type || "").toLowerCase();
  return e === "pdf" || o === "application/pdf" ? "pdf" : Li.has(e) || o.includes("word") ? "word" : Vi.has(e) || o.includes("excel") || o.includes("spreadsheet") || o.includes("csv") ? "excel" : Bi.has(e) || o.includes("powerpoint") || o.includes("presentation") ? "presentation" : Ui.has(e) || Hi.some((r) => t.endsWith(`.${r}`)) || o.includes("archive") || o.includes("compressed") || o.includes("x-7z") || o.includes("x-rar") || o.includes("x-tar") || o.includes("gzip") || o.includes("zip") || o.includes("rar") || o.includes("tar") || o.includes("7z") ? "archive" : Ni.has(e) || o.startsWith("image/") ? "image" : null;
}
const ji = /* @__PURE__ */ new Set([
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/webp",
  "image/svg+xml",
  "image/bmp",
  "image/avif",
  "image/x-icon",
  "image/vnd.microsoft.icon"
]);
function qi(n) {
  return ji.has((n.mime_type ?? "").toLowerCase());
}
function Sn(n) {
  if (Qt(n)) return Si;
  if (n.type === "dir") return et;
  switch (zo(n)) {
    case "pdf":
      return Do;
    case "word":
      return Fo;
    case "excel":
      return Eo;
    case "presentation":
      return Po;
    case "archive":
      return To;
    case "image":
      return Io;
    default:
      return Rn;
  }
}
const Gi = { class: "vuefinder__delete-modal__content" }, Wi = { class: "vuefinder__delete-modal__form" }, Yi = { class: "vuefinder__delete-modal__description" }, Qi = { class: "vuefinder__delete-modal__files vf-scrollbar" }, Xi = { class: "vuefinder__delete-modal__file-name" }, Ji = ["onUpdate:modelValue", "disabled", "placeholder"], Zi = {
  key: 0,
  class: "vuefinder__delete-modal__password-hint"
}, er = { class: "vuefinder__delete-modal__confirmation" }, tr = { class: "vuefinder__delete-modal__confirmation-label" }, nr = ["disabled"], or = { class: "vuefinder__delete-modal__confirmation-text" }, sr = ["disabled"], ir = ["disabled"], Jt = /* @__PURE__ */ le({
  __name: "ModalDelete",
  setup(n) {
    const e = fe(), t = Ne(e), { t: o } = e.i18n, r = e.fs, l = Z(r.path), d = z(e.modal.data.items), a = z(!1), u = z(!1), f = z({}), g = (y) => y.type !== "dir" && !!y.restricted, h = B(() => d.value.filter(g)), v = B(
      () => h.value.every((y) => (f.value[J(y)] ?? "").trim())
    ), x = () => {
      !d.value.length || !a.value || !v.value || u.value || (u.value = !0, e.adapter.delete({
        path: l.value.path,
        items: d.value.map(_t),
        ...h.value.length ? { passwords: { ...f.value } } : {}
      }).then((y) => {
        t.success(o("Files deleted.")), e.fs.setFiles(y.files), e.emitter.emit("vf-delete-complete", d.value), e.modal.close();
      }).catch((y) => {
        t.error(Ae(y, o("Failed to delete files"), o)), f.value = {};
      }).finally(() => {
        u.value = !1;
      }));
    };
    return (y, m) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("div", er, [
          i("label", tr, [
            xe(i("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (b) => a.value = b),
              type: "checkbox",
              class: "vuefinder__delete-modal__checkbox",
              disabled: u.value
            }, null, 8, nr), [
              [Wt, a.value]
            ]),
            i("span", or, w(s(o)("I'm sure delete it, This action cannot be undone.")), 1)
          ])
        ]),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-danger",
          disabled: !a.value || !v.value || u.value,
          onClick: x
        }, w(s(o)("Yes, Delete!")), 9, sr),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: u.value,
          onClick: m[1] || (m[1] = (b) => s(e).modal.close())
        }, w(s(o)("Cancel")), 9, ir)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(It),
            title: s(o)("Delete files")
          }, null, 8, ["icon", "title"]),
          i("div", Gi, [
            i("div", Wi, [
              i("p", Yi, w(s(o)("Are you sure you want to delete these files?")), 1),
              i("div", Qi, [
                (c(!0), _(he, null, ke(d.value, (b) => (c(), _("p", {
                  key: s(J)(b),
                  class: "vuefinder__delete-modal__file"
                }, [
                  (c(), Y(Ge(s(Sn)(b)), {
                    class: re(["vuefinder__delete-modal__icon", { "vuefinder__item-icon__folder": b.type === "dir" }])
                  }, null, 8, ["class"])),
                  i("span", Xi, w(b.basename), 1),
                  g(b) ? xe((c(), _("input", {
                    key: 0,
                    "onUpdate:modelValue": (I) => f.value[s(J)(b)] = I,
                    class: "vuefinder__delete-modal__password",
                    type: "password",
                    autocomplete: "off",
                    disabled: u.value,
                    placeholder: s(o)("Password")
                  }, null, 8, Ji)), [
                    [bt, f.value[s(J)(b)]]
                  ]) : V("", !0)
                ]))), 128))
              ]),
              h.value.length ? (c(), _("p", Zi, w(s(o)("The file is password-protected from editing. Enter the password to delete it.")), 1)) : V("", !0)
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
});
function Kt(n) {
  const e = n.lastIndexOf(".");
  return e > 0 && e < n.length - 1 ? n.slice(e + 1) : "";
}
function rr(n) {
  return !!Kt(n);
}
function ar(n) {
  const e = n.lastIndexOf(".");
  return e > 0 && e < n.length - 1 ? n.slice(0, e) : n;
}
function lr(n, e) {
  const t = Kt(e);
  return t ? `${n}.${t}` : n;
}
function dr(n, e) {
  return Kt(n).toLowerCase() !== Kt(e).toLowerCase();
}
const cr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function ur(n, e) {
  return c(), _("svg", cr, [...e[0] || (e[0] = [
    i("path", { d: "M4 20h4L19 9l-4-4L4 16zm9.5-13.5 4 4" }, null, -1)
  ])]);
}
const Ln = { render: ur }, fr = { class: "vuefinder__rename-modal__content" }, vr = { class: "vuefinder__rename-modal__item" }, _r = { class: "vuefinder__rename-modal__item-info" }, hr = {
  key: 0,
  class: "vuefinder__rename-modal__icon vuefinder__rename-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, pr = {
  key: 1,
  class: "vuefinder__rename-modal__icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, mr = { class: "vuefinder__rename-modal__item-name" }, gr = ["disabled"], wr = ["disabled"], yr = ["disabled"], Zt = /* @__PURE__ */ le({
  __name: "ModalRename",
  setup(n) {
    const e = fe(), t = Ne(e), { t: o } = e.i18n, r = e.fs, l = Z(r.path), d = z(e.modal.data.items[0]), a = B(
      () => d.value.type !== "dir" && rr(d.value.basename)
    ), u = B(
      () => a.value ? ar(d.value.basename) : d.value.basename
    ), f = z(u.value), g = z(!1), h = B(
      () => a.value ? lr(f.value, d.value.basename) : f.value
    ), v = B(() => h.value !== d.value.basename), x = () => {
      h.value === d.value.basename || g.value || (g.value = !0, e.adapter.rename({
        path: l.value.path,
        item: d.value.path,
        id: d.value.id,
        name: h.value
      }).then((y) => {
        t.success(o("%s is renamed.", h.value)), e.fs.setFiles(y.files), e.modal.close();
      }).catch((y) => {
        t.error(Ae(y, o("Failed to rename"), o));
      }).finally(() => {
        g.value = !1;
      }));
    };
    return (y, m) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: re(["vf-btn vf-btn-primary", { disabled: !v.value || g.value }]),
          disabled: !v.value || g.value,
          onClick: x
        }, w(s(o)("Rename")), 11, wr),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: g.value,
          onClick: m[1] || (m[1] = (b) => s(e).modal.close())
        }, w(s(o)("Cancel")), 9, yr)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(Ln),
            title: s(o)("Rename")
          }, null, 8, ["icon", "title"]),
          i("div", fr, [
            i("div", vr, [
              i("p", _r, [
                d.value.type === "dir" ? (c(), _("svg", hr, [...m[2] || (m[2] = [
                  i("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  }, null, -1)
                ])])) : (c(), _("svg", pr, [...m[3] || (m[3] = [
                  i("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  }, null, -1)
                ])])),
                i("span", mr, w(u.value), 1)
              ]),
              xe(i("input", {
                "onUpdate:modelValue": m[0] || (m[0] = (b) => f.value = b),
                class: "vuefinder__rename-modal__input",
                placeholder: "Name",
                type: "text",
                disabled: g.value,
                onKeyup: yt(x, ["enter"])
              }, null, 40, gr), [
                [bt, f.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
});
function st() {
  const n = fe(), e = B(() => n.features), t = Z(n.fs.disabledFeatures);
  return {
    enabled: (r) => t.value.includes(r) ? !1 : e.value[r] ?? !1
  };
}
const br = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function kr(n, e) {
  return c(), _("svg", br, [...e[0] || (e[0] = [
    i("path", { d: "M12 3v18m-9-9h18M8 7l-5 5 5 5m8-10 5 5-5 5" }, null, -1)
  ])]);
}
const Ro = { render: kr }, xr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function $r(n, e) {
  return c(), _("svg", xr, [...e[0] || (e[0] = [
    i("rect", {
      width: "11",
      height: "11",
      x: "8",
      y: "8",
      rx: "2"
    }, null, -1),
    i("path", { d: "M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" }, null, -1)
  ])]);
}
const Tt = { render: $r }, Sr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Cr(n, e) {
  return c(), _("svg", Sr, [...e[0] || (e[0] = [
    i("path", { d: "M12 5v14m-7-7h14" }, null, -1)
  ])]);
}
const Mt = { render: Cr }, Fr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
};
function Er(n, e) {
  return c(), _("svg", Fr, [...e[0] || (e[0] = [
    i("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    i("path", { d: "M5 12h14" }, null, -1)
  ])]);
}
const en = { render: Er }, Dr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "h-5 w-5",
  viewBox: "0 0 24 24"
};
function Pr(n, e) {
  return c(), _("svg", Dr, [...e[0] || (e[0] = [
    i("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    i("path", { d: "m15 4.5-4 4L7 10l-1.5 1.5 7 7L14 17l1.5-4 4-4M9 15l-4.5 4.5M14.5 4 20 9.5" }, null, -1)
  ])]);
}
const Vn = { render: Pr }, Ir = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function Tr(n, e) {
  return c(), _("svg", Ir, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
    }, null, -1)
  ])]);
}
const Bn = { render: Tr }, Mr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 32 32"
};
function Ar(n, e) {
  return c(), _("svg", Mr, [...e[0] || (e[0] = [
    i("path", {
      fill: "#737E88",
      "fill-rule": "evenodd",
      d: "M6 6h6c2 0 1.5 2 4 2h10a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "#B8BEC3",
      "fill-rule": "evenodd",
      d: "M26 11a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V14a3 3 0 0 1 3-3zm-10 3c-2.77 0-5 2.23-5 5s2.23 5 5 5 5-2.23 5-5-2.23-5-5-5m-3.923 4.077 2.385 2.385V21c0 .538.461 1 1 1v1C13.538 22.692 12 21.077 12 19c0-.308.077-.615.077-.923m5.461-2.77C19 15.924 20 17.308 20 19c0 1.077-.385 2-1.077 2.692C18.77 21.308 18.385 21 18 21h-.538v-1.538c0-.231-.154-.462-.462-.462h-3v-1h1c.308 0 .538-.23.538-.538v-.924h1c.539 0 1-.461 1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Nn = { render: Ar }, Or = { class: "vuefinder__modal-tree__folder-item" }, zr = { class: "vuefinder__modal-tree__folder-content" }, Rr = {
  key: 1,
  class: "vuefinder__modal-tree__folder-spacer"
}, Lr = { class: "vuefinder__modal-tree__folder-text" }, Vr = {
  key: 0,
  class: "vuefinder__modal-tree__subfolders"
}, Br = {
  key: 0,
  class: "vuefinder__modal-tree__more-note"
}, Nr = 300, Ur = /* @__PURE__ */ le({
  __name: "ModalTreeFolderItem",
  props: {
    folder: {},
    storage: {},
    modelValue: {},
    expandedFolders: {},
    modalTreeData: {},
    currentPath: {}
  },
  emits: ["update:modelValue", "selectAndClose", "toggleFolder"],
  setup(n, { emit: e }) {
    const t = fe(), { t: o } = t.i18n, r = t.fs, l = z({}), d = n, a = e;
    Z(r.path);
    const u = B(() => {
      const P = `${d.storage}:${d.folder.path}`;
      return d.expandedFolders[P] || !1;
    }), f = B(() => d.modelValue?.path === d.folder.path), g = B(() => d.currentPath?.path === d.folder.path), h = B(() => d.modalTreeData[d.folder.path] || []), v = B(() => {
      const P = h.value, N = l.value[d.folder.path] || 50;
      return P.length > N ? P.slice(0, N) : P;
    }), x = B(() => h.value.length), y = B(() => l.value[d.folder.path] || 50), m = B(() => x.value > y.value), b = () => {
      l.value[d.folder.path] = (y.value || 50) + 50;
    }, I = B(() => h.value.length > 0 || d.folder.type === "dir"), L = B(() => Ue(d.folder, t.i18n.t)), S = () => {
      a("toggleFolder", d.storage, d.folder.path);
    }, p = () => {
      a("update:modelValue", d.folder);
    }, F = () => {
      a("update:modelValue", d.folder), a("selectAndClose", d.folder);
    };
    let C = 0;
    const E = () => {
      const P = Date.now();
      P - C < Nr ? F() : p(), C = P;
    };
    return (P, N) => {
      const te = uo("ModalTreeFolderItem", !0);
      return c(), _("div", Or, [
        i("div", zr, [
          I.value ? (c(), _("div", {
            key: 0,
            class: "vuefinder__modal-tree__folder-toggle",
            onClick: S
          }, [
            u.value ? (c(), Y(s(en), {
              key: 1,
              class: "vuefinder__modal-tree__folder-toggle-icon"
            })) : (c(), Y(s(Mt), {
              key: 0,
              class: "vuefinder__modal-tree__folder-toggle-icon"
            }))
          ])) : (c(), _("div", Rr)),
          i("div", {
            class: re(["vuefinder__modal-tree__folder-link", {
              "vuefinder__modal-tree__folder-link--selected": f.value,
              "vuefinder__modal-tree__folder-link--current": g.value
            }]),
            onClick: p,
            onDblclick: F,
            onTouchend: E
          }, [
            u.value ? (c(), Y(s(Nn), {
              key: 1,
              class: "vuefinder__item-icon__folder--open vuefinder__modal-tree__folder-icon"
            })) : (c(), Y(s(et), {
              key: 0,
              class: "vuefinder__modal-tree__folder-icon vuefinder__item-icon__folder"
            })),
            i("span", Lr, w(L.value), 1)
          ], 34)
        ]),
        u.value && I.value ? (c(), _("div", Vr, [
          (c(!0), _(he, null, ke(v.value, (W) => (c(), Y(te, {
            key: W.path,
            folder: W,
            storage: n.storage,
            "model-value": n.modelValue,
            "expanded-folders": n.expandedFolders,
            "modal-tree-data": n.modalTreeData,
            "current-path": n.currentPath,
            "onUpdate:modelValue": N[0] || (N[0] = (se) => P.$emit("update:modelValue", se)),
            onSelectAndClose: N[1] || (N[1] = (se) => P.$emit("selectAndClose", se)),
            onToggleFolder: N[2] || (N[2] = (se, $) => P.$emit("toggleFolder", se, $))
          }, null, 8, ["folder", "storage", "model-value", "expanded-folders", "modal-tree-data", "current-path"]))), 128)),
          m.value ? (c(), _("div", Br, [
            i("div", {
              class: "vuefinder__modal-tree__load-more",
              onClick: b
            }, w(s(o)("load more")), 1)
          ])) : V("", !0)
        ])) : V("", !0)
      ]);
    };
  }
}), Hr = { class: "vuefinder__modal-tree" }, Kr = { class: "vuefinder__modal-tree__header" }, jr = { class: "vuefinder__modal-tree__title" }, qr = {
  key: 0,
  class: "vuefinder__modal-tree__section"
}, Gr = { class: "vuefinder__modal-tree__section-title" }, Wr = { class: "vuefinder__modal-tree__list" }, Yr = ["onClick", "onDblclick", "onTouchend"], Qr = { class: "vuefinder__modal-tree__text" }, Xr = { class: "vuefinder__modal-tree__text-storage" }, Jr = { class: "vuefinder__modal-tree__section-title" }, Zr = { class: "vuefinder__modal-tree__list" }, ea = { class: "vuefinder__modal-tree__storage-item" }, ta = { class: "vuefinder__modal-tree__storage-content" }, na = ["onClick"], oa = ["onClick", "onDblclick", "onTouchend"], sa = { class: "vuefinder__modal-tree__storage-text" }, ia = {
  key: 0,
  class: "vuefinder__modal-tree__subfolders"
}, ra = {
  key: 0,
  class: "vuefinder__modal-tree__more-note"
}, aa = ["onClick"], oo = 300, Un = /* @__PURE__ */ le({
  __name: "ModalTreeSelector",
  props: {
    modelValue: {},
    showPinnedFolders: { type: Boolean },
    currentPath: {}
  },
  emits: ["update:modelValue", "selectAndClose"],
  setup(n, { emit: e }) {
    const t = fe(), { t: o } = t.i18n, r = t.fs, l = t.config, d = e, a = Z(r.sortedFiles), u = Z(r.storages), f = B(() => u.value || []), g = Z(r.path), h = z(null), v = z({}), x = z({}), y = z({});
    me(a, (k) => {
      const T = k.filter((q) => q.type === "dir"), M = g.value?.path || "";
      M && (x.value[M] = T.map((q) => ({
        ...q,
        type: "dir"
      })));
    });
    const m = (k, T) => {
      const M = `${k}:${T}`;
      v.value = {
        ...v.value,
        [M]: !v.value[M]
      }, v.value[M] && !x.value[T] && t.adapter.list(T).then((q) => {
        const R = (q.files || []).filter((D) => D.type === "dir");
        x.value[T] = R.map((D) => ({
          ...D,
          type: "dir"
        }));
      });
    }, b = (k) => x.value[k] || [], I = (k) => y.value[k] || 50, L = (k) => {
      const T = b(k), M = I(k);
      return T.length > M ? T.slice(0, M) : T;
    }, S = (k) => b(k).length, p = (k) => S(k) > I(k), F = (k) => {
      y.value[k] = I(k) + 50;
    }, C = (k) => {
      k && d("update:modelValue", k);
    }, E = (k) => {
      k && (d("update:modelValue", k), d("selectAndClose", k));
    }, P = (k) => {
      const T = {
        // Синтетическая папка-назначение (корень хранилища): id = путь.
        id: k + "://",
        storage: k,
        path: k + "://",
        basename: k,
        type: "dir",
        extension: "",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: "public",
        dir: k + "://"
      };
      d("update:modelValue", T);
    }, N = (k) => {
      const T = {
        // Синтетическая папка-назначение (корень хранилища): id = путь.
        id: k + "://",
        storage: k,
        path: k + "://",
        basename: k,
        type: "dir",
        extension: "",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: "public",
        dir: k + "://"
      };
      d("update:modelValue", T), d("selectAndClose", T);
    };
    let te = 0;
    const W = (k) => {
      if (!k) return;
      const T = Date.now();
      T - te < oo ? E(k) : C(k), te = T;
    }, se = (k) => {
      const T = Date.now();
      T - te < oo ? N(k) : P(k), te = T;
    }, $ = (k) => Ue(k, t.i18n.t);
    return Fe(() => {
      h.value && Dt(h.value, {
        overflow: {
          x: "hidden"
        },
        scrollbars: {
          theme: "vf-scrollbars-theme"
        }
      });
    }), (k, T) => (c(), _("div", Hr, [
      i("div", Kr, [
        i("div", jr, w(s(o)("Select Target Folder")), 1)
      ]),
      i("div", {
        ref_key: "modalContentElement",
        ref: h,
        class: "vuefinder__modal-tree__content"
      }, [
        n.showPinnedFolders && s(t).features.pinned && s(l).get("pinnedFolders").length ? (c(), _("div", qr, [
          i("div", Gr, w(s(o)("Pinned Folders")), 1),
          i("div", Wr, [
            (c(!0), _(he, null, ke(s(l).get("pinnedFolders"), (M) => (c(), _("div", {
              key: M.path,
              class: re(["vuefinder__modal-tree__item", { "vuefinder__modal-tree__item--selected": n.modelValue?.path === M.path }]),
              onClick: (q) => C(M),
              onDblclick: (q) => E(M),
              onTouchend: (q) => W(M)
            }, [
              j(s(et), { class: "vuefinder__modal-tree__icon vuefinder__item-icon__folder" }),
              i("div", Qr, w($(M)), 1),
              i("div", Xr, w(M.storage), 1),
              j(s(Vn), { class: "vuefinder__modal-tree__icon vuefinder__modal-tree__icon--pin" })
            ], 42, Yr))), 128))
          ])
        ])) : V("", !0),
        i("div", Jr, w(s(o)("Storages")), 1),
        (c(!0), _(he, null, ke(f.value, (M) => (c(), _("div", {
          key: M,
          class: "vuefinder__modal-tree__section"
        }, [
          i("div", Zr, [
            i("div", ea, [
              i("div", ta, [
                i("div", {
                  class: "vuefinder__modal-tree__storage-toggle",
                  onClick: ge((q) => m(M, M + "://"), ["stop"])
                }, [
                  v.value[`${M}:${M}://`] ? (c(), Y(s(en), {
                    key: 1,
                    class: "vuefinder__modal-tree__toggle-icon"
                  })) : (c(), Y(s(Mt), {
                    key: 0,
                    class: "vuefinder__modal-tree__toggle-icon"
                  }))
                ], 8, na),
                i("div", {
                  class: re(["vuefinder__modal-tree__storage-link", {
                    "vuefinder__modal-tree__storage-link--selected": n.modelValue?.path === M + "://"
                  }]),
                  onClick: (q) => P(M),
                  onDblclick: (q) => N(M),
                  onTouchend: (q) => se(M)
                }, [
                  j(s(Bn), { class: "vuefinder__modal-tree__storage-icon" }),
                  i("span", sa, w(M), 1)
                ], 42, oa)
              ]),
              v.value[`${M}:${M}://`] ? (c(), _("div", ia, [
                (c(!0), _(he, null, ke(L(M + "://"), (q) => (c(), Y(Ur, {
                  key: q.path,
                  folder: q,
                  storage: M,
                  "model-value": n.modelValue,
                  "expanded-folders": v.value,
                  "modal-tree-data": x.value,
                  "current-path": n.currentPath,
                  "onUpdate:modelValue": C,
                  onSelectAndClose: E,
                  onToggleFolder: m
                }, null, 8, ["folder", "storage", "model-value", "expanded-folders", "modal-tree-data", "current-path"]))), 128)),
                p(M + "://") ? (c(), _("div", ra, [
                  i("div", {
                    class: "vuefinder__modal-tree__load-more",
                    onClick: (q) => F(M + "://")
                  }, w(s(o)("load more")), 9, aa)
                ])) : V("", !0)
              ])) : V("", !0)
            ])
          ])
        ]))), 128))
      ], 512)
    ]));
  }
}), la = ["title"], Cn = /* @__PURE__ */ le({
  __name: "Message",
  props: {
    error: { type: Boolean }
  },
  emits: ["hidden"],
  setup(n, { emit: e }) {
    const t = e, o = fe(), { t: r } = o.i18n, l = z(!1), d = z(null), a = z(d.value?.innerHTML);
    me(a, () => l.value = !1);
    const u = () => {
      t("hidden"), l.value = !0;
    };
    return (f, g) => (c(), _("div", null, [
      l.value ? V("", !0) : (c(), _("div", {
        key: 0,
        ref_key: "strMessage",
        ref: d,
        class: re(["vuefinder__message", n.error ? "vuefinder__message--error" : "vuefinder__message--success"])
      }, [
        Ce(f.$slots, "default"),
        i("div", {
          class: "vuefinder__message__close",
          title: s(r)("Close"),
          onClick: u
        }, [...g[0] || (g[0] = [
          i("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "currentColor",
            class: "vuefinder__message__icon"
          }, [
            i("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ])], 8, la)
      ], 2))
    ]));
  }
}), da = ["src"], ca = {
  key: 10,
  class: "vuefinder__item-icon__extension"
}, wt = /* @__PURE__ */ le({
  __name: "ItemIcon",
  props: {
    item: {},
    ext: { type: Boolean },
    small: { type: Boolean },
    view: {}
  },
  setup(n) {
    const e = n, t = fe(), o = Z(t.config.state), r = B(() => e.small !== void 0 ? e.small ? "small" : "large" : e.view === "list" ? "small" : "large"), l = B(() => {
      const u = r.value, f = o.value?.listIconSize, g = o.value?.gridIconSize;
      return o.value?.gridItemWidth, o.value?.gridItemHeight, e.view === "list" || u === "small" ? {
        "--vf-icon-size": `${f ?? 16}px`
      } : {
        "--vf-icon-size": `${g ?? 48}px`
      };
    }), d = B(() => zo(e.item)), a = {
      app: t,
      config: o.value,
      item: e.item,
      view: e.view
    };
    return (u, f) => (c(), _("div", {
      class: re(["vuefinder__item-icon", {
        "vuefinder__item-icon--small": r.value === "small",
        "vuefinder__item-icon--large": r.value === "large",
        "vuefinder__item-icon--grid": n.view === "grid",
        "vuefinder__item-icon--list": n.view === "list"
      }]),
      style: Be(l.value)
    }, [
      Ce(u.$slots, "icon", We(Ye(a)), () => [
        n.item.icon_url ? (c(), _("img", {
          key: 0,
          src: n.item.icon_url,
          alt: "",
          class: "vuefinder__item-icon__custom"
        }, null, 8, da)) : s(Qt)(n.item) ? (c(), Y(s(It), {
          key: 1,
          class: "vuefinder__item-icon__trash"
        })) : n.item.type === "dir" ? (c(), Y(s(et), {
          key: 2,
          class: "vuefinder__item-icon__folder"
        })) : d.value === "pdf" ? (c(), Y(s(Do), {
          key: 3,
          class: "vuefinder__item-icon__format"
        })) : d.value === "word" ? (c(), Y(s(Fo), {
          key: 4,
          class: "vuefinder__item-icon__format"
        })) : d.value === "excel" ? (c(), Y(s(Eo), {
          key: 5,
          class: "vuefinder__item-icon__format"
        })) : d.value === "presentation" ? (c(), Y(s(Po), {
          key: 6,
          class: "vuefinder__item-icon__format"
        })) : d.value === "archive" ? (c(), Y(s(To), {
          key: 7,
          class: "vuefinder__item-icon__format"
        })) : d.value === "image" ? (c(), Y(s(Io), {
          key: 8,
          class: "vuefinder__item-icon__format"
        })) : (c(), Y(s(Rn), {
          key: 9,
          class: "vuefinder__item-icon__file"
        })),
        n.ext && n.item.type !== "dir" && n.item.extension && !d.value ? (c(), _("div", ca, w(n.item.extension.substring(0, 3)), 1)) : V("", !0)
      ])
    ], 6));
  }
});
function ua(n) {
  const [e, t] = va(n);
  if (!t || t === "/") return e + "://";
  const o = t.replace(/\/+$/, ""), r = o.lastIndexOf("/");
  return r === 0 ? e + "://" : e + ":/" + o.slice(0, r);
}
function fa(n, e) {
  return n === e ? !0 : n.startsWith(e.endsWith("/") ? e : e + "/");
}
function jt(n, e) {
  return ua(n.path) === e ? !0 : n.type === "dir" ? fa(e, n.path) : e === n.path;
}
function va(n) {
  const e = n.indexOf(":/");
  return e === -1 ? [void 0, n] : [n.slice(0, e), n.slice(e + 2) || "/"];
}
function Lo(n, e = 40) {
  const t = n.match(/^([^:]+:\/\/)(.*)$/);
  if (!t) return n;
  const o = t[1], r = t[2] ?? "", l = r.split("/").filter(Boolean), d = l.pop();
  if (!d) return o + r;
  let a = `${o}${l.join("/")}${l.length ? "/" : ""}${d}`;
  if (a.length <= e) return a;
  const u = d.split(/\.(?=[^\.]+$)/), f = u[0] ?? "", g = u[1] ?? "", h = f.length > 10 ? `${f.slice(0, 6)}...${f.slice(-5)}` : f, v = g ? `${h}.${g}` : h;
  return a = `${o}${l.join("/")}${l.length ? "/" : ""}${v}`, a.length > e && (a = `${o}.../${v}`), a;
}
const _a = { class: "vuefinder__move-modal__content" }, ha = { class: "vuefinder__move-modal__description" }, pa = { class: "vuefinder__move-modal__files vf-scrollbar" }, ma = { class: "vuefinder__move-modal__file-name" }, ga = { class: "vuefinder__move-modal__target-title" }, wa = { class: "vuefinder__move-modal__target-container" }, ya = { class: "vuefinder__move-modal__target-path" }, ba = { class: "vuefinder__move-modal__target-storage" }, ka = {
  key: 0,
  class: "vuefinder__move-modal__destination-folder"
}, xa = { class: "vuefinder__move-modal__target-badge" }, $a = {
  key: 0,
  class: "vuefinder__move-modal__options"
}, Sa = { class: "vuefinder__move-modal__checkbox-label" }, Ca = { class: "vuefinder__move-modal__checkbox-text" }, Fa = ["disabled"], Ea = ["disabled"], Da = { class: "vuefinder__move-modal__selected-items" }, Vo = /* @__PURE__ */ le({
  __name: "ModalTransfer",
  props: {
    copy: { type: Boolean }
  },
  setup(n) {
    const e = fe(), t = Ne(e), { enabled: o } = st(), { t: r } = e.i18n, l = n, d = z(e.modal.data.items.from), a = z(e.modal.data.items.to), u = z(""), f = z(!1), g = z(l.copy || !o("move")), h = B(() => g.value ? "copy" : "move"), v = z(!1), x = Z(e.fs.path), y = B(() => g.value ? r("Copy files") : r("Move files")), m = B(
      () => g.value ? r("Are you sure you want to copy these files?") : r("Are you sure you want to move these files?")
    ), b = B(() => g.value ? r("Yes, Copy!") : r("Yes, Move!"));
    B(() => g.value ? r("Files copied.") : r("Files moved."));
    const I = (E) => {
      E && (a.value = E);
    }, L = (E) => {
      E && (a.value = E, v.value = !1);
    }, S = B(() => {
      const E = a.value;
      return E ? d.value.some((P) => jt(P, E.path)) : !0;
    }), p = B(() => {
      if (!S.value)
        return "";
      const E = a.value;
      return E ? d.value.find(
        (N) => jt(N, E.path)
      ) ? r("Cannot move/copy item to itself or its parent/child directory") : r("Invalid destination directory") : r("Please select a destination directory");
    }), F = () => {
      const E = a.value.path;
      if (!E) return { storage: "local", path: "" };
      if (E.endsWith("://"))
        return { storage: E.replace("://", ""), path: "" };
      const P = E.split("://");
      return {
        storage: P[0] || "local",
        path: P[1] || ""
      };
    }, C = async () => {
      if (!(!d.value.length || f.value)) {
        f.value = !0;
        try {
          const { files: E } = await e.adapter[h.value]({
            path: x.value.path,
            sources: d.value.map(_t),
            destination: a.value.path
          });
          e.fs.setFiles(E), h.value === "move" && e.modal.data.clearClipboardOnSuccess && e.fs.clearClipboard(), e.modal.close();
        } catch (E) {
          t.error(Ae(E, r("Failed to transfer files"), r));
        } finally {
          f.value = !1;
        }
      }
    };
    return (E, P) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: S.value || f.value,
          onClick: C
        }, w(b.value), 9, Fa),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: f.value,
          onClick: P[4] || (P[4] = (N) => s(e).modal.close())
        }, w(s(r)("Cancel")), 9, Ea),
        i("div", Da, w(s(r)("%s item(s) selected.", d.value.length)), 1)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: g.value ? s(Tt) : s(Ro),
            title: y.value
          }, null, 8, ["icon", "title"]),
          i("div", _a, [
            i("p", ha, w(m.value), 1),
            i("div", pa, [
              (c(!0), _(he, null, ke(d.value, (N) => (c(), _("div", {
                key: N.path,
                class: "vuefinder__move-modal__file"
              }, [
                i("div", null, [
                  j(wt, {
                    item: N,
                    small: "",
                    view: "list"
                  }, null, 8, ["item"])
                ]),
                i("div", ma, w(N.path), 1)
              ]))), 128))
            ]),
            i("h4", ga, w(s(r)("Target Directory")), 1),
            i("div", wa, [
              i("div", {
                class: "vuefinder__move-modal__target-display",
                onClick: P[0] || (P[0] = (N) => v.value = !v.value)
              }, [
                i("div", ya, [
                  i("span", ba, w(F().storage) + "://", 1),
                  F().path ? (c(), _("span", ka, w(F().path), 1)) : V("", !0)
                ]),
                i("span", xa, w(s(r)("Browse")), 1)
              ])
            ]),
            i("div", {
              class: re([
                "vuefinder__move-modal__tree-selector",
                v.value ? "vuefinder__move-modal__tree-selector--expanded" : "vuefinder__move-modal__tree-selector--collapsed"
              ])
            }, [
              j(Un, {
                modelValue: a.value,
                "onUpdate:modelValue": [
                  P[1] || (P[1] = (N) => a.value = N),
                  I
                ],
                "show-pinned-folders": !0,
                onSelectAndClose: L
              }, null, 8, ["modelValue"])
            ], 2),
            s(o)("copy") && s(o)("move") ? (c(), _("div", $a, [
              i("label", Sa, [
                xe(i("input", {
                  "onUpdate:modelValue": P[2] || (P[2] = (N) => g.value = N),
                  type: "checkbox",
                  class: "vuefinder__move-modal__checkbox"
                }, null, 512), [
                  [Wt, g.value]
                ]),
                i("span", Ca, w(s(r)("Create a copy instead of moving")), 1)
              ])
            ])) : V("", !0),
            p.value ? (c(), Y(Cn, {
              key: 1,
              error: ""
            }, {
              default: ae(() => [
                ye(w(p.value), 1)
              ]),
              _: 1
            })) : V("", !0),
            u.value.length && !p.value ? (c(), Y(Cn, {
              key: 2,
              error: "",
              onHidden: P[3] || (P[3] = (N) => u.value = "")
            }, {
              default: ae(() => [
                ye(w(u.value), 1)
              ]),
              _: 1
            })) : V("", !0)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), dt = /* @__PURE__ */ le({
  __name: "ModalMove",
  setup(n) {
    return (e, t) => (c(), Y(Vo, { copy: !1 }));
  }
}), tn = /* @__PURE__ */ le({
  __name: "ModalCopy",
  setup(n) {
    return (e, t) => (c(), Y(Vo, { copy: !0 }));
  }
});
function kt(n) {
  const e = (o) => ({
    item: o,
    defaultPrevented: !1,
    preventDefault() {
      this.defaultPrevented = !0;
    }
  });
  return {
    createCancelableEvent: e,
    openItem: (o, r, l) => {
      const d = e(o);
      if (o.type === "file") {
        n.emitter.emit("vf-file-dclick", d);
        return;
      }
      if (o.type === "dir") {
        if (n.emitter.emit("vf-folder-dclick", d), d.defaultPrevented)
          return;
        n.adapter.open(o.path);
      }
    }
  };
}
const Pa = (n, e = 0, t = !1) => {
  let o;
  return (...r) => {
    t && !o && n(...r), clearTimeout(o), o = setTimeout(() => {
      n(...r);
    }, e);
  };
}, Bo = (n, e, t) => {
  const o = z(n);
  return cs((r, l) => ({
    get() {
      return r(), o.value;
    },
    set: Pa(
      (d) => {
        o.value = d, l();
      },
      e,
      !1
    )
  }));
}, Ia = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Ta(n, e) {
  return c(), _("svg", Ia, [...e[0] || (e[0] = [
    i("circle", {
      cx: "11",
      cy: "11",
      r: "7"
    }, null, -1),
    i("path", { d: "m20 20-4-4" }, null, -1)
  ])]);
}
const Hn = { render: Ta }, Ma = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "animate-spin p-0.5 h-5 w-5 text-white ml-auto",
  viewBox: "0 0 24 24"
};
function Aa(n, e) {
  return c(), _("svg", Ma, [...e[0] || (e[0] = [
    i("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4",
      class: "opacity-25 stroke-blue-900"
    }, null, -1),
    i("path", {
      fill: "currentColor",
      d: "M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12zm2 5.291A7.96 7.96 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938z",
      class: "opacity-75"
    }, null, -1)
  ])]);
}
const nn = { render: Aa }, Oa = { class: "vuefinder__search-modal__search-input" }, za = ["value", "placeholder", "disabled"], Ra = {
  key: 0,
  class: "vuefinder__search-modal__loading"
}, La = /* @__PURE__ */ le({
  name: "SearchInput",
  __name: "SearchInput",
  props: {
    modelValue: {},
    isSearching: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "keydown"],
  setup(n, { expose: e, emit: t }) {
    const o = t, r = fe(), { t: l } = r.i18n, d = z(null), a = (f) => {
      const g = f.target;
      o("update:modelValue", g.value);
    }, u = (f) => {
      o("keydown", f);
    };
    return e({
      focus: () => {
        d.value && d.value.focus();
      }
    }), (f, g) => (c(), _("div", Oa, [
      j(s(Hn), { class: "vuefinder__search-modal__search-icon" }),
      i("input", {
        ref_key: "searchInput",
        ref: d,
        value: n.modelValue,
        type: "text",
        placeholder: s(l)("Search files"),
        disabled: n.disabled,
        class: "vuefinder__search-modal__input",
        onKeydown: u,
        onKeyup: g[0] || (g[0] = ge(() => {
        }, ["stop"])),
        onInput: a
      }, null, 40, za),
      n.isSearching ? (c(), _("div", Ra, [
        j(s(nn), { class: "vuefinder__search-modal__loading-icon" })
      ])) : V("", !0)
    ]));
  }
}), Va = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function Ba(n, e) {
  return c(), _("svg", Va, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87q.11.06.22.127c.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a8 8 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a7 7 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a7 7 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a7 7 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124q.108-.066.22-.128c.332-.183.582-.495.644-.869z"
    }, null, -1),
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    }, null, -1)
  ])]);
}
const No = { render: Ba }, Na = ["disabled", "title"], Ua = ["data-theme"], Ha = { class: "vuefinder__search-modal__dropdown-content" }, Ka = { class: "vuefinder__search-modal__dropdown-section" }, ja = { class: "vuefinder__search-modal__dropdown-title" }, qa = { class: "vuefinder__search-modal__dropdown-options" }, Ga = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Wa = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Ya = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Qa = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Xa = /* @__PURE__ */ le({
  name: "SearchOptionsDropdown",
  __name: "SearchOptionsDropdown",
  props: {
    visible: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    sizeFilter: {},
    selectedOption: {}
  },
  emits: ["update:visible", "update:sizeFilter", "update:selectedOption", "keydown"],
  setup(n, { expose: e, emit: t }) {
    const o = n, r = t, l = fe(), { t: d } = l.i18n, a = z(null), u = z(null);
    let f = null;
    const g = (m) => {
      if (r("update:selectedOption", m), m.startsWith("size-")) {
        const b = m.split("-")[1];
        r("update:sizeFilter", b);
      }
    }, h = async () => {
      o.disabled || (o.visible ? (r("update:visible", !1), f && (f(), f = null)) : (r("update:visible", !0), await Ve(), await v()));
    }, v = async () => {
      if (!(!a.value || !u.value) && (await Ve(), !(!a.value || !u.value))) {
        Object.assign(u.value.style, {
          position: "fixed",
          zIndex: "10001",
          opacity: "0",
          transform: "translateY(-8px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out"
        });
        try {
          const { x: m, y: b } = await lt(a.value, u.value, {
            placement: "bottom-start",
            strategy: "fixed",
            middleware: [pt(8), mt({ padding: 16 }), gt({ padding: 16 })]
          });
          Object.assign(u.value.style, {
            left: `${m}px`,
            top: `${b}px`
          }), requestAnimationFrame(() => {
            u.value && Object.assign(u.value.style, {
              opacity: "1",
              transform: "translateY(0)"
            });
          });
        } catch (m) {
          console.warn("Floating UI initial positioning error:", m);
          return;
        }
        try {
          f = Tn(a.value, u.value, async () => {
            if (!(!a.value || !u.value))
              try {
                const { x: m, y: b } = await lt(
                  a.value,
                  u.value,
                  {
                    placement: "bottom-start",
                    strategy: "fixed",
                    middleware: [pt(8), mt({ padding: 16 }), gt({ padding: 16 })]
                  }
                );
                Object.assign(u.value.style, {
                  left: `${m}px`,
                  top: `${b}px`
                });
              } catch (m) {
                console.warn("Floating UI positioning error:", m);
              }
          });
        } catch (m) {
          console.warn("Floating UI autoUpdate setup error:", m), f = null;
        }
      }
    }, x = (m) => {
      if (!o.visible) return;
      const b = ["size-all", "size-small", "size-medium", "size-large"], I = b.findIndex((L) => L === o.selectedOption);
      if (m.key === "ArrowDown") {
        m.preventDefault();
        const L = (I + 1) % b.length;
        r("update:selectedOption", b[L] || null);
      } else if (m.key === "ArrowUp") {
        m.preventDefault();
        const L = I <= 0 ? b.length - 1 : I - 1;
        r("update:selectedOption", b[L] || null);
      } else m.key === "Enter" ? (m.preventDefault(), o.selectedOption?.startsWith("size-") && r(
        "update:sizeFilter",
        o.selectedOption.split("-")[1]
      )) : m.key === "Escape" && (m.preventDefault(), r("update:visible", !1), f && (f(), f = null));
    }, y = () => {
      f && (f(), f = null);
    };
    return me(
      () => o.visible,
      (m) => {
        !m && f && (f(), f = null);
      }
    ), Te(() => {
      y();
    }), e({
      cleanup: y
    }), (m, b) => (c(), _(he, null, [
      i("button", {
        ref_key: "dropdownBtn",
        ref: a,
        class: re(["vuefinder__search-modal__dropdown-btn", { "vuefinder__search-modal__dropdown-btn--active": n.visible }]),
        disabled: n.disabled,
        title: s(d)("Search Options"),
        onClick: ge(h, ["stop"])
      }, [
        j(s(No), { class: "vuefinder__search-modal__dropdown-icon" })
      ], 10, Na),
      (c(), Y(Et, { to: "body" }, [
        n.visible ? (c(), _("div", {
          key: 0,
          ref_key: "dropdownContent",
          ref: u,
          class: "vuefinder__themer vuefinder__search-modal__dropdown vuefinder__search-modal__dropdown--visible",
          "data-theme": s(l).theme.current,
          tabindex: "-1",
          onClick: b[4] || (b[4] = ge(() => {
          }, ["stop"])),
          onKeydown: x
        }, [
          i("div", Ha, [
            i("div", Ka, [
              i("div", ja, w(s(d)("File Size")), 1),
              i("div", qa, [
                i("div", {
                  class: re(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": n.sizeFilter === "all"
                  }]),
                  onClick: b[0] || (b[0] = ge((I) => g("size-all"), ["stop"]))
                }, [
                  i("span", null, w(s(d)("All Files")), 1),
                  n.sizeFilter === "all" ? (c(), _("div", Ga, [...b[5] || (b[5] = [
                    i("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      i("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : V("", !0)
                ], 2),
                i("div", {
                  class: re(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": n.sizeFilter === "small"
                  }]),
                  onClick: b[1] || (b[1] = ge((I) => g("size-small"), ["stop"]))
                }, [
                  i("span", null, w(s(d)("Small (< 1MB)")), 1),
                  n.sizeFilter === "small" ? (c(), _("div", Wa, [...b[6] || (b[6] = [
                    i("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      i("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : V("", !0)
                ], 2),
                i("div", {
                  class: re(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": n.sizeFilter === "medium"
                  }]),
                  onClick: b[2] || (b[2] = ge((I) => g("size-medium"), ["stop"]))
                }, [
                  i("span", null, w(s(d)("Medium (1-10MB)")), 1),
                  n.sizeFilter === "medium" ? (c(), _("div", Ya, [...b[7] || (b[7] = [
                    i("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      i("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : V("", !0)
                ], 2),
                i("div", {
                  class: re(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": n.sizeFilter === "large"
                  }]),
                  onClick: b[3] || (b[3] = ge((I) => g("size-large"), ["stop"]))
                }, [
                  i("span", null, w(s(d)("Large (> 10MB)")), 1),
                  n.sizeFilter === "large" ? (c(), _("div", Qa, [...b[8] || (b[8] = [
                    i("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      i("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : V("", !0)
                ], 2)
              ])
            ])
          ])
        ], 40, Ua)) : V("", !0)
      ]))
    ], 64));
  }
});
async function Uo(n) {
  try {
    await navigator.clipboard.writeText(n);
  } catch {
    const e = document.createElement("textarea");
    e.value = n, document.body.appendChild(e), e.select(), document.execCommand("copy"), document.body.removeChild(e);
  }
}
async function on(n, e) {
  if (e.length) {
    if (n.copyPath) {
      await n.copyPath(e);
      return;
    }
    await Uo(e.map((t) => t.path).join(`
`)), Ne(n).success(n.i18n.t("Path copied to clipboard"));
  }
}
function Ho(n) {
  const { path: e, storage: t } = n.fs.path.get();
  return {
    id: e,
    path: e,
    storage: t,
    type: "dir",
    basename: e.split("/").pop() || e,
    dir: "",
    extension: "",
    file_size: null,
    last_modified: null,
    mime_type: null
  };
}
async function Ja(n) {
  await Uo(n);
}
const Za = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function el(n, e) {
  return c(), _("svg", Za, [...e[0] || (e[0] = [
    i("circle", {
      cx: "5",
      cy: "12",
      r: "1",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    i("circle", {
      cx: "12",
      cy: "12",
      r: "1",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    i("circle", {
      cx: "19",
      cy: "12",
      r: "1",
      fill: "currentColor",
      stroke: "none"
    }, null, -1)
  ])]);
}
const sn = { render: el }, tl = ["title"], nl = { class: "vuefinder__search-modal__result-icon" }, ol = { class: "vuefinder__search-modal__result-content" }, sl = {
  key: 0,
  class: "vuefinder__search-modal__result-size"
}, il = ["title"], rl = ["title"], al = ["data-item-dropdown", "data-theme"], ll = { class: "vuefinder__search-modal__item-dropdown-content" }, dl = /* @__PURE__ */ le({
  name: "SearchResultItem",
  __name: "SearchResultItem",
  props: {
    item: {},
    index: {},
    selectedIndex: {},
    expandedPaths: {},
    activeDropdown: {},
    selectedItemDropdownOption: {}
  },
  emits: ["select", "selectWithDropdown", "togglePathExpansion", "toggleItemDropdown", "update:selectedItemDropdownOption", "copyPath", "openContainingFolder", "preview"],
  setup(n, { emit: e }) {
    const t = n, o = e, r = fe(), { t: l } = r.i18n, d = z(null);
    let a = null, u = null, f = [], g = null;
    me(
      () => t.activeDropdown,
      (E) => {
        a && (a(), a = null), u && (f.forEach((P) => {
          P === window ? window.removeEventListener("scroll", u, !0) : P.removeEventListener("scroll", u, !0);
        }), u = null, f = []), g && (document.removeEventListener("mousedown", g, !0), document.removeEventListener("touchstart", g, !0), g = null), E === t.item.path && d.value && Ve(() => {
          I(t.item.path, d.value), v(), x();
        });
      }
    );
    const h = (E) => {
      const P = [];
      let N = E;
      for (; N && N !== document.body && N !== document.documentElement; ) {
        const te = window.getComputedStyle(N), W = te.overflow + te.overflowX + te.overflowY;
        (W.includes("scroll") || W.includes("auto")) && P.push(N), N = N.parentElement;
      }
      return P;
    }, v = () => {
      if (t.activeDropdown !== t.item.path) return;
      const E = h(d.value);
      f = [window, ...E], u = () => {
        t.activeDropdown === t.item.path && o("toggleItemDropdown", t.item.path, new MouseEvent("click"));
      };
      const P = u;
      P && f.forEach((N) => {
        N === window ? window.addEventListener("scroll", P, !0) : N.addEventListener("scroll", P, !0);
      });
    }, x = () => {
      t.activeDropdown === t.item.path && (g = (E) => {
        if (t.activeDropdown !== t.item.path) return;
        const P = E.target;
        if (!P) return;
        const N = document.querySelector(
          `[data-item-dropdown="${t.item.path}"]`
        );
        if (N && N.contains(P) || d.value && d.value.contains(P))
          return;
        const te = r.root;
        if (te && te.contains(P)) {
          o("toggleItemDropdown", t.item.path, new MouseEvent("click"));
          return;
        }
        const W = document.querySelector(".vuefinder__modal-layout");
        if (W && W.contains(P)) {
          o("toggleItemDropdown", t.item.path, new MouseEvent("click"));
          return;
        }
        o("toggleItemDropdown", t.item.path, new MouseEvent("click"));
      }, setTimeout(() => {
        g && (document.addEventListener("mousedown", g, !0), document.addEventListener("touchstart", g, !0));
      }, 100));
    };
    Te(() => {
      a && (a(), a = null), u && (f.forEach((E) => {
        E === window ? window.removeEventListener("scroll", u, !0) : E.removeEventListener("scroll", u, !0);
      }), u = null, f = []), g && (document.removeEventListener("mousedown", g, !0), document.removeEventListener("touchstart", g, !0), g = null);
    });
    const y = (E) => t.expandedPaths.has(E), m = (E) => E.type === "dir" || !E.file_size ? "" : Yt(E.file_size), b = (E, P) => {
      P.stopPropagation(), o("toggleItemDropdown", E, P);
    }, I = async (E, P) => {
      const N = document.querySelector(
        `[data-item-dropdown="${E}"]`
      );
      if (!(!N || !P) && (await Ve(), !(!N || !P))) {
        Object.assign(N.style, {
          position: "fixed",
          zIndex: "10001",
          opacity: "0",
          transform: "translateY(-8px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out"
        });
        try {
          const { x: te, y: W } = await lt(P, N, {
            placement: "left-start",
            strategy: "fixed",
            middleware: [pt(8), mt({ padding: 16 }), gt({ padding: 16 })]
          });
          Object.assign(N.style, {
            left: `${te}px`,
            top: `${W}px`
          }), requestAnimationFrame(() => {
            N && Object.assign(N.style, {
              opacity: "1",
              transform: "translateY(0)"
            });
          });
        } catch (te) {
          console.warn("Floating UI initial positioning error:", te);
          return;
        }
        try {
          a = Tn(P, N, async () => {
            if (!(!P || !N))
              try {
                const { x: te, y: W } = await lt(P, N, {
                  placement: "left-start",
                  strategy: "fixed",
                  middleware: [pt(8), mt({ padding: 16 }), gt({ padding: 16 })]
                });
                Object.assign(N.style, {
                  left: `${te}px`,
                  top: `${W}px`
                });
              } catch (te) {
                console.warn("Floating UI positioning error:", te);
              }
          });
        } catch (te) {
          console.warn("Floating UI autoUpdate setup error:", te), a = null;
        }
      }
    }, L = (E) => {
      o("update:selectedItemDropdownOption", E);
    }, S = async (E) => {
      await on(r, [E]), o("copyPath", E);
    }, p = (E) => {
      o("openContainingFolder", E);
    }, F = (E) => {
      o("preview", E);
    }, C = (E) => {
      if (!t.activeDropdown) return;
      const P = ["copy-path", "open-folder", "preview"], N = t.selectedItemDropdownOption, te = P.findIndex((W) => N?.includes(W));
      if (E.key === "ArrowDown") {
        E.preventDefault();
        const W = (te + 1) % P.length;
        o(
          "update:selectedItemDropdownOption",
          `${P[W] || ""}-${t.activeDropdown}`
        );
      } else if (E.key === "ArrowUp") {
        E.preventDefault();
        const W = te <= 0 ? P.length - 1 : te - 1;
        o(
          "update:selectedItemDropdownOption",
          `${P[W] || ""}-${t.activeDropdown}`
        );
      } else E.key === "Enter" ? (E.preventDefault(), N && (N.includes("copy-path") ? S(t.item) : N.includes("open-folder") ? p(t.item) : N.includes("preview") && F(t.item))) : E.key === "Escape" && (E.preventDefault(), o("update:selectedItemDropdownOption", null));
    };
    return (E, P) => (c(), _("div", {
      class: re(["vuefinder__search-modal__result-item", { "vuefinder__search-modal__result-item--selected": n.index === n.selectedIndex }]),
      title: n.item.basename
    }, [
      i("div", nl, [
        j(wt, {
          item: n.item,
          small: "",
          view: "list"
        }, null, 8, ["item"])
      ]),
      i("div", ol, [
        i("div", {
          class: "vuefinder__search-modal__result-name vuefinder__search-modal__result-name--link",
          onClick: P[0] || (P[0] = ge((N) => {
            o("select", n.index), F(n.item);
          }, ["stop"]))
        }, [
          ye(w(n.item.basename) + " ", 1),
          m(n.item) ? (c(), _("span", sl, w(m(n.item)), 1)) : V("", !0)
        ]),
        i("div", {
          class: "vuefinder__search-modal__result-path",
          title: n.item.path,
          onClick: P[1] || (P[1] = ge((N) => {
            o("select", n.index), S(n.item);
          }, ["stop"]))
        }, w(y(n.item.path) ? n.item.path : s(Lo)(n.item.path)), 9, il)
      ]),
      i("button", {
        ref_key: "buttonElementRef",
        ref: d,
        class: "vuefinder__search-modal__result-actions",
        title: s(l)("More actions"),
        onClick: P[2] || (P[2] = (N) => {
          o("selectWithDropdown", n.index), b(n.item.path, N);
        })
      }, [
        j(s(sn), { class: "vuefinder__search-modal__result-actions-icon" })
      ], 8, rl),
      (c(), Y(Et, { to: "body" }, [
        n.activeDropdown === n.item.path ? (c(), _("div", {
          key: 0,
          "data-item-dropdown": n.item.path,
          class: "vuefinder__themer vuefinder__search-modal__item-dropdown vuefinder__search-modal__item-dropdown--visible",
          "data-theme": s(r).theme.current,
          tabindex: "-1",
          onClick: P[9] || (P[9] = ge(() => {
          }, ["stop"])),
          onKeydown: C
        }, [
          i("div", ll, [
            i("div", {
              class: re(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": n.selectedItemDropdownOption === `copy-path-${n.item.path}`
              }]),
              onClick: P[3] || (P[3] = (N) => {
                L(`copy-path-${n.item.path}`), S(n.item);
              }),
              onFocus: P[4] || (P[4] = (N) => L(`copy-path-${n.item.path}`))
            }, [
              j(s(Tt), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              i("span", null, w(s(l)("Copy Path")), 1)
            ], 34),
            i("div", {
              class: re(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": n.selectedItemDropdownOption === `open-folder-${n.item.path}`
              }]),
              onClick: P[5] || (P[5] = (N) => {
                L(`open-folder-${n.item.path}`), p(n.item);
              }),
              onFocus: P[6] || (P[6] = (N) => L(`open-folder-${n.item.path}`))
            }, [
              j(s(et), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              i("span", null, w(s(l)("Open Containing Folder")), 1)
            ], 34),
            i("div", {
              class: re(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": n.selectedItemDropdownOption === `preview-${n.item.path}`
              }]),
              onClick: P[7] || (P[7] = (N) => {
                L(`preview-${n.item.path}`), F(n.item);
              }),
              onFocus: P[8] || (P[8] = (N) => L(`preview-${n.item.path}`))
            }, [
              j(s(Rn), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              i("span", null, w(s(l)("Open")), 1)
            ], 34)
          ])
        ], 40, al)) : V("", !0)
      ]))
    ], 10, tl));
  }
}), cl = {
  key: 0,
  class: "vuefinder__search-modal__searching"
}, ul = { class: "vuefinder__search-modal__loading-icon" }, fl = {
  key: 1,
  class: "vuefinder__search-modal__no-results"
}, vl = {
  key: 2,
  class: "vuefinder__search-modal__results-list"
}, _l = { class: "vuefinder__search-modal__results-header" }, rt = 60, so = 5, hl = /* @__PURE__ */ le({
  name: "SearchResultsList",
  __name: "SearchResultsList",
  props: {
    searchResults: {},
    isSearching: { type: Boolean },
    selectedIndex: {},
    expandedPaths: {},
    activeDropdown: {},
    selectedItemDropdownOption: {},
    resultsEnter: { type: Boolean }
  },
  emits: ["selectResultItem", "selectResultItemWithDropdown", "togglePathExpansion", "toggleItemDropdown", "update:selectedItemDropdownOption", "copyPath", "openContainingFolder", "preview"],
  setup(n, { expose: e, emit: t }) {
    const o = n, r = t, l = fe(), { t: d } = l.i18n, a = Ft("scrollableContainer"), u = B(() => o.searchResults.length > 0), f = B(() => o.searchResults.length), g = z(0), h = z(600), v = B(() => o.searchResults.length * rt), x = B(() => {
      const S = Math.max(0, Math.floor(g.value / rt) - so), p = Math.min(
        o.searchResults.length,
        Math.ceil((g.value + h.value) / rt) + so
      );
      return { start: S, end: p };
    }), y = B(() => {
      const { start: S, end: p } = x.value;
      return o.searchResults.slice(S, p).map((F, C) => ({
        item: F,
        index: S + C,
        top: (S + C) * rt
      }));
    }), m = (S) => {
      const p = S.target;
      g.value = p.scrollTop;
    }, b = () => {
      a.value && (h.value = a.value.clientHeight);
    }, I = () => {
      if (o.selectedIndex >= 0 && a.value) {
        const S = o.selectedIndex * rt, p = S + rt, F = a.value.scrollTop, C = a.value.clientHeight, E = F + C;
        let P = F;
        S < F ? P = S : p > E && (P = p - C), P !== F && a.value.scrollTo({
          top: P,
          behavior: "smooth"
        });
      }
    }, L = () => {
      a.value && (a.value.scrollTop = 0, g.value = 0);
    };
    return Fe(() => {
      b(), window.addEventListener("resize", b);
    }), Te(() => {
      window.removeEventListener("resize", b);
    }), me(
      () => a.value,
      () => {
        b();
      }
    ), e({
      scrollSelectedIntoView: I,
      resetScroll: L,
      getContainerHeight: () => h.value,
      scrollTop: () => g.value
    }), (S, p) => (c(), _("div", {
      class: re(["vuefinder__search-modal__results", { "vuefinder__search-modal__results--enter": n.resultsEnter }])
    }, [
      n.isSearching ? (c(), _("div", cl, [
        i("div", ul, [
          j(s(nn), { class: "vuefinder__search-modal__loading-icon" })
        ]),
        i("span", null, w(s(d)("Searching...")), 1)
      ])) : u.value ? (c(), _("div", vl, [
        i("div", _l, [
          i("span", null, w(s(d)("Found %s results", f.value)), 1)
        ]),
        i("div", {
          ref_key: "scrollableContainer",
          ref: a,
          class: "vuefinder__search-modal__results-scrollable",
          onScroll: m
        }, [
          i("div", {
            class: "vuefinder__search-modal__results-items",
            style: Be({ height: `${v.value}px`, position: "relative" })
          }, [
            (c(!0), _(he, null, ke(y.value, (F) => (c(), _("div", {
              key: F.item.path,
              style: Be({
                position: "absolute",
                top: `${F.top}px`,
                left: "0",
                width: "100%",
                height: `${rt}px`
              })
            }, [
              j(dl, {
                item: F.item,
                index: F.index,
                "selected-index": n.selectedIndex,
                "expanded-paths": n.expandedPaths,
                "active-dropdown": n.activeDropdown,
                "selected-item-dropdown-option": n.selectedItemDropdownOption,
                onSelect: p[0] || (p[0] = (C) => r("selectResultItem", C)),
                onSelectWithDropdown: p[1] || (p[1] = (C) => r("selectResultItemWithDropdown", C)),
                onTogglePathExpansion: p[2] || (p[2] = (C) => r("togglePathExpansion", C)),
                onToggleItemDropdown: p[3] || (p[3] = (C, E) => r("toggleItemDropdown", C, E)),
                "onUpdate:selectedItemDropdownOption": p[4] || (p[4] = (C) => r("update:selectedItemDropdownOption", C)),
                onCopyPath: p[5] || (p[5] = (C) => r("copyPath", C)),
                onOpenContainingFolder: p[6] || (p[6] = (C) => r("openContainingFolder", C)),
                onPreview: p[7] || (p[7] = (C) => r("preview", C))
              }, null, 8, ["item", "index", "selected-index", "expanded-paths", "active-dropdown", "selected-item-dropdown-option"])
            ], 4))), 128))
          ], 4)
        ], 544)
      ])) : (c(), _("div", fl, [
        i("span", null, w(s(d)("No results found")), 1)
      ]))
    ], 2));
  }
}), pl = { class: "vuefinder__search-modal" }, ml = { class: "vuefinder__search-modal__content" }, gl = { class: "vuefinder__search-modal__search-bar" }, wl = { class: "vuefinder__search-modal__search-location" }, yl = ["title"], bl = ["disabled"], kl = {
  key: 0,
  class: "vuefinder__search-modal__folder-selector"
}, xl = { class: "vuefinder__search-modal__folder-selector-content" }, $l = {
  key: 1,
  class: "vuefinder__search-modal__instructions"
}, Sl = { class: "vuefinder__search-modal__instructions-text" }, Kn = /* @__PURE__ */ le({
  name: "ModalSearch",
  __name: "ModalSearch",
  setup(n) {
    const e = fe(), t = Ne(e), { t: o } = e.i18n, r = e.fs, l = z(null), d = z(null), a = z(null), u = Bo("", 300), f = z([]), g = z(!1), h = z(-1), v = z(!1), x = z(!1), y = z(null), m = z("all"), b = z(!1), I = z(`size-${m.value}`), L = z(null), S = z(/* @__PURE__ */ new Set()), p = z(null), F = Z(r.path), C = (R) => {
      S.value.has(R) ? S.value.delete(R) : S.value.add(R);
    }, E = (R, D) => {
      D && typeof D.stopPropagation == "function" && D.stopPropagation(), p.value === R ? p.value = null : p.value = R;
    }, P = () => {
      p.value = null;
    }, N = (R) => {
      try {
        const D = R.dir || `${R.storage}://`;
        e.adapter.open(D), e.modal.close(), P();
      } catch {
        t.error(o("Failed to open containing folder"));
      }
    }, te = (R) => {
      P(), e.modal.close(), kt(e).openItem(R);
    }, W = (R) => {
      h.value = R, P();
    }, se = (R) => {
      h.value = R;
    }, $ = () => {
      P();
    };
    me(u, async (R) => {
      R.trim() ? (await k(R.trim()), h.value = 0) : (f.value = [], g.value = !1, h.value = -1);
    }), me(m, async (R) => {
      I.value = `size-${R}`, u.value.trim() && !x.value && (await k(u.value.trim()), h.value = 0);
    }), me(b, async () => {
      u.value.trim() && !x.value && (await k(u.value.trim()), h.value = 0);
    });
    const k = async (R) => {
      if (R) {
        g.value = !0;
        try {
          const D = y.value?.path || F?.value?.path, A = await e.adapter.search({
            path: D,
            filter: R,
            deep: b.value,
            size: m.value
          });
          f.value = A || [], g.value = !1;
        } catch (D) {
          t.error(Ae(D, o("Search failed"), o)), f.value = [], g.value = !1;
        }
      }
    };
    Fe(() => {
      document.addEventListener("click", pe), I.value = `size-${m.value}`;
    });
    const T = () => {
      x.value ? (x.value = !1, u.value.trim() && (k(u.value.trim()), h.value = 0)) : (v.value = !1, x.value = !0);
    }, M = (R) => {
      R && (y.value = R);
    }, q = (R) => {
      R && (M(R), x.value = !1, u.value.trim() && (k(u.value.trim()), h.value = 0));
    };
    Te(() => {
      document.removeEventListener("click", pe), d.value && d.value.cleanup();
    });
    const pe = (R) => {
      const D = R.target;
      if (v.value && (D.closest(".vuefinder__search-modal__dropdown") || (v.value = !1, Ve(() => {
        l.value && l.value.focus();
      }))), p.value) {
        const A = D.closest(".vuefinder__search-modal__item-dropdown"), H = D.closest(".vuefinder__search-modal__result-item");
        !A && !H && P();
      }
    };
    return (R, D) => (c(), Y(Re, { class: "vuefinder__search-modal-layout" }, {
      default: ae(() => [
        i("div", pl, [
          j(Le, {
            icon: s(Hn),
            title: s(o)("Search files")
          }, null, 8, ["icon", "title"]),
          i("div", ml, [
            i("div", gl, [
              j(La, {
                ref_key: "searchInputRef",
                ref: l,
                modelValue: s(u),
                "onUpdate:modelValue": D[0] || (D[0] = (A) => us(u) ? u.value = A : null),
                "is-searching": g.value,
                disabled: x.value
              }, null, 8, ["modelValue", "is-searching", "disabled"]),
              j(Xa, {
                ref_key: "searchOptionsDropdownRef",
                ref: d,
                visible: v.value,
                "onUpdate:visible": D[1] || (D[1] = (A) => v.value = A),
                "size-filter": m.value,
                "onUpdate:sizeFilter": D[2] || (D[2] = (A) => m.value = A),
                "selected-option": I.value,
                "onUpdate:selectedOption": D[3] || (D[3] = (A) => I.value = A),
                disabled: x.value
              }, null, 8, ["visible", "size-filter", "selected-option", "disabled"])
            ]),
            i("div", {
              class: "vuefinder__search-modal__options",
              onClick: D[7] || (D[7] = ge(() => {
              }, ["stop"]))
            }, [
              i("div", wl, [
                i("button", {
                  class: re(["vuefinder__search-modal__location-btn", { "vuefinder__search-modal__location-btn--open": x.value }]),
                  onClick: ge(T, ["stop"])
                }, [
                  j(s(et), { class: "vuefinder__search-modal__location-icon" }),
                  i("span", {
                    class: "vuefinder__search-modal__location-text",
                    title: y.value?.path || s(F).path
                  }, w(s(Lo)(y.value?.path || s(F).path)), 9, yl),
                  D[10] || (D[10] = i("svg", {
                    class: "vuefinder__search-modal__location-arrow",
                    viewBox: "0 0 16 16",
                    fill: "currentColor"
                  }, [
                    i("path", { d: "M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z" })
                  ], -1))
                ], 2)
              ]),
              i("label", {
                class: "vuefinder__search-modal__deep-search",
                onClick: D[6] || (D[6] = ge(() => {
                }, ["stop"]))
              }, [
                xe(i("input", {
                  "onUpdate:modelValue": D[4] || (D[4] = (A) => b.value = A),
                  type: "checkbox",
                  disabled: x.value,
                  class: "vuefinder__search-modal__checkbox",
                  onClick: D[5] || (D[5] = ge(() => {
                  }, ["stop"]))
                }, null, 8, bl), [
                  [Wt, b.value]
                ]),
                i("span", null, w(s(o)("Include subfolders")), 1)
              ])
            ]),
            x.value ? (c(), _("div", kl, [
              i("div", xl, [
                j(Un, {
                  modelValue: y.value,
                  "onUpdate:modelValue": [
                    D[8] || (D[8] = (A) => y.value = A),
                    M
                  ],
                  "show-pinned-folders": !0,
                  "current-path": s(F),
                  onSelectAndClose: q
                }, null, 8, ["modelValue", "current-path"])
              ])
            ])) : V("", !0),
            !s(u).trim() && !x.value ? (c(), _("div", $l, [
              i("p", Sl, w(s(o)("Start typing to search files. Use options to filter or include subfolders.")), 1)
            ])) : V("", !0),
            s(u).trim() && !x.value ? (c(), Y(hl, {
              key: 2,
              ref_key: "searchResultsListRef",
              ref: a,
              "search-results": f.value,
              "is-searching": g.value,
              "selected-index": h.value,
              "expanded-paths": S.value,
              "active-dropdown": p.value,
              "selected-item-dropdown-option": L.value,
              "results-enter": !0,
              onSelectResultItem: W,
              onSelectResultItemWithDropdown: se,
              onTogglePathExpansion: C,
              onToggleItemDropdown: E,
              "onUpdate:selectedItemDropdownOption": D[9] || (D[9] = (A) => L.value = A),
              onCopyPath: $,
              onOpenContainingFolder: N,
              onPreview: te
            }, null, 8, ["search-results", "is-searching", "selected-index", "expanded-paths", "active-dropdown", "selected-item-dropdown-option"])) : V("", !0)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Oe = {
  ESCAPE: "Escape",
  DELETE: "Delete",
  ENTER: "Enter",
  BACKSLASH: "Backslash",
  KEY_A: "KeyA",
  KEY_E: "KeyE",
  KEY_F: "KeyF",
  SPACE: "Space",
  KEY_C: "KeyC",
  KEY_X: "KeyX",
  KEY_V: "KeyV",
  KEY_R: "KeyR",
  F2: "F2"
};
function Cl() {
  const n = fe(), e = Ne(n), t = n.fs, o = n.config, { enabled: r } = st(), { openItem: l } = kt(n), d = Z(t.path), a = Z(t.selectedItems), u = (v) => v.metaKey || v.ctrlKey, f = () => !t.getReadOnly() && !a.value.some((v) => t.isReadOnly(v)), g = () => !t.getReadOnly() && !t.isReadOnlyPath(t.path.get().path), h = (v) => {
    if (v.code === Oe.ESCAPE && (n.modal.close(), n.root.focus()), n.modal.visible) return;
    if (u(v) && v.code === Oe.KEY_R && !v.shiftKey && (n.adapter.invalidateListQuery(d.value.path), n.adapter.open(d.value.path), v.preventDefault()), (v.code === Oe.F2 || u(v) && v.shiftKey && v.code === Oe.KEY_R) && r("rename") && f() && a.value.length === 1 && (n.modal.open(Zt, { items: a.value }), v.preventDefault()), v.code === Oe.DELETE && r("delete") && f() && a.value.length !== 0 && n.modal.open(Jt, { items: a.value }), u(v) && v.code === Oe.BACKSLASH && n.modal.open(Co), u(v) && v.code === Oe.KEY_F && r("search") && (n.modal.open(Kn), v.preventDefault()), u(v) && v.code === Oe.KEY_E && (o.toggle("showTreeView"), v.preventDefault()), u(v) && v.code === Oe.ENTER && r("fullscreen") && (o.toggle("fullScreen"), n.root.focus()), u(v) && v.code === Oe.KEY_A && (t.selectAll(n.selectionMode || "multiple", n), v.preventDefault()), v.code === Oe.SPACE) {
      const y = a.value.length === 1 ? a.value[0] : void 0;
      y?.type === "file" && (l(y), v.preventDefault());
    }
    if (u(v) && v.code === Oe.KEY_C && r("copy")) {
      if (a.value.length === 0) {
        e.error(n.i18n.t("No items selected"));
        return;
      }
      t.setClipboard("copy", new Set(a.value.map((y) => J(y)))), e.success(
        a.value.length === 1 ? n.i18n.t("Item copied to clipboard") : n.i18n.t("%s items copied to clipboard", a.value.length)
      ), v.preventDefault();
    }
    if (u(v) && v.code === Oe.KEY_X && r("copy") && f()) {
      if (a.value.length === 0) {
        e.error(n.i18n.t("No items selected"));
        return;
      }
      t.setClipboard("cut", new Set(a.value.map((y) => J(y)))), e.success(
        a.value.length === 1 ? n.i18n.t("Item cut to clipboard") : n.i18n.t("%s items cut to clipboard", a.value.length)
      ), v.preventDefault();
    }
    if (u(v) && v.code === Oe.KEY_V && r("copy") && g()) {
      if (t.getClipboard().items.size === 0) {
        e.error(n.i18n.t("No items in clipboard"));
        return;
      }
      if (t.getClipboard().path === t.path.get().path) {
        e.error(n.i18n.t("Cannot paste items to the same directory"));
        return;
      }
      if (t.getClipboard().type === "cut") {
        n.modal.open(dt, {
          items: { from: Array.from(t.getClipboard().items), to: t.path.get() },
          clearClipboardOnSuccess: !0
        });
        return;
      }
      if (t.getClipboard().type === "copy") {
        n.modal.open(tn, {
          items: { from: Array.from(t.getClipboard().items), to: t.path.get() }
        });
        return;
      }
      v.preventDefault();
    }
  };
  Fe(async () => {
    if (await Ve(), !n.root) {
      console.warn("app.root is not available. Event listeners will not be attached.");
      return;
    }
    n.root.addEventListener("keydown", h);
  }), fo(() => {
    n.root && n.root.removeEventListener("keydown", h);
  });
}
const jn = async (n, e) => {
  if (e) {
    if (e.isFile) {
      const t = await new Promise((o) => {
        e.file(o);
      });
      n(e, t);
    }
    if (e.isDirectory) {
      const t = e.createReader(), o = await new Promise((r) => {
        t.readEntries(r);
      });
      for (const r of o)
        await jn(n, r);
    }
  }
};
function Fl() {
  const n = z(!1), e = z([]);
  return {
    isDraggingExternal: n,
    externalFiles: e,
    handleDragEnter: (a) => {
      a.preventDefault(), a.stopPropagation();
      const u = a.dataTransfer?.items;
      u && Array.from(u).some((g) => g.kind === "file") && (n.value = !0, a.isExternalDrag = !0);
    },
    handleDragOver: (a) => {
      n.value && a.dataTransfer && (a.dataTransfer.dropEffect = "copy", a.preventDefault(), a.stopPropagation());
    },
    handleDragLeave: (a) => {
      a.preventDefault();
      const u = a.currentTarget.getBoundingClientRect(), f = a.clientX, g = a.clientY;
      (f < u.left || f > u.right || g < u.top || g > u.bottom) && (n.value = !1);
    },
    handleDrop: async (a) => {
      a.preventDefault(), a.stopPropagation(), n.value = !1;
      const u = a.dataTransfer?.items;
      if (u) {
        const f = Array.from(u).filter((g) => g.kind === "file");
        if (f.length > 0) {
          e.value = [];
          for (const g of f) {
            const h = g.webkitGetAsEntry?.();
            if (h)
              await jn((v, x) => {
                e.value.push({
                  name: x.name,
                  size: x.size,
                  type: x.type,
                  lastModified: new Date(x.lastModified),
                  file: x
                });
              }, h);
            else {
              const v = g.getAsFile();
              v && e.value.push({
                name: v.name,
                size: v.size,
                type: v.type,
                lastModified: new Date(v.lastModified),
                file: v
              });
            }
          }
          return e.value;
        }
      }
      return [];
    },
    clearExternalFiles: () => {
      e.value = [];
    }
  };
}
const El = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Dl(n, e) {
  return c(), _("svg", El, [...e[0] || (e[0] = [
    i("path", { d: "M3 7h7l2 2h9v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM12 12v5m-2.5-2.5h5" }, null, -1)
  ])]);
}
const rn = { render: Dl }, Pl = { class: "vuefinder__new-folder-modal__content" }, Il = { class: "vuefinder__new-folder-modal__form" }, Tl = { class: "vuefinder__new-folder-modal__description" }, Ml = ["placeholder", "disabled"], Al = ["disabled"], Ol = ["disabled"], qn = /* @__PURE__ */ le({
  __name: "ModalNewFolder",
  setup(n) {
    const e = fe(), t = Ne(e), { t: o } = e.i18n, r = e.fs, l = Z(r.path), d = z(""), a = z(!1), u = e.modal.data.targetPath ?? l.value.path, f = () => {
      d.value === "" || a.value || (a.value = !0, e.adapter.createFolder({
        path: u,
        name: d.value
      }).then((g) => {
        t.success(o("%s is created.", d.value)), u === l.value.path ? e.fs.setFiles(g.files) : e.adapter.open(u), e.modal.close();
      }).catch((g) => {
        t.error(Ae(g, o("Failed to create folder"), o));
      }).finally(() => {
        a.value = !1;
      }));
    };
    return (g, h) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: a.value || d.value === "",
          onClick: f
        }, w(s(o)("Create")), 9, Al),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: a.value,
          onClick: h[1] || (h[1] = (v) => s(e).modal.close())
        }, w(s(o)("Cancel")), 9, Ol)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(rn),
            title: s(o)("New Folder")
          }, null, 8, ["icon", "title"]),
          i("div", Pl, [
            i("div", Il, [
              i("p", Tl, w(s(o)("Create a new folder")), 1),
              xe(i("input", {
                "onUpdate:modelValue": h[0] || (h[0] = (v) => d.value = v),
                class: "vuefinder__new-folder-modal__input",
                placeholder: s(o)("Folder Name"),
                type: "text",
                autofocus: "",
                disabled: a.value,
                onKeyup: yt(f, ["enter"])
              }, null, 40, Ml), [
                [bt, d.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), zl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto vf-toolbar-icon",
  viewBox: "0 0 24 24"
};
function Rl(n, e) {
  return c(), _("svg", zl, [...e[0] || (e[0] = [
    i("path", { d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9" }, null, -1)
  ])]);
}
const Ll = { render: Rl }, Vl = { class: "vuefinder__new-file-modal__content" }, Bl = { class: "vuefinder__new-file-modal__form" }, Nl = { class: "vuefinder__new-file-modal__description" }, Ul = ["placeholder", "disabled"], Hl = ["disabled"], Kl = ["disabled"], qt = /* @__PURE__ */ le({
  __name: "ModalNewFile",
  setup(n) {
    const e = fe(), t = Ne(e), { t: o } = e.i18n, r = e.fs, l = Z(r.path), d = z(""), a = z(!1), u = e.modal.data.targetPath ?? l.value.path, f = e.modal.data.extension ?? "", g = e.modal.data.officeKind ?? null, h = () => {
      const x = d.value.trim();
      return !x || !f || x.toLowerCase().endsWith(`.${f}`) ? x : `${x}.${f}`;
    }, v = () => {
      const x = h();
      x === "" || a.value || (a.value = !0, e.adapter.createFile({
        path: u,
        name: x,
        kind: g
      }).then((y) => {
        const m = y.created || y.file || y.files?.find((b) => b.basename === x);
        t.success(o("%s is created.", x)), u === l.value.path ? e.fs.setFiles(y.files) : e.adapter.open(u), g && e.emitter.emit("vf-office-file-created", {
          kind: g,
          name: x,
          targetPath: u,
          item: m,
          editor: y.editor ?? null
        }), e.modal.close();
      }).catch((y) => {
        t.error(Ae(y, o("Failed to create file"), o));
      }).finally(() => {
        a.value = !1;
      }));
    };
    return (x, y) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: a.value || d.value.trim() === "",
          onClick: v
        }, w(s(o)("Create")), 9, Hl),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: a.value,
          onClick: y[1] || (y[1] = (m) => s(e).modal.close())
        }, w(s(o)("Cancel")), 9, Kl)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(Ll),
            title: s(o)("New File")
          }, null, 8, ["icon", "title"]),
          i("div", Vl, [
            i("div", Bl, [
              i("p", Nl, w(s(o)("Create a new file")), 1),
              xe(i("input", {
                "onUpdate:modelValue": y[0] || (y[0] = (m) => d.value = m),
                class: "vuefinder__new-file-modal__input",
                placeholder: s(o)("File Name"),
                type: "text",
                disabled: a.value,
                onKeyup: yt(v, ["enter"])
              }, null, 40, Ul), [
                [bt, d.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), jl = { class: "vuefinder__upload-conflict" }, ql = { class: "vuefinder__upload-conflict-title" }, Gl = {
  key: 0,
  class: "mb-4 max-h-64 overflow-auto rounded border border-gray-200"
}, Wl = { class: "w-full text-left text-sm" }, Yl = { class: "bg-gray-50 text-xs text-gray-500" }, Ql = { class: "px-3 py-2 font-medium" }, Xl = { class: "px-3 py-2 font-medium" }, Jl = ["title"], Zl = { class: "px-3 py-2" }, ed = { class: "vuefinder__upload-conflict-actions flex flex-wrap gap-2" }, td = /* @__PURE__ */ le({
  __name: "UploadConflictDialog",
  props: {
    files: {},
    names: {},
    buttonStyle: {},
    locale: {}
  },
  emits: ["resolve"],
  setup(n, { emit: e }) {
    const t = n, o = e, r = ht(
      "VueFinderOptions",
      {}
    ), { t: l } = On(
      An("upload-conflict"),
      t.locale ?? r.locale ?? "",
      { emit: () => {
      } },
      r.i18n ?? {}
    ), d = B(() => new Set(t.names)), a = B(() => t.names.length === 1), u = B(() => t.files.length > 1), f = (g) => t.buttonStyle === "bootstrap" ? g === "primary" ? "btn btn-primary" : "btn btn-outline-secondary" : g === "primary" ? "vf-btn vf-btn-primary" : "vf-btn vf-btn-secondary";
    return (g, h) => (c(), _("div", jl, [
      i("h3", ql, w(a.value ? s(l)('A file named "%s" already exists in the destination folder', n.names[0]) : s(l)("The destination folder already contains files with the same names")), 1),
      i("p", null, [
        ye(w(s(l)("Replacing creates a new version of the file.")) + " ", 1),
        u.value ? (c(), _(he, { key: 0 }, [
          ye(w(s(l)("Other files will be uploaded.")), 1)
        ], 64)) : V("", !0)
      ]),
      u.value ? (c(), _("div", Gl, [
        i("table", Wl, [
          i("thead", Yl, [
            i("tr", null, [
              i("th", Ql, w(s(l)("File Name")), 1),
              i("th", Xl, w(s(l)("Status")), 1)
            ])
          ]),
          i("tbody", null, [
            (c(!0), _(he, null, ke(n.files, (v, x) => (c(), _("tr", {
              key: `${v}-${x}`,
              class: re(d.value.has(v) ? "bg-red-50" : "bg-green-50")
            }, [
              i("td", {
                class: "max-w-80 truncate px-3 py-2",
                title: v
              }, w(v), 9, Jl),
              i("td", Zl, [
                i("span", {
                  class: re(d.value.has(v) ? "text-red-700" : "text-green-700")
                }, w(d.value.has(v) ? s(l)("Conflict: choose an action") : s(l)("Will be uploaded")), 3)
              ])
            ], 2))), 128))
          ])
        ])
      ])) : V("", !0),
      i("div", ed, [
        i("button", {
          type: "button",
          class: re(f("primary")),
          onClick: h[0] || (h[0] = (v) => o("resolve", "replace"))
        }, w(a.value ? s(l)("Replace the file in the destination folder") : s(l)("Replace the files in the destination folder")), 3),
        u.value ? (c(), _("button", {
          key: 0,
          type: "button",
          class: re(f("secondary")),
          onClick: h[1] || (h[1] = (v) => o("resolve", "skip"))
        }, w(a.value ? s(l)("Skip this file") : s(l)("Skip these files")), 3)) : V("", !0),
        i("button", {
          type: "button",
          class: re(f("secondary")),
          onClick: h[2] || (h[2] = (v) => o("resolve", "cancel"))
        }, w(s(l)("Cancel upload")), 3)
      ])
    ]));
  }
}), $e = {
  PENDING: 0,
  CANCELED: 1,
  UPLOADING: 2,
  ERROR: 3,
  SKIPPED: 4,
  DONE: 10
};
function nd(n) {
  const e = fe(), { t } = e.i18n, o = e.fs, r = Z(o.path), l = e.config, d = z({ QUEUE_ENTRY_STATUS: $e }), a = z(null), u = z(null), f = z(null), g = z(null), h = z(null), v = z([]), x = z(""), y = z(!1), m = z([]), b = z(!1), I = z(null);
  let L = "error", S, p = null, F = null;
  const C = () => {
    p?.abort(), p = null, b.value = !1;
    const O = (X) => {
      const ne = X.value;
      if (!ne?.parentNode || !F) return;
      const ue = ne.cloneNode(!0);
      ue.value = "", ne.parentNode.replaceChild(ue, ne), X.value = ue, ue.addEventListener("change", F);
    };
    O(u), O(f);
  }, E = (O) => {
    O.preventDefault(), O.stopPropagation(), b.value = !0;
  }, P = (O) => {
    O.preventDefault(), O.stopPropagation(), b.value = !0;
  }, N = (O) => {
    O.preventDefault(), O.stopPropagation(), (!O.relatedTarget || O.relatedTarget === document.body) && (b.value = !1);
  }, te = (O) => {
    O.preventDefault(), O.stopPropagation(), b.value = !1;
    const X = /^[/\\](.+)/, ne = O.dataTransfer;
    if (!ne) return;
    let ue = !1;
    ne.items && ne.items.length ? Array.from(ne.items).forEach((_e) => {
      if (_e.kind === "file") {
        const K = _e.webkitGetAsEntry?.();
        if (K)
          ue = !0, jn((ee, Q) => {
            const ce = X.exec(ee?.fullPath || "");
            se(Q, ce ? ce[1] : Q.name);
          }, K);
        else {
          const ee = _e.getAsFile?.();
          ee && (ue = !0, se(ee));
        }
      }
    }) : ne.files && ne.files.length && (ue = !0, Array.from(ne.files).forEach((_e) => se(_e))), ue && C();
  }, W = (O) => v.value.findIndex((X) => X.id === O), se = (O, X) => S.addFile({ name: X || O.name, type: O.type, data: O, source: "Local" }), $ = (O) => O.status === $e.DONE ? "text-green-600" : O.status === $e.ERROR || O.status === $e.CANCELED ? "text-red-600" : "", k = (O) => O.status === $e.DONE ? "✓" : O.status === $e.ERROR || O.status === $e.CANCELED ? "!" : O.status === $e.SKIPPED ? "–" : "...", T = async () => {
    const O = window;
    if (typeof O.showOpenFilePicker == "function") {
      p?.abort(), p = new AbortController();
      try {
        const X = await O.showOpenFilePicker({
          multiple: !0,
          signal: p.signal
        });
        for (const ne of X)
          se(await ne.getFile());
      } catch (X) {
        X?.name;
      } finally {
        p = null;
      }
      return;
    }
    u.value?.click();
  }, M = () => e.modal.close(), q = () => {
    m.value = [], y.value = !0, S.upload();
  }, pe = async (O) => {
    if (y.value || !v.value.filter(
      (X) => X.status !== $e.DONE && X.status !== $e.SKIPPED
    ).length) {
      y.value || (x.value = t("Please select file to upload first."));
      return;
    }
    x.value = "", I.value = O || r.value;
    try {
      const X = e.adapter.getDriver(), ne = v.value.filter(
        (K) => K.status !== $e.DONE && K.status !== $e.SKIPPED
      ), { conflicts: ue } = await X.checkUploadConflicts({
        path: I.value.path,
        names: ne.map((K) => K.name)
      }), _e = new Set(ue);
      if (m.value = v.value.filter(
        (K) => K.status !== $e.DONE && K.status !== $e.SKIPPED && _e.has(K.name)
      ), m.value.length) return;
      L = "error", q();
    } catch (X) {
      x.value = Ae(X, t("Unknown Error"), t);
    }
  }, R = (O) => {
    if (O === "cancel") {
      m.value = [];
      return;
    }
    if (O === "skip" ? (m.value.forEach((X) => {
      S.removeFile(X.id), X.status = $e.SKIPPED, X.statusName = t("Skipped");
    }), L = "error") : L = "replace", !S.getFiles().length) {
      m.value = [];
      return;
    }
    q();
  }, D = () => {
    S.cancelAll(), v.value.forEach((O) => {
      O.status !== $e.DONE && O.status !== $e.SKIPPED && (O.status = $e.CANCELED, O.statusName = t("Canceled"));
    }), y.value = !1;
  }, A = (O) => {
    y.value || (S.removeFile(O.id), v.value.splice(W(O.id), 1));
  }, H = (O) => {
    if (!y.value)
      if (S.cancelAll(), O) {
        const X = v.value.filter(
          (ne) => ne.status !== $e.DONE && ne.status !== $e.SKIPPED
        );
        v.value = [], X.forEach((ne) => se(ne.originalFile, ne.name));
      } else
        v.value = [];
  }, U = (O) => {
    O?.length && (O.forEach((X) => {
      se(X);
    }), C());
  };
  return Fe(() => {
    S = new _o({
      debug: e.debug,
      restrictions: { maxFileSize: Is(l.get("maxFileSize") ?? "10mb") },
      locale: e.i18n.t("uppy"),
      onBeforeFileAdded: (ne, ue) => {
        if (ue[ne.id] != null) {
          const ee = W(ne.id);
          v.value[ee]?.status === $e.PENDING && (x.value = S.i18n("noDuplicates", { fileName: ne.name })), v.value = v.value.filter((Q) => Q.id !== ne.id);
        }
        const K = Number.isFinite(ne.size) ? ne.size : ne.data?.size;
        return v.value.push({
          id: ne.id,
          name: ne.name,
          size: Number.isFinite(K) ? e.filesize(K) : "",
          status: $e.PENDING,
          statusName: t("Pending upload"),
          percent: null,
          originalFile: ne.data
        }), !0;
      }
    });
    const O = {
      getTargetPath: () => (I.value || r.value).path,
      getConflictAction: () => L
    };
    if (n)
      n(S, O);
    else if (e.adapter.getDriver().configureUploader)
      e.adapter.getDriver().configureUploader(S, O);
    else
      throw new Error("No uploader configured");
    S.on("restriction-failed", (ne, ue) => {
      const _e = v.value[W(ne.id)];
      _e && A(_e), x.value = ue.message;
    }), S.on("upload-start", (ne) => {
      ne.forEach((ue) => {
        const _e = v.value[W(ue.id)];
        _e && (_e.status = $e.UPLOADING, _e.statusName = t("Uploading"), _e.percent = "0%");
      });
    }), S.on("upload-progress", (ne, ue) => {
      const _e = W(ne?.id);
      if (_e === -1 || !v.value[_e]) return;
      const K = Number(ue?.percentage), ee = Number(ue?.bytesTotal), Q = Number(ue?.bytesUploaded), ce = Number.isFinite(K) ? Math.round(K) : ee > 0 && Number.isFinite(Q) ? Math.min(100, Math.floor(Q / ee * 100)) : null;
      v.value[_e].percent = ce == null ? "" : `${ce}%`;
    }), S.on("upload-success", (ne) => {
      const ue = v.value[W(ne.id)];
      ue && (ue.status = $e.DONE, ue.statusName = t("Done"));
    }), S.on("upload-error", (ne, ue) => {
      const _e = v.value[W(ne.id)];
      _e && (_e.percent = null, _e.status = $e.ERROR, _e.statusName = ue?.isNetworkError ? t("Network Error, Unable establish connection to the server or interrupted.") : Ae(ue, t("Unknown Error"), t));
    }), S.on("error", (ne) => {
      x.value = Ae(ne, t("Unknown Error"), t), y.value = !1;
    }), S.on("complete", (ne) => {
      y.value = !1;
      const ue = I.value || r.value;
      e.adapter.invalidateListQuery(ue.path), e.adapter.open(ue.path);
      const _e = v.value.filter(
        (K) => K.status === $e.DONE && ne.successful.includes(K.id)
      ).map((K) => K.name);
      e.emitter.emit("vf-upload-complete", _e);
    });
    const X = { capture: !0 };
    document.addEventListener("dragover", E, X), document.addEventListener("dragenter", P, X), document.addEventListener("dragleave", N, X), document.addEventListener("drop", te, X), F = (ne) => {
      const ue = ne.target, _e = ue.files;
      if (_e) {
        for (const K of _e) se(K);
        ue.value = "";
      }
    }, u.value?.addEventListener("change", F), f.value?.addEventListener("change", F);
  }), Te(() => {
    p?.abort(), p = null;
    const O = { capture: !0 };
    document.removeEventListener("dragover", E, O), document.removeEventListener("dragenter", P, O), document.removeEventListener("dragleave", N, O), document.removeEventListener("drop", te, O);
  }), {
    container: a,
    internalFileInput: u,
    internalFolderInput: f,
    pickFiles: g,
    pickFolders: h,
    queue: v,
    message: x,
    uploading: y,
    conflicts: m,
    hasFilesInDropArea: b,
    definitions: d,
    openFileSelector: T,
    upload: pe,
    resolveConflicts: R,
    cancel: D,
    remove: A,
    clear: H,
    close: M,
    getClassNameForEntry: $,
    getIconForEntry: k,
    addExternalFiles: U
  };
}
const od = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function sd(n, e) {
  return c(), _("svg", od, [...e[0] || (e[0] = [
    i("path", { d: "M12 16V4m0 0L7 9m5-5 5 5M5 20h14" }, null, -1)
  ])]);
}
const an = { render: sd };
function Fn(n, e = 14) {
  const t = `((?=([\\w\\W]{0,${e}}))([\\w\\W]{${e + 1},})([\\w\\W]{8,}))`;
  return n.replace(new RegExp(t), "$2..$4");
}
const id = {
  key: 1,
  class: "vuefinder__upload-modal__content relative"
}, rd = { class: "vuefinder__upload-modal__target-section" }, ad = { class: "vuefinder__upload-modal__target-label" }, ld = { class: "vuefinder__upload-modal__target-container" }, dd = { class: "vuefinder__upload-modal__target-path" }, cd = { class: "vuefinder__upload-modal__target-storage" }, ud = {
  key: 0,
  class: "vuefinder__upload-modal__target-folder"
}, fd = { class: "vuefinder__upload-modal__target-badge" }, vd = { class: "vuefinder__upload-modal__drag-hint" }, _d = { class: "vuefinder__upload-modal__file-list vf-scrollbar" }, hd = ["textContent"], pd = { class: "vuefinder__upload-modal__file-info" }, md = { class: "vuefinder__upload-modal__file-name hidden md:block" }, gd = { class: "vuefinder__upload-modal__file-name md:hidden" }, wd = {
  key: 0,
  class: "ml-auto"
}, yd = ["title", "disabled", "onClick"], bd = {
  key: 0,
  class: "py-2"
}, kd = ["aria-expanded"], xd = {
  key: 0,
  class: "vuefinder__upload-actions__menu absolute right-0 bottom-full left-0 mb-2"
}, $d = ["disabled"], Sd = ["aria-expanded"], Cd = {
  key: 0,
  class: "vuefinder__upload-actions__menu"
}, ln = /* @__PURE__ */ le({
  __name: "ModalUpload",
  setup(n) {
    const e = fe(), { t } = e.i18n, o = e.fs, r = Z(o.path), l = z(e.modal.data?.target ?? r.value), d = z(!1), a = B(
      () => m.value.filter(
        (D) => D.status !== p.value.QUEUE_ENTRY_STATUS.DONE && D.status !== p.value.QUEUE_ENTRY_STATUS.SKIPPED
      ).map((D) => D.name)
    ), u = () => {
      const D = l.value.path;
      if (!D) return { storage: "local", path: "" };
      if (D.endsWith("://"))
        return { storage: D.replace("://", ""), path: "" };
      const A = D.split("://");
      return {
        storage: A[0] || "local",
        path: A[1] || ""
      };
    }, f = (D) => {
      D && (l.value = D);
    }, g = (D) => {
      D && (l.value = D, d.value = !1);
    }, {
      container: h,
      internalFileInput: v,
      internalFolderInput: x,
      pickFiles: y,
      queue: m,
      message: b,
      uploading: I,
      conflicts: L,
      hasFilesInDropArea: S,
      definitions: p,
      openFileSelector: F,
      upload: C,
      resolveConflicts: E,
      cancel: P,
      remove: N,
      clear: te,
      close: W,
      getClassNameForEntry: se,
      getIconForEntry: $,
      addExternalFiles: k
    } = nd(e.customUploader), T = async () => {
      await C(l.value);
    };
    Fe(() => {
      e.emitter.on("vf-external-files-dropped", (D) => {
        k(D);
      });
    }), Te(() => {
      e.emitter.off("vf-external-files-dropped");
    });
    const M = z(!1), q = z(null), pe = z(null), R = (D) => {
      if (!M.value) return;
      const A = D.target, H = q.value?.contains(A) ?? !1, U = pe.value?.contains(A) ?? !1;
      !H && !U && (M.value = !1);
    };
    return Fe(() => document.addEventListener("click", R)), Te(() => document.removeEventListener("click", R)), (D, A) => (c(), Y(Re, {
      "show-drag-overlay": s(S),
      "drag-overlay-text": s(t)("Drag and drop the files/folders to here.")
    }, {
      buttons: ae(() => [
        s(L).length ? V("", !0) : (c(), _(he, { key: 0 }, [
          i("div", {
            ref_key: "actionsMenuMobileRef",
            ref: q,
            class: "relative mb-2 w-full sm:hidden"
          }, [
            i("div", {
              class: re([
                "vuefinder__upload-actions",
                "vuefinder__upload-actions--block",
                M.value ? "vuefinder__upload-actions--ring" : ""
              ])
            }, [
              i("button", {
                type: "button",
                class: "vuefinder__upload-actions__main",
                onClick: A[3] || (A[3] = (H) => s(F)())
              }, w(s(t)("Select Files")), 1),
              i("button", {
                type: "button",
                class: "vuefinder__upload-actions__trigger",
                "aria-haspopup": "menu",
                "aria-expanded": M.value ? "true" : "false",
                onClick: A[4] || (A[4] = ge((H) => M.value = !M.value, ["stop"]))
              }, [...A[18] || (A[18] = [
                i("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  i("path", {
                    "fill-rule": "evenodd",
                    d: "M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z",
                    "clip-rule": "evenodd"
                  })
                ], -1)
              ])], 8, kd)
            ], 2),
            M.value ? (c(), _("div", xd, [
              i("div", {
                class: "vuefinder__upload-actions__item",
                onClick: A[5] || (A[5] = (H) => {
                  s(F)(), M.value = !1;
                })
              }, w(s(t)("Select Files")), 1),
              i("div", {
                class: "vuefinder__upload-actions__item",
                onClick: A[6] || (A[6] = (H) => {
                  s(x)?.click(), M.value = !1;
                })
              }, w(s(t)("Select Folders")), 1),
              A[19] || (A[19] = i("div", { class: "vuefinder__upload-actions__separator" }, null, -1)),
              i("div", {
                class: re(["vuefinder__upload-actions__item", s(I) ? "disabled" : ""]),
                onClick: A[7] || (A[7] = (H) => s(I) ? null : (s(te)(!1), M.value = !1))
              }, w(s(t)("Clear all")), 3),
              i("div", {
                class: re(["vuefinder__upload-actions__item", s(I) ? "disabled" : ""]),
                onClick: A[8] || (A[8] = (H) => s(I) ? null : (s(te)(!0), M.value = !1))
              }, w(s(t)("Clear only successful")), 3)
            ])) : V("", !0)
          ], 512),
          i("button", {
            type: "button",
            class: "vf-btn vf-btn-primary",
            disabled: s(I) || !s(m).length,
            onClick: ge(T, ["prevent"])
          }, w(s(t)("Upload")), 9, $d),
          s(I) ? (c(), _("button", {
            key: 0,
            type: "button",
            class: "vf-btn vf-btn-secondary",
            onClick: A[9] || (A[9] = ge(
              //@ts-ignore
              (...H) => s(P) && s(P)(...H),
              ["prevent"]
            ))
          }, w(s(t)("Cancel")), 1)) : (c(), _("button", {
            key: 1,
            type: "button",
            class: "vf-btn vf-btn-secondary",
            onClick: A[10] || (A[10] = ge(
              //@ts-ignore
              (...H) => s(W) && s(W)(...H),
              ["prevent"]
            ))
          }, w(s(t)("Close")), 1)),
          i("div", {
            ref_key: "actionsMenuDesktopRef",
            ref: pe,
            class: "relative mr-auto hidden sm:block"
          }, [
            i("div", {
              class: re(["vuefinder__upload-actions", M.value ? "vuefinder__upload-actions--ring" : ""])
            }, [
              i("button", {
                ref_key: "pickFiles",
                ref: y,
                type: "button",
                class: "vuefinder__upload-actions__main",
                onClick: A[11] || (A[11] = (H) => s(F)())
              }, w(s(t)("Select Files")), 513),
              i("button", {
                type: "button",
                class: "vuefinder__upload-actions__trigger",
                "aria-haspopup": "menu",
                "aria-expanded": M.value ? "true" : "false",
                onClick: A[12] || (A[12] = ge((H) => M.value = !M.value, ["stop"]))
              }, [...A[20] || (A[20] = [
                i("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  i("path", {
                    "fill-rule": "evenodd",
                    d: "M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z",
                    "clip-rule": "evenodd"
                  })
                ], -1)
              ])], 8, Sd)
            ], 2),
            M.value ? (c(), _("div", Cd, [
              i("div", {
                class: "vuefinder__upload-actions__item",
                onClick: A[13] || (A[13] = (H) => {
                  s(F)(), M.value = !1;
                })
              }, w(s(t)("Select Files")), 1),
              i("div", {
                class: "vuefinder__upload-actions__item",
                onClick: A[14] || (A[14] = (H) => {
                  s(x)?.click(), M.value = !1;
                })
              }, w(s(t)("Select Folders")), 1),
              A[21] || (A[21] = i("div", { class: "vuefinder__upload-actions__separator" }, null, -1)),
              i("div", {
                class: re(["vuefinder__upload-actions__item", s(I) ? "disabled" : ""]),
                onClick: A[15] || (A[15] = (H) => s(I) ? null : (s(te)(!1), M.value = !1))
              }, w(s(t)("Clear all")), 3),
              i("div", {
                class: re(["vuefinder__upload-actions__item", s(I) ? "disabled" : ""]),
                onClick: A[16] || (A[16] = (H) => s(I) ? null : (s(te)(!0), M.value = !1))
              }, w(s(t)("Clear only successful")), 3)
            ])) : V("", !0)
          ], 512)
        ], 64))
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(an),
            title: s(t)("Upload Files")
          }, null, 8, ["icon", "title"]),
          s(L).length ? (c(), Y(td, {
            key: 0,
            files: a.value,
            names: s(L).map((H) => H.name),
            onResolve: s(E)
          }, null, 8, ["files", "names", "onResolve"])) : (c(), _("div", id, [
            i("div", rd, [
              i("div", ad, w(s(t)("Target Directory")), 1),
              i("div", ld, [
                i("div", {
                  class: "vuefinder__upload-modal__target-display",
                  onClick: A[0] || (A[0] = (H) => d.value = !d.value)
                }, [
                  i("div", dd, [
                    i("span", cd, w(u().storage) + "://", 1),
                    u().path ? (c(), _("span", ud, w(u().path), 1)) : V("", !0)
                  ]),
                  i("span", fd, w(s(t)("Browse")), 1)
                ])
              ]),
              i("div", {
                class: re([
                  "vuefinder__upload-modal__tree-selector",
                  d.value ? "vuefinder__upload-modal__tree-selector--expanded" : "vuefinder__upload-modal__tree-selector--collapsed"
                ])
              }, [
                j(Un, {
                  modelValue: l.value,
                  "onUpdate:modelValue": [
                    A[1] || (A[1] = (H) => l.value = H),
                    f
                  ],
                  "show-pinned-folders": !0,
                  onSelectAndClose: g
                }, null, 8, ["modelValue"])
              ], 2)
            ]),
            i("div", vd, w(s(t)("You can drag & drop files anywhere while this modal is open.")), 1),
            i("div", {
              ref_key: "container",
              ref: h,
              class: "hidden"
            }, null, 512),
            i("div", _d, [
              (c(!0), _(he, null, ke(s(m), (H) => (c(), _("div", {
                key: H.id,
                class: "vuefinder__upload-modal__file-entry"
              }, [
                i("span", {
                  class: re(["vuefinder__upload-modal__file-icon", s(se)(H)])
                }, [
                  i("span", {
                    class: "vuefinder__upload-modal__file-icon-text",
                    textContent: w(s($)(H))
                  }, null, 8, hd)
                ], 2),
                i("div", pd, [
                  i("div", md, w(s(Fn)(H.name, 40)) + " (" + w(H.size) + ") ", 1),
                  i("div", gd, w(s(Fn)(H.name, 16)) + " (" + w(H.size) + ") ", 1),
                  i("div", {
                    class: re(["vuefinder__upload-modal__file-status", s(se)(H)])
                  }, [
                    ye(w(H.statusName) + " ", 1),
                    H.status === s(p).QUEUE_ENTRY_STATUS.UPLOADING ? (c(), _("b", wd, w(H.percent), 1)) : V("", !0)
                  ], 2)
                ]),
                i("button", {
                  type: "button",
                  class: re(["vuefinder__upload-modal__file-remove", s(I) ? "disabled" : ""]),
                  title: s(t)("Delete"),
                  disabled: s(I),
                  onClick: (U) => s(N)(H)
                }, [...A[17] || (A[17] = [
                  i("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "vuefinder__upload-modal__file-remove-icon"
                  }, [
                    i("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ])], 10, yd)
              ]))), 128)),
              s(m).length ? V("", !0) : (c(), _("div", bd, w(s(t)("No files selected!")), 1))
            ]),
            s(b).length ? (c(), Y(Cn, {
              key: 0,
              error: "",
              onHidden: A[2] || (A[2] = (H) => b.value = "")
            }, {
              default: ae(() => [
                ye(w(s(b)), 1)
              ]),
              _: 1
            })) : V("", !0)
          ]))
        ]),
        i("input", {
          ref_key: "internalFileInput",
          ref: v,
          type: "file",
          multiple: "",
          class: "hidden"
        }, null, 512),
        i("input", {
          ref_key: "internalFolderInput",
          ref: x,
          type: "file",
          multiple: "",
          webkitdirectory: "",
          class: "hidden"
        }, null, 512)
      ]),
      _: 1
    }, 8, ["show-drag-overlay", "drag-overlay-text"]));
  }
}), Fd = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto",
  viewBox: "0 0 24 24"
};
function Ed(n, e) {
  return c(), _("svg", Fd, [...e[0] || (e[0] = [
    i("path", { d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125" }, null, -1)
  ])]);
}
const Dd = { render: Ed }, Pd = { class: "vuefinder__unarchive-modal__content" }, Id = { class: "vuefinder__unarchive-modal__items" }, Td = {
  key: 0,
  class: "vuefinder__unarchive-modal__icon vuefinder__unarchive-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Md = {
  key: 1,
  class: "vuefinder__unarchive-modal__icon vuefinder__unarchive-modal__icon--file",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Ad = { class: "vuefinder__unarchive-modal__item-name" }, Od = { class: "vuefinder__unarchive-modal__info" }, zd = ["disabled"], Rd = ["disabled"], Ld = /* @__PURE__ */ le({
  __name: "ModalUnarchive",
  setup(n) {
    const e = fe(), t = Ne(e), o = e.fs, r = Z(o.path), { t: l } = e.i18n, d = z(e.modal.data.items[0]), a = z(!1), u = z([]), f = () => {
      a.value || (a.value = !0, e.adapter.unarchive({
        item: d.value.path,
        id: d.value.id,
        path: r.value.path
      }).then((g) => {
        t.success(l("The file unarchived.")), e.fs.setFiles(g.files), e.modal.close();
      }).catch((g) => {
        t.error(Ae(g, l("Failed to unarchive"), l));
      }).finally(() => {
        a.value = !1;
      }));
    };
    return (g, h) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: a.value,
          onClick: f
        }, w(s(l)("Unarchive")), 9, zd),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: a.value,
          onClick: h[0] || (h[0] = (v) => s(e).modal.close())
        }, w(s(l)("Cancel")), 9, Rd)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(Dd),
            title: s(l)("Unarchive")
          }, null, 8, ["icon", "title"]),
          i("div", Pd, [
            i("div", Id, [
              (c(!0), _(he, null, ke(u.value, (v) => (c(), _("p", {
                key: s(J)(v),
                class: "vuefinder__unarchive-modal__item"
              }, [
                v.type === "dir" ? (c(), _("svg", Td, [...h[1] || (h[1] = [
                  i("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  }, null, -1)
                ])])) : (c(), _("svg", Md, [...h[2] || (h[2] = [
                  i("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  }, null, -1)
                ])])),
                i("span", Ad, w(v.basename), 1)
              ]))), 128)),
              i("p", Od, w(s(l)("The archive will be unarchived at")) + " (" + w(s(r).path) + ") ", 1)
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Vd = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function Bd(n, e) {
  return c(), _("svg", Vd, [...e[0] || (e[0] = [
    i("path", { d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125" }, null, -1)
  ])]);
}
const Nd = { render: Bd }, Ud = { class: "vuefinder__archive-modal__content" }, Hd = { class: "vuefinder__archive-modal__form" }, Kd = { class: "vuefinder__archive-modal__files vf-scrollbar" }, jd = {
  key: 0,
  class: "vuefinder__archive-modal__icon vuefinder__archive-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, qd = {
  key: 1,
  class: "vuefinder__archive-modal__icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Gd = { class: "vuefinder__archive-modal__file-name" }, Wd = ["placeholder", "disabled"], Yd = ["disabled"], Qd = ["disabled"], Xd = /* @__PURE__ */ le({
  __name: "ModalArchive",
  setup(n) {
    const e = fe(), t = Ne(e), { t: o } = e.i18n, r = e.fs, l = Z(r.path), d = z(""), a = z(!1), u = z(e.modal.data.items), f = () => {
      !u.value.length || a.value || (a.value = !0, e.adapter.archive({
        path: l.value.path,
        items: u.value.map(_t),
        name: d.value
      }).then((g) => {
        t.success(o("The file(s) archived.")), e.fs.setFiles(g.files), e.modal.close();
      }).catch((g) => {
        t.error(Ae(g, o("Failed to archive files"), o));
      }).finally(() => {
        a.value = !1;
      }));
    };
    return (g, h) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: a.value,
          onClick: f
        }, w(s(o)("Archive")), 9, Yd),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          disabled: a.value,
          onClick: h[1] || (h[1] = (v) => s(e).modal.close())
        }, w(s(o)("Cancel")), 9, Qd)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(Nd),
            title: s(o)("Archive the files")
          }, null, 8, ["icon", "title"]),
          i("div", Ud, [
            i("div", Hd, [
              i("div", Kd, [
                (c(!0), _(he, null, ke(u.value, (v) => (c(), _("p", {
                  key: s(J)(v),
                  class: "vuefinder__archive-modal__file"
                }, [
                  v.type === "dir" ? (c(), _("svg", jd, [...h[2] || (h[2] = [
                    i("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                    }, null, -1)
                  ])])) : (c(), _("svg", qd, [...h[3] || (h[3] = [
                    i("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                    }, null, -1)
                  ])])),
                  i("span", Gd, w(v.basename), 1)
                ]))), 128))
              ]),
              xe(i("input", {
                "onUpdate:modelValue": h[0] || (h[0] = (v) => d.value = v),
                class: "vuefinder__archive-modal__input",
                placeholder: s(o)("Archive name. (.zip file will be created)"),
                type: "text",
                disabled: a.value,
                onKeyup: yt(f, ["enter"])
              }, null, 40, Wd), [
                [bt, d.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Jd = {
  props: {
    on: { type: String, required: !0 }
  },
  setup(n, { emit: e, slots: t }) {
    const o = fe(), r = z(!1), { t: l } = o.i18n;
    let d = null;
    const a = () => {
      d && clearTimeout(d), r.value = !0, d = setTimeout(() => {
        r.value = !1;
      }, 2e3);
    };
    return Fe(() => {
      o.emitter.on(n.on, a);
    }), Te(() => {
      d && clearTimeout(d);
    }), {
      shown: r,
      t: l
    };
  }
}, Ko = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [o, r] of e)
    t[o] = r;
  return t;
}, Zd = { key: 1 };
function ec(n, e, t, o, r, l) {
  return c(), _("div", {
    class: re(["vuefinder__action-message", { "vuefinder__action-message--hidden": !o.shown }])
  }, [
    n.$slots.default ? Ce(n.$slots, "default", { key: 0 }) : (c(), _("span", Zd, w(o.t("Saved.")), 1))
  ], 2);
}
const io = /* @__PURE__ */ Ko(Jd, [["render", ec]]), tc = [
  { name: "silver", displayName: "Silver" },
  { name: "valorite", displayName: "Valorite" },
  { name: "midnight", displayName: "Midnight" },
  { name: "latte", displayName: "Latte" },
  { name: "rose", displayName: "Rose" },
  { name: "mythril", displayName: "Mythril" },
  { name: "lime", displayName: "lime" },
  { name: "sky", displayName: "Sky" },
  { name: "ocean", displayName: "Oceanic" },
  { name: "palenight", displayName: "Palenight" },
  { name: "arctic", displayName: "Arctic" },
  { name: "code", displayName: "Code" }
], nc = { class: "vuefinder__settings-modal__content" }, oc = { class: "vuefinder__settings-modal__main" }, sc = { class: "vuefinder__settings-modal__sections" }, ic = {
  key: 0,
  class: "vuefinder__settings-modal__section"
}, rc = {
  for: "theme",
  class: "vuefinder__settings-modal__label"
}, ac = { class: "vuefinder__settings-modal__input-group" }, lc = ["value"], dc = ["value"], cc = {
  key: 1,
  class: "vuefinder__settings-modal__section"
}, uc = {
  for: "language",
  class: "vuefinder__settings-modal__label"
}, fc = { class: "vuefinder__settings-modal__input-group" }, vc = ["value"], _c = { class: "vuefinder__settings-modal__reset-section" }, hc = { class: "vuefinder__settings-modal__reset-content" }, pc = { class: "vuefinder__settings-modal__reset-title" }, mc = { class: "vuefinder__settings-modal__reset-description" }, gc = /* @__PURE__ */ le({
  __name: "ModalSettings",
  setup(n) {
    const e = fe(), { enabled: t } = st(), o = e.config, { clearStore: r } = e.storage, { t: l, localeAtom: d } = e.i18n, a = Z(d), u = B({
      get: () => String(a.value || "en"),
      set: (b) => d.set(b || "en")
    }), f = Z(o.state), g = B(() => f.value.theme || "silver"), h = async () => {
      o.reset(), r(), localStorage.removeItem("vuefinder_locale"), localStorage.removeItem("vuefinder_translations"), location.reload();
    }, v = (b) => {
      o.set("theme", b), e.emitter.emit("vf-theme-saved");
    }, { i18n: x } = ht("VueFinderOptions"), m = Object.fromEntries(
      Object.entries({
        ar: "Arabic (العربيّة)",
        zhCN: "Chinese-Simplified (简体中文)",
        zhTW: "Chinese-Traditional (繁體中文)",
        nl: "Dutch (Nederlands)",
        en: "English",
        fr: "French (Français)",
        de: "German (Deutsch)",
        he: "Hebrew (עִברִית)",
        hi: "Hindi (हिंदी)",
        it: "Italian (Italiano)",
        ja: "Japanese (日本語)",
        fa: "Persian (فارسی)",
        pl: "Polish (Polski)",
        pt: "Portuguese (Português)",
        ru: "Russian (Pусский)",
        es: "Spanish (Español)",
        sv: "Swedish (Svenska)",
        tr: "Turkish (Türkçe)"
      }).filter(([b]) => Object.keys(x).includes(b))
    );
    return (b, I) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: I[2] || (I[2] = (L) => s(e).modal.close())
        }, w(s(l)("Close")), 1)
      ]),
      default: ae(() => [
        i("div", nc, [
          j(Le, {
            icon: s(No),
            title: s(l)("Settings")
          }, null, 8, ["icon", "title"]),
          i("div", oc, [
            i("div", sc, [
              s(t)("theme") ? (c(), _("div", ic, [
                i("label", rc, [
                  ye(w(s(l)("Theme")) + " ", 1),
                  j(io, {
                    class: "vuefinder__settings-modal__message",
                    on: "vf-theme-saved"
                  }, {
                    default: ae(() => [
                      ye(w(s(l)("Saved.")), 1)
                    ]),
                    _: 1
                  })
                ]),
                i("div", ac, [
                  i("select", {
                    id: "theme",
                    value: g.value,
                    class: "vuefinder__settings-modal__select",
                    onChange: I[0] || (I[0] = (L) => v(L.target?.value))
                  }, [
                    (c(!0), _(he, null, ke(s(tc), (L) => (c(), _("option", {
                      key: L.name,
                      value: L.name
                    }, w(L.displayName), 9, dc))), 128))
                  ], 40, lc)
                ])
              ])) : V("", !0),
              Object.keys(s(m)).length > 1 ? (c(), _("div", cc, [
                i("label", uc, [
                  ye(w(s(l)("Language")) + " ", 1),
                  j(io, {
                    class: "vuefinder__settings-modal__message",
                    on: "vf-language-saved"
                  }, {
                    default: ae(() => [
                      ye(w(s(l)("Saved.")), 1)
                    ]),
                    _: 1
                  })
                ]),
                i("div", fc, [
                  xe(i("select", {
                    id: "language",
                    "onUpdate:modelValue": I[1] || (I[1] = (L) => u.value = L),
                    class: "vuefinder__settings-modal__select"
                  }, [
                    (c(!0), _(he, null, ke(s(m), (L, S) => (c(), _("option", {
                      key: S,
                      value: S
                    }, w(L), 9, vc))), 128))
                  ], 512), [
                    [yn, u.value]
                  ])
                ])
              ])) : V("", !0)
            ]),
            i("div", _c, [
              i("div", hc, [
                i("div", pc, w(s(l)("Reset")), 1),
                i("div", mc, w(s(l)("Reset all settings to default")), 1)
              ]),
              i("button", {
                type: "button",
                class: "vuefinder__settings-modal__reset-button",
                onClick: h
              }, w(s(l)("Reset Settings")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), wc = { class: "vuefinder__about-modal__content" }, yc = { class: "vuefinder__about-modal__main" }, bc = { class: "vuefinder__about-modal__shortcuts" }, kc = { class: "vuefinder__about-modal__shortcut" }, xc = {
  key: 0,
  class: "vuefinder__about-modal__shortcut"
}, $c = {
  key: 1,
  class: "vuefinder__about-modal__shortcut"
}, Sc = { class: "vuefinder__about-modal__shortcut" }, Cc = { class: "vuefinder__about-modal__shortcut" }, Fc = {
  key: 2,
  class: "vuefinder__about-modal__shortcut"
}, Ec = {
  key: 3,
  class: "vuefinder__about-modal__shortcut"
}, Dc = {
  key: 4,
  class: "vuefinder__about-modal__shortcut"
}, Pc = {
  key: 5,
  class: "vuefinder__about-modal__shortcut"
}, Ic = { class: "vuefinder__about-modal__shortcut" }, Tc = { class: "vuefinder__about-modal__shortcut" }, Mc = {
  key: 6,
  class: "vuefinder__about-modal__shortcut"
}, Ac = { class: "vuefinder__about-modal__shortcut" }, Oc = /* @__PURE__ */ le({
  __name: "ModalShortcuts",
  setup(n) {
    const e = fe(), { enabled: t } = st(), { t: o } = e.i18n;
    return (r, l) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: l[0] || (l[0] = (d) => s(e).modal.close())
        }, w(s(o)("Close")), 1)
      ]),
      default: ae(() => [
        i("div", wc, [
          j(Le, {
            icon: s(So),
            title: s(o)("Shortcuts")
          }, null, 8, ["icon", "title"]),
          i("div", yc, [
            i("div", bc, [
              i("div", kc, [
                i("div", null, w(s(o)("Refresh")), 1),
                l[1] || (l[1] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "R")
                ], -1))
              ]),
              s(t)("rename") ? (c(), _("div", xc, [
                i("div", null, w(s(o)("Rename")), 1),
                l[2] || (l[2] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "Shift"),
                  ye(" + "),
                  i("kbd", null, "R")
                ], -1))
              ])) : V("", !0),
              s(t)("delete") ? (c(), _("div", $c, [
                i("div", null, w(s(o)("Delete")), 1),
                l[3] || (l[3] = i("kbd", null, "Del", -1))
              ])) : V("", !0),
              i("div", Sc, [
                i("div", null, w(s(o)("Escape")), 1),
                l[4] || (l[4] = i("kbd", null, "Esc", -1))
              ]),
              i("div", Cc, [
                i("div", null, w(s(o)("Select All")), 1),
                l[5] || (l[5] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "A")
                ], -1))
              ]),
              s(t)("copy") ? (c(), _("div", Fc, [
                i("div", null, w(s(o)("Cut")), 1),
                l[6] || (l[6] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "X")
                ], -1))
              ])) : V("", !0),
              s(t)("copy") ? (c(), _("div", Ec, [
                i("div", null, w(s(o)("Copy")), 1),
                l[7] || (l[7] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "C")
                ], -1))
              ])) : V("", !0),
              s(t)("copy") ? (c(), _("div", Dc, [
                i("div", null, w(s(o)("Paste")), 1),
                l[8] || (l[8] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "V")
                ], -1))
              ])) : V("", !0),
              s(t)("search") ? (c(), _("div", Pc, [
                i("div", null, w(s(o)("Search")), 1),
                l[9] || (l[9] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "F")
                ], -1))
              ])) : V("", !0),
              i("div", Ic, [
                i("div", null, w(s(o)("Toggle Sidebar")), 1),
                l[10] || (l[10] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "E")
                ], -1))
              ]),
              i("div", Tc, [
                i("div", null, w(s(o)("Open Settings")), 1),
                l[11] || (l[11] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "S")
                ], -1))
              ]),
              s(t)("fullscreen") ? (c(), _("div", Mc, [
                i("div", null, w(s(o)("Toggle Full Screen")), 1),
                l[12] || (l[12] = i("div", null, [
                  i("kbd", null, "⌘"),
                  ye(" + "),
                  i("kbd", null, "Enter")
                ], -1))
              ])) : V("", !0),
              i("div", Ac, [
                i("div", null, w(s(o)("Open")), 1),
                l[13] || (l[13] = i("kbd", null, "Space", -1))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), zc = { class: "vuefinder__menubar__container" }, Rc = ["onClick", "onMouseenter"], Lc = { class: "vuefinder__menubar__label" }, Vc = ["onMouseenter"], Bc = ["onClick"], Nc = {
  key: 0,
  class: "vuefinder__menubar__dropdown__label"
}, Uc = {
  key: 1,
  class: "vuefinder__menubar__dropdown__checkmark"
}, Hc = /* @__PURE__ */ le({
  __name: "MenuBar",
  setup(n) {
    const e = fe(), t = Ne(e), { enabled: o } = st(), { openItem: r } = kt(e), { t: l } = e?.i18n || { t: (p) => p }, d = e?.fs, a = e?.config, u = Z(a.state), f = Z(d.selectedItems), g = Z(d?.storages || []), h = z(null), v = z(!1), x = B(() => window.opener !== null || window.name !== "" || window.history.length <= 1), y = B(() => [
      {
        id: "file",
        label: l("File"),
        items: [
          {
            id: "new-folder",
            label: l("New Folder"),
            action: () => e?.modal?.open(qn, { items: f.value }),
            hidden: () => !o("newfolder")
          },
          {
            id: "new-file",
            label: l("New File"),
            action: () => e?.modal?.open(qt, { items: f.value }),
            hidden: () => !o("newfile")
          },
          {
            type: "separator",
            hidden: () => !o("newfolder") && !o("newfile") || !o("upload")
          },
          {
            id: "upload",
            label: l("Upload"),
            action: () => e?.modal?.open(ln, { items: f.value }),
            hidden: () => !o("upload")
          },
          { type: "separator", hidden: () => !o("search") },
          {
            id: "search",
            label: l("Search"),
            action: () => e.modal.open(Kn),
            hidden: () => !o("search")
          },
          { type: "separator", hidden: () => !o("archive") && !o("unarchive") },
          {
            id: "archive",
            label: l("Archive"),
            action: () => {
              f.value.length > 0 && e?.modal?.open(Xd, { items: f.value });
            },
            enabled: () => f.value.length > 0,
            hidden: () => !o("archive")
          },
          {
            id: "unarchive",
            label: l("Unarchive"),
            action: () => {
              f.value.length === 1 && f.value[0]?.mime_type === "application/zip" && e?.modal?.open(Ld, { items: f.value });
            },
            enabled: () => f.value.length === 1 && f.value[0]?.mime_type === "application/zip",
            hidden: () => !o("unarchive")
          },
          { type: "separator" },
          {
            id: "preview",
            label: l("Open"),
            action: () => {
              const p = f.value.length === 1 ? f.value[0] : void 0;
              p?.type === "file" && r(p);
            },
            enabled: () => f.value.length === 1 && f.value[0]?.type === "file"
          },
          // Only show exit option if we can actually close the window
          ...x.value ? [
            { type: "separator" },
            {
              id: "exit",
              label: l("Exit"),
              action: () => {
                try {
                  window.close();
                } catch {
                }
              },
              enabled: () => !0
            }
          ] : []
        ]
      },
      {
        id: "edit",
        label: l("Edit"),
        items: [
          // Only show Select All and Deselect All in multiple selection mode
          ...e?.selectionMode === "multiple" ? [
            {
              id: "select-all",
              label: l("Select All"),
              action: () => d?.selectAll(e?.selectionMode || "multiple", e),
              enabled: () => !0
            },
            {
              id: "deselect",
              label: l("Deselect All"),
              action: () => d?.clearSelection(),
              enabled: () => f.value.length > 0
            },
            { type: "separator" }
          ] : [],
          ...o("copy") ? [
            {
              id: "cut",
              label: l("Cut"),
              action: () => {
                f.value.length > 0 && d?.setClipboard(
                  "cut",
                  new Set(f.value.map((p) => J(p)))
                );
              },
              enabled: () => f.value.length > 0
            },
            {
              id: "copy",
              label: l("Copy"),
              action: () => {
                f.value.length > 0 && d?.setClipboard(
                  "copy",
                  new Set(f.value.map((p) => J(p)))
                );
              },
              enabled: () => f.value.length > 0
            },
            {
              id: "paste",
              label: l("Paste"),
              action: () => {
                const p = d?.getClipboard();
                p?.items?.size > 0 && e?.modal?.open(p.type === "cut" ? dt : tn, {
                  items: { from: Array.from(p.items), to: d?.path?.get() },
                  clearClipboardOnSuccess: p.type === "cut"
                });
              },
              enabled: () => d?.getClipboard()?.items?.size > 0
            }
          ] : [],
          ...o("move") ? [
            {
              id: "move",
              label: l("Move files"),
              action: () => {
                if (f.value.length > 0) {
                  const p = e?.fs, F = {
                    storage: p?.path?.get()?.storage || "",
                    path: p?.path?.get()?.path || "",
                    type: "dir"
                  };
                  e?.modal?.open(dt, { items: { from: f.value, to: F } });
                }
              },
              enabled: () => f.value.length > 0
            },
            { type: "separator" }
          ] : [],
          {
            id: "copy-path",
            label: l("Copy Path"),
            action: async () => {
              const p = f.value.length === 1 ? f.value[0] : void 0;
              await on(e, [p ?? Ho(e)]);
            },
            enabled: () => !0
            // Her zaman aktif
          },
          {
            id: "copy-download-url",
            label: l("Copy Download URL"),
            action: async () => {
              if (f.value.length === 1) {
                const p = f.value[0];
                d?.path?.get()?.storage;
                const F = e?.adapter?.getDownloadUrl({ path: p.path, id: p.id });
                F && await Ja(F);
              }
            },
            enabled: () => f.value.length === 1 && f.value[0]?.type !== "dir"
          },
          { type: "separator", hidden: () => !o("rename") && !o("delete") },
          {
            id: "rename",
            label: l("Rename"),
            action: () => {
              f.value.length === 1 && e?.modal?.open(Zt, { items: f.value });
            },
            enabled: () => f.value.length === 1,
            hidden: () => !o("rename")
          },
          {
            id: "delete",
            label: l("Delete"),
            action: () => {
              f.value.length > 0 && e?.modal?.open(Jt, { items: f.value });
            },
            enabled: () => f.value.length > 0,
            hidden: () => !o("delete")
          }
        ]
      },
      {
        id: "view",
        label: l("View"),
        items: [
          {
            id: "refresh",
            label: l("Refresh"),
            action: () => {
              e.adapter.invalidateListQuery(d.path.get().path), e.adapter.open(d.path.get().path);
            },
            enabled: () => !0
          },
          { type: "separator" },
          {
            id: "grid-view",
            label: l("Grid View"),
            action: () => a?.set("view", "grid"),
            enabled: () => !0,
            checked: () => u.value?.view === "grid"
          },
          {
            id: "list-view",
            label: l("List View"),
            action: () => a?.set("view", "list"),
            enabled: () => !0,
            checked: () => u.value?.view === "list"
          },
          { type: "separator" },
          {
            id: "tree-view",
            label: l("Tree View"),
            action: () => a?.toggle("showTreeView"),
            enabled: () => !0,
            checked: () => u.value?.showTreeView
          },
          {
            id: "thumbnails",
            label: l("Show Thumbnails"),
            action: () => a?.toggle("showThumbnails"),
            enabled: () => !0,
            checked: () => u.value?.showThumbnails
          },
          {
            id: "show-hidden-files",
            label: l("Show Hidden Files"),
            action: () => a?.toggle("showHiddenFiles"),
            enabled: () => !0,
            checked: () => u.value?.showHiddenFiles
          },
          { type: "separator", hidden: () => !o("fullscreen") },
          {
            id: "fullscreen",
            label: l("Full Screen"),
            action: () => a?.toggle("fullScreen"),
            enabled: () => o("fullscreen"),
            checked: () => u.value?.fullScreen,
            hidden: () => !o("fullscreen")
          },
          { type: "separator" },
          {
            id: "persist-path",
            label: l("Persist Path"),
            action: () => {
              a?.toggle("persist"), e.emitter.emit("vf-persist-path-saved");
            },
            enabled: () => !0,
            checked: () => u.value?.persist
          },
          {
            id: "metric-units",
            label: l("Metric Units"),
            action: () => {
              a?.toggle("metricUnits"), e.filesize = a?.get("metricUnits") ? go : Yt, e.emitter.emit("vf-metric-units-saved");
            },
            enabled: () => !0,
            checked: () => u.value?.metricUnits
          }
        ]
      },
      {
        id: "go",
        label: l("Go"),
        items: [
          ...o("history") ? [
            {
              id: "forward",
              label: l("Forward"),
              action: () => {
                d?.goForward();
                const p = d?.path?.get();
                p?.path && e?.adapter.open(p.path);
              },
              enabled: () => d?.canGoForward?.get() ?? !1
            },
            {
              id: "back",
              label: l("Back"),
              action: () => {
                d?.goBack();
                const p = d?.path?.get();
                p?.path && e?.adapter.open(p.path);
              },
              enabled: () => d?.canGoBack?.get() ?? !1
            }
          ] : [],
          {
            id: "open-containing-folder",
            label: l("Open containing folder"),
            action: () => {
              const p = d?.path?.get();
              if (p?.breadcrumb && p.breadcrumb.length > 1) {
                const C = p.breadcrumb[p.breadcrumb.length - 2]?.path ?? `${p.storage}://`;
                e?.adapter.open(C);
              }
            },
            enabled: () => {
              const p = d?.path?.get();
              return p?.breadcrumb && p.breadcrumb.length > 1;
            }
          },
          { type: "separator" },
          // Dynamic storage list items will be added here
          ...(g.value || []).map((p) => ({
            id: `storage-${p}`,
            label: p,
            action: () => {
              const F = `${p}://`;
              e?.adapter.open(F);
            },
            enabled: () => !0
          })),
          { type: "separator" },
          {
            id: "go-to-folder",
            label: l("Go to Folder"),
            action: async () => {
              const p = prompt(l("Enter folder path:"));
              if (p) {
                if (!p.includes("://")) {
                  alert(l("Invalid path format. Path must be in format: storage://path/to/folder"));
                  return;
                }
                const F = p.indexOf("://"), C = p.slice(0, F);
                if (!g.value || !g.value.includes(C)) {
                  alert(l('Invalid storage. Storage "%s" is not available.', C));
                  return;
                }
                try {
                  await e?.adapter.open(p);
                } catch (E) {
                  const P = Ae(
                    E,
                    l("Failed to navigate to folder"),
                    l
                  );
                  t.error(P), e.fs.setLoading(!1);
                }
              }
            },
            enabled: () => !0
          }
        ]
      },
      {
        id: "help",
        label: l("Help"),
        items: [
          {
            id: "settings",
            label: l("Settings"),
            action: () => e?.modal?.open(gc),
            enabled: () => !0
          },
          {
            id: "shortcuts",
            label: l("Shortcuts"),
            action: () => e?.modal?.open(Oc),
            enabled: () => !0
          },
          {
            id: "about",
            label: l("About"),
            action: () => e?.modal?.open(Co),
            enabled: () => !0
          }
        ]
      }
    ]), m = (p) => {
      h.value === p ? I() : (h.value = p, v.value = !0);
    }, b = (p) => {
      v.value && (h.value = p);
    }, I = () => {
      h.value = null, v.value = !1;
    }, L = (p) => {
      I(), p();
    }, S = (p) => {
      p.target.closest(".vuefinder__menubar") || I();
    };
    return Fe(() => {
      document.addEventListener("click", S);
    }), Te(() => {
      document.removeEventListener("click", S);
    }), (p, F) => (c(), _("div", {
      class: "vuefinder__menubar",
      onClick: F[0] || (F[0] = ge(() => {
      }, ["stop"]))
    }, [
      i("div", zc, [
        (c(!0), _(he, null, ke(y.value, (C) => (c(), _("div", {
          key: C.id,
          class: re(["vuefinder__menubar__item", { "vuefinder__menubar__item--active": h.value === C.id }]),
          onClick: (E) => m(C.id),
          onMouseenter: (E) => b(C.id)
        }, [
          i("span", Lc, w(C.label), 1),
          h.value === C.id ? (c(), _("div", {
            key: 0,
            class: "vuefinder__menubar__dropdown",
            onMouseenter: (E) => b(C.id)
          }, [
            (c(!0), _(he, null, ke(C.items, (E) => (c(), _("div", {
              key: E.id || E.type,
              class: re(["vuefinder__menubar__dropdown__item", {
                "vuefinder__menubar__dropdown__item--separator": E.type === "separator",
                "vuefinder__menubar__dropdown__item--disabled": E.enabled && !E.enabled(),
                "vuefinder__menubar__dropdown__item--checked": E.checked && E.checked(),
                "vuefinder__menubar__dropdown__item--hidden": E.hidden && E.hidden()
              }]),
              onClick: ge((P) => E.type !== "separator" && E.enabled && E.enabled() ? L(E.action) : null, ["stop"])
            }, [
              E.type !== "separator" ? (c(), _("span", Nc, w(E.label), 1)) : V("", !0),
              E.checked && E.checked() ? (c(), _("span", Uc, " ✓ ")) : V("", !0)
            ], 10, Bc))), 128))
          ], 40, Vc)) : V("", !0)
        ], 42, Rc))), 128))
      ])
    ]));
  }
});
function Kc(n) {
  return n.length > 1 || n.some((e) => e.type === "dir");
}
function jo(n, e) {
  return n.length === 0 ? !1 : !e || !Kc(n);
}
function jc(n, e) {
  const t = URL.createObjectURL(n), o = document.createElement("a");
  o.href = t, o.download = e, o.style.display = "none", document.body.appendChild(o), o.click(), document.body.removeChild(o), window.setTimeout(() => URL.revokeObjectURL(t), 0);
}
async function qc(n, e) {
  const t = await n.adapter.download({ path: e.path, id: e.id });
  jc(t.blob, t.filename || e.basename || "download");
}
const Gc = { class: "vuefinder__download-modal__content" }, Wc = { class: "vuefinder__download-modal__items vf-scrollbar" }, Yc = ["checked", "onChange"], Qc = { class: "vuefinder__download-modal__name" }, Xc = { class: "vuefinder__download-modal__hint" }, Jc = ["disabled"], qo = /* @__PURE__ */ le({
  __name: "ModalDownload",
  setup(n) {
    const e = fe(), { t } = e.i18n, o = Ne(e), r = z(e.modal.data.items ?? []), l = z(new Set(r.value.map((v) => J(v)))), d = z(!1), a = B(
      () => r.value.filter((v) => l.value.has(J(v)))
    ), u = B(
      () => a.value.length > 1 || a.value.some((v) => v.type === "dir")
    ), f = (v) => Ue(v, e.i18n.t), g = (v) => {
      const x = new Set(l.value), y = J(v);
      x.has(y) ? x.delete(y) : x.add(y), l.value = x;
    }, h = async () => {
      if (!(!a.value.length || d.value)) {
        d.value = !0;
        try {
          if (!u.value && a.value[0]) {
            await qc(e, a.value[0]), e.modal.close();
            return;
          }
          e.emitter.emit("vf-download-requested", {
            items: a.value,
            archive: u.value
          }), e.modal.close();
        } catch (v) {
          o.error(Ae(v, t("Download failed"), t));
        } finally {
          d.value = !1;
        }
      }
    };
    return (v, x) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: !a.value.length || d.value,
          onClick: h
        }, w(s(t)("Download")), 9, Jc),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: x[0] || (x[0] = (y) => s(e).modal.close())
        }, w(s(t)("Close")), 1)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(an),
            title: s(t)("Download")
          }, null, 8, ["icon", "title"]),
          i("div", Gc, [
            i("div", Wc, [
              (c(!0), _(he, null, ke(r.value, (y) => (c(), _("label", {
                key: s(J)(y),
                class: "vuefinder__download-modal__item"
              }, [
                i("input", {
                  class: "vuefinder__download-modal__checkbox",
                  type: "checkbox",
                  checked: l.value.has(s(J)(y)),
                  onChange: (m) => g(y)
                }, null, 40, Yc),
                j(wt, {
                  item: y,
                  small: "",
                  view: "list"
                }, null, 8, ["item"]),
                i("span", Qc, w(f(y)), 1)
              ]))), 128))
            ]),
            i("div", Xc, w(u.value ? s(t)("Selected items will be downloaded as an archive") : s(t)("Selected file will be downloaded")), 1)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Zc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function eu(n, e) {
  return c(), _("svg", Zc, [...e[0] || (e[0] = [
    i("path", { d: "m8 10 4 4 4-4" }, null, -1)
  ])]);
}
const Go = { render: eu }, tu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function nu(n, e) {
  return c(), _("svg", tu, [...e[0] || (e[0] = [
    i("path", { d: "M6 3h8l4 4v14H6zm8 0v5h5" }, null, -1),
    i("path", { d: "m8.5 11 1.5 6 2-4 2 4 1.5-6" }, null, -1)
  ])]);
}
const Wo = { render: nu }, ou = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function su(n, e) {
  return c(), _("svg", ou, [...e[0] || (e[0] = [
    i("path", { d: "M6 3h8l4 4v14H6zm8 0v5h5M9 11l6 6m0-6-6 6" }, null, -1)
  ])]);
}
const Yo = { render: su }, iu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function ru(n, e) {
  return c(), _("svg", iu, [...e[0] || (e[0] = [
    i("circle", {
      cx: "6",
      cy: "7",
      r: "3"
    }, null, -1),
    i("circle", {
      cx: "6",
      cy: "17",
      r: "3"
    }, null, -1),
    i("path", { d: "M8.7 8.5 20 15m-11.3.5L20 9" }, null, -1)
  ])]);
}
const Qo = { render: ru }, au = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function lu(n, e) {
  return c(), _("svg", au, [...e[0] || (e[0] = [
    i("path", { d: "M9 5h6M9 3h6v4H9z" }, null, -1),
    i("rect", {
      width: "12",
      height: "16",
      x: "6",
      y: "5",
      rx: "2"
    }, null, -1)
  ])]);
}
const Xo = { render: lu }, du = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function cu(n, e) {
  return c(), _("svg", du, [...e[0] || (e[0] = [
    i("path", { d: "M12 4v12m0 0 5-5m-5 5-5-5m-2 9h14" }, null, -1)
  ])]);
}
const Jo = { render: cu }, uu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function fu(n, e) {
  return c(), _("svg", uu, [...e[0] || (e[0] = [
    i("path", { d: "m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3L7.5 14 3 9.6l6.2-.9z" }, null, -1)
  ])]);
}
const Zo = { render: fu }, vu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function _u(n, e) {
  return c(), _("svg", vu, [...e[0] || (e[0] = [
    i("path", {
      fill: "currentColor",
      d: "m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3L7.5 14 3 9.6l6.2-.9z"
    }, null, -1)
  ])]);
}
const es = { render: _u }, hu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function pu(n, e) {
  return c(), _("svg", hu, [...e[0] || (e[0] = [
    i("path", { d: "M3 12a9 9 0 1 0 3-6.7" }, null, -1),
    i("path", { d: "M3 4v5h5M12 7v5l3 2" }, null, -1)
  ])]);
}
const ts = { render: pu }, mu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function gu(n, e) {
  return c(), _("svg", mu, [...e[0] || (e[0] = [
    i("path", { d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" }, null, -1)
  ])]);
}
const wu = { render: gu }, yu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto vf-toolbar-icon",
  viewBox: "0 0 24 24"
};
function bu(n, e) {
  return c(), _("svg", yu, [...e[0] || (e[0] = [
    i("path", { d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25" }, null, -1)
  ])]);
}
const ku = { render: bu }, xu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto",
  viewBox: "0 0 24 24"
};
function $u(n, e) {
  return c(), _("svg", xu, [...e[0] || (e[0] = [
    i("path", { d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25zm0 9.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18zM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25zm0 9.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18z" }, null, -1)
  ])]);
}
const Su = { render: $u }, Cu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Fu(n, e) {
  return c(), _("svg", Cu, [...e[0] || (e[0] = [
    i("path", { d: "M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" }, null, -1)
  ])]);
}
const Eu = { render: Fu }, Du = {
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function Pu(n, e) {
  return c(), _("svg", Du, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.586a1 1 0 0 1-.293.707l-6.414 6.414a1 1 0 0 0-.293.707V17l-4 4v-6.586a1 1 0 0 0-.293-.707L3.293 7.293A1 1 0 0 1 3 6.586z"
    }, null, -1)
  ])]);
}
const Iu = { render: Pu };
function Gn(n, e) {
  n.config.set("favoriteItems", e), n.emitter.emit("vf-favorites-change", e);
}
function Pt(n, e) {
  return (n.config.get("favoriteItems") ?? []).some(
    (t) => J(t) === J(e)
  );
}
function En(n, e) {
  return e.length === 0 ? !1 : e.every((t) => t.is_storage_mount || t.is_trash || t.is_trash_root ? !1 : n.fs.isReadOnlyPath(t.path) ? !0 : !n.fs.getReadOnly() && !n.fs.isReadOnly(t));
}
function Tu(n, e) {
  const t = n.config.get("favoriteItems") ?? [];
  Gn(
    n,
    Pt(n, e) ? t.filter((o) => J(o) !== J(e)) : [e, ...t]
  );
}
const Mu = { class: "vuefinder__toolbar" }, Au = { class: "vuefinder__toolbar__actions" }, Ou = {
  key: 0,
  class: "vuefinder__toolbar__create-container"
}, zu = ["aria-expanded", "title"], Ru = {
  key: 0,
  class: "vuefinder__toolbar__create-menu"
}, Lu = ["title"], Vu = {
  key: 2,
  class: "vuefinder__toolbar__separator",
  "aria-hidden": "true"
}, Bu = ["disabled", "title"], Nu = ["disabled", "title"], Uu = ["disabled", "title"], Hu = ["disabled", "title"], Ku = ["disabled", "title"], ju = ["disabled", "title"], qu = ["disabled", "title"], Gu = ["disabled", "title"], Wu = { class: "vuefinder__toolbar__controls" }, Yu = ["title"], Qu = {
  key: 1,
  class: "vuefinder__toolbar__control vuefinder__toolbar__dropdown-container"
}, Xu = ["title"], Ju = { class: "relative" }, Zu = {
  key: 0,
  class: "vuefinder__toolbar__filter-indicator"
}, ef = {
  key: 0,
  class: "vuefinder__toolbar__dropdown"
}, tf = { class: "vuefinder__toolbar__dropdown-content" }, nf = { class: "vuefinder__toolbar__dropdown-section" }, of = { class: "vuefinder__toolbar__dropdown-label" }, sf = { class: "vuefinder__toolbar__dropdown-row" }, rf = { value: "name" }, af = { value: "size" }, lf = { value: "" }, df = { value: "asc" }, cf = { value: "desc" }, uf = { class: "vuefinder__toolbar__dropdown-section" }, ff = { class: "vuefinder__toolbar__dropdown-label" }, vf = { class: "vuefinder__toolbar__dropdown-options" }, _f = { class: "vuefinder__toolbar__dropdown-option" }, hf = { class: "vuefinder__toolbar__option-text" }, pf = { class: "vuefinder__toolbar__dropdown-option" }, mf = { class: "vuefinder__toolbar__option-text" }, gf = { class: "vuefinder__toolbar__dropdown-option" }, wf = { class: "vuefinder__toolbar__option-text" }, yf = { class: "vuefinder__toolbar__dropdown-toggle" }, bf = {
  for: "showHidden",
  class: "vuefinder__toolbar__toggle-label"
}, kf = { class: "vuefinder__toolbar__dropdown-reset" }, xf = ["title"], $f = ["title"], Sf = ["disabled", "title"], ro = /* @__PURE__ */ le({
  name: "VfToolbar",
  __name: "Toolbar",
  setup(n) {
    const e = fe(), { enabled: t } = st(), { t: o } = e.i18n, r = e.fs, l = e.config, d = Z(l.state), a = Z(r.selectedItems), u = Z(r.path), f = Z(r.clipboardItems), g = Z(r.sort), h = Z(r.filter);
    me(
      () => d.value.fullScreen,
      () => {
        const U = document.querySelector("body");
        U && (U.style.overflow = d.value.fullScreen ? "hidden" : "");
      },
      { immediate: !0 }
    );
    const v = z(!1), x = z(!1), y = (U) => {
      const O = U.target;
      O.closest(".vuefinder__toolbar__dropdown-container") || (v.value = !1), O.closest(".vuefinder__toolbar__create-container") || (x.value = !1);
    };
    Fe(() => {
      const U = document.querySelector("body");
      U && d.value.fullScreen && setTimeout(() => U.style.overflow = "hidden"), document.addEventListener("click", y);
    }), Te(() => {
      document.removeEventListener("click", y);
    });
    const m = z({
      sortBy: "name",
      // name | size | type | modified (date option is disabled in the template)
      sortOrder: "",
      // '' | asc | desc (empty means no sorting)
      filterKind: "all",
      // all | files | folders
      showHidden: d.value.showHiddenFiles
      // Initialize with config store default
    });
    me(
      () => m.value.sortBy,
      (U) => {
        if (!m.value.sortOrder) {
          r.clearSort();
          return;
        }
        U === "name" ? r.setSort("basename", m.value.sortOrder) : U === "size" ? r.setSort("file_size", m.value.sortOrder) : U === "modified" && r.setSort("last_modified", m.value.sortOrder);
      }
    ), me(
      () => m.value.sortOrder,
      (U) => {
        if (!U) {
          r.clearSort();
          return;
        }
        m.value.sortBy === "name" ? r.setSort("basename", U) : m.value.sortBy === "size" ? r.setSort("file_size", U) : m.value.sortBy === "modified" && r.setSort("last_modified", U);
      }
    ), me(
      g,
      (U) => {
        U.active ? (U.column === "basename" ? m.value.sortBy = "name" : U.column === "file_size" ? m.value.sortBy = "size" : U.column === "last_modified" && (m.value.sortBy = "modified"), m.value.sortOrder = U.order) : m.value.sortOrder = "";
      },
      { immediate: !0 }
    ), me(
      () => m.value.filterKind,
      (U) => {
        r.setFilter(U, d.value.showHiddenFiles);
      }
    ), me(
      () => m.value.showHidden,
      (U) => {
        l.set("showHiddenFiles", U), r.setFilter(m.value.filterKind, U);
      }
    ), me(
      h,
      (U) => {
        m.value.filterKind = U.kind;
      },
      { immediate: !0 }
    ), me(
      () => d.value.showHiddenFiles,
      (U) => {
        m.value.showHidden = U, r.setFilter(m.value.filterKind, U);
      },
      { immediate: !0 }
    );
    const b = () => l.set("view", d.value.view === "grid" ? "list" : "grid"), I = B(() => h.value.kind !== "all" || !d.value.showHiddenFiles || g.value.active), L = () => {
      m.value = {
        sortBy: "name",
        sortOrder: "",
        // No sorting by default
        filterKind: "all",
        showHidden: !0
        // Reset to default value
      }, l.set("showHiddenFiles", !0), r.clearSort(), r.clearFilter();
    }, S = B(() => r.getReadOnly()), p = B(
      () => a.value.some((U) => r.isReadOnly(U))
    ), F = B(() => !S.value), C = B(
      () => a.value.length > 0 && !p.value
    ), E = B(
      () => a.value.length === 1 && !p.value
    ), P = B(() => t("copy") && a.value.length > 0), N = B(() => t("move") && C.value), te = B(
      () => t("copy") && F.value && f.value.items.size > 0
    ), W = Z(r.disabledFeatures), se = B(
      () => t("download") && jo(a.value, W.value.includes("archive"))
    ), $ = B(
      () => a.value.length === 1 && En(e, a.value)
    ), k = B(() => {
      if (!t("history") || a.value.length !== 1)
        return !1;
      const U = a.value[0];
      if (!U || U.is_trash_root || String(U.id ?? "").startsWith("trash:"))
        return !1;
      const O = Number(U.id);
      return Number.isFinite(O) && O > 0;
    });
    function T() {
      k.value && e.emitter.emit("vf-history-request", { items: a.value });
    }
    const M = B(() => $.value ? (d.value.favoriteItems, Pt(e, a.value[0])) : !1), q = B(
      () => a.value.length === 0 && u.value.breadcrumb.length === 0
    ), pe = () => {
      x.value = !x.value;
    }, R = () => {
      x.value = !1, e.modal.open(qn, { items: a.value });
    }, D = (U, O) => {
      x.value = !1, e.modal.open(qt, { extension: U, officeKind: O });
    }, A = () => {
      if (!te.value) return;
      const U = r.getClipboard();
      e.modal.open(U.type === "cut" ? dt : tn, {
        items: { from: Array.from(U.items), to: r.path.get() },
        clearClipboardOnSuccess: U.type === "cut"
      });
    }, H = (U) => {
      e.emitter.emit("vf-contextmenu-show", {
        event: U,
        items: a.value,
        target: a.value[0] ?? null
      });
    };
    return (U, O) => (c(), _("div", Mu, [
      i("div", Au, [
        F.value && (s(t)("newfolder") || s(t)("newfile")) ? (c(), _("div", Ou, [
          i("button", {
            type: "button",
            class: "vuefinder__toolbar__button vuefinder__toolbar__button--primary vuefinder__toolbar__button--compact",
            "aria-expanded": x.value,
            title: s(o)("Create"),
            onClick: ge(pe, ["stop"])
          }, [
            j(s(Mt), { class: "vf-toolbar-icon vuefinder__toolbar__create-icon" }),
            i("span", null, w(s(o)("Create")), 1),
            j(s(Go), {
              class: "vuefinder__toolbar__chevron",
              "aria-hidden": "true"
            })
          ], 8, zu),
          x.value ? (c(), _("div", Ru, [
            s(t)("newfolder") ? (c(), _("button", {
              key: 0,
              type: "button",
              class: "vuefinder__toolbar__create-item",
              onClick: R
            }, [
              j(s(rn), { class: "vf-toolbar-icon vuefinder__toolbar__create-menu-icon" }),
              ye(" " + w(s(o)("Create folder")), 1)
            ])) : V("", !0),
            s(t)("newfile") ? (c(), _("button", {
              key: 1,
              type: "button",
              class: "vuefinder__toolbar__create-item",
              onClick: O[0] || (O[0] = (X) => D("docx", "word"))
            }, [
              j(s(Wo), { class: "vuefinder__toolbar__create-menu-icon" }),
              ye(" " + w(s(o)("Create Word")), 1)
            ])) : V("", !0),
            s(t)("newfile") ? (c(), _("button", {
              key: 2,
              type: "button",
              class: "vuefinder__toolbar__create-item",
              onClick: O[1] || (O[1] = (X) => D("xlsx", "excel"))
            }, [
              j(s(Yo), { class: "vuefinder__toolbar__create-menu-icon" }),
              ye(" " + w(s(o)("Create Excel")), 1)
            ])) : V("", !0)
          ])) : V("", !0)
        ])) : V("", !0),
        s(t)("upload") && F.value ? (c(), _("button", {
          key: 1,
          type: "button",
          class: "vuefinder__toolbar__button",
          title: s(o)("Upload"),
          onClick: O[2] || (O[2] = (X) => s(e).modal.open(ln, { items: s(a) }))
        }, [
          j(s(an), { class: "vf-toolbar-icon" }),
          i("span", null, w(s(o)("Upload")), 1)
        ], 8, Lu)) : V("", !0),
        F.value && (s(t)("newfolder") || s(t)("newfile") || s(t)("upload")) ? (c(), _("div", Vu)) : V("", !0),
        s(t)("copy") ? (c(), _("button", {
          key: 3,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: !P.value,
          title: s(o)("Copy"),
          onClick: O[3] || (O[3] = (X) => s(r).setClipboardItems("copy", s(a)))
        }, [
          j(s(Tt), { class: "vf-toolbar-icon" })
        ], 8, Bu)) : V("", !0),
        s(t)("move") ? (c(), _("button", {
          key: 4,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: !N.value,
          title: s(o)("Cut"),
          onClick: O[4] || (O[4] = (X) => s(r).setClipboardItems("cut", s(a)))
        }, [
          j(s(Qo), { class: "vf-toolbar-icon" })
        ], 8, Nu)) : V("", !0),
        s(t)("copy") ? (c(), _("button", {
          key: 5,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: !te.value,
          title: s(o)("Paste"),
          onClick: A
        }, [
          j(s(Xo), { class: "vf-toolbar-icon" })
        ], 8, Uu)) : V("", !0),
        s(t)("rename") ? (c(), _("button", {
          key: 6,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: !E.value,
          title: s(o)("Rename"),
          onClick: O[5] || (O[5] = (X) => s(e).modal.open(Zt, { items: s(a) }))
        }, [
          j(s(Ln), { class: "vf-toolbar-icon" })
        ], 8, Hu)) : V("", !0),
        s(t)("delete") ? (c(), _("button", {
          key: 7,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon vuefinder__toolbar__button--danger",
          disabled: !C.value,
          title: s(o)("Delete"),
          onClick: O[6] || (O[6] = (X) => s(e).modal.open(Jt, { items: s(a) }))
        }, [
          j(s(It), { class: "vf-toolbar-icon" })
        ], 8, Ku)) : V("", !0),
        s(t)("download") ? (c(), _("button", {
          key: 8,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: !se.value,
          title: s(o)("Download"),
          onClick: O[7] || (O[7] = (X) => s(e).modal.open(qo, { items: s(a) }))
        }, [
          j(s(Jo), { class: "vf-toolbar-icon" })
        ], 8, ju)) : V("", !0),
        i("button", {
          type: "button",
          class: re(["vuefinder__toolbar__button vuefinder__toolbar__button--icon", { "vuefinder__toolbar__button--active": M.value }]),
          disabled: !$.value,
          title: M.value ? s(o)("Remove from favorites") : s(o)("Add to favorites"),
          onClick: O[8] || (O[8] = (X) => $.value && s(Tu)(s(e), s(a)[0]))
        }, [
          M.value ? (c(), Y(s(es), {
            key: 0,
            class: "vf-toolbar-icon vuefinder__toolbar__favorite-icon--active"
          })) : (c(), Y(s(Zo), {
            key: 1,
            class: "vf-toolbar-icon"
          }))
        ], 10, qu),
        s(t)("history") ? (c(), _("button", {
          key: 9,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: !k.value,
          title: s(o)("History"),
          onClick: T
        }, [
          j(s(ts), { class: "vf-toolbar-icon" })
        ], 8, Gu)) : V("", !0)
      ]),
      i("div", Wu, [
        s(t)("search") ? (c(), _("div", {
          key: 0,
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          title: s(o)("Search Files"),
          onClick: O[9] || (O[9] = (X) => s(e).modal.open(Kn))
        }, [
          j(s(Hn), { class: "vf-toolbar-icon" })
        ], 8, Yu)) : V("", !0),
        s(t)("filter") ? (c(), _("div", Qu, [
          i("div", {
            title: s(o)("Filter"),
            class: "vuefinder__toolbar__dropdown-trigger",
            onClick: O[10] || (O[10] = (X) => v.value = !v.value)
          }, [
            i("div", Ju, [
              j(s(Iu), { class: "vf-toolbar-icon vuefinder__toolbar__icon h-6 w-6" }),
              I.value ? (c(), _("div", Zu)) : V("", !0)
            ])
          ], 8, Xu),
          v.value ? (c(), _("div", ef, [
            i("div", tf, [
              i("div", nf, [
                i("div", of, w(s(o)("Sorting")), 1),
                i("div", sf, [
                  xe(i("select", {
                    "onUpdate:modelValue": O[11] || (O[11] = (X) => m.value.sortBy = X),
                    class: "vuefinder__toolbar__dropdown-select"
                  }, [
                    i("option", rf, w(s(o)("Name")), 1),
                    i("option", af, w(s(o)("Size")), 1)
                  ], 512), [
                    [yn, m.value.sortBy]
                  ]),
                  xe(i("select", {
                    "onUpdate:modelValue": O[12] || (O[12] = (X) => m.value.sortOrder = X),
                    class: "vuefinder__toolbar__dropdown-select"
                  }, [
                    i("option", lf, w(s(o)("None")), 1),
                    i("option", df, w(s(o)("Asc")), 1),
                    i("option", cf, w(s(o)("Desc")), 1)
                  ], 512), [
                    [yn, m.value.sortOrder]
                  ])
                ])
              ]),
              i("div", uf, [
                i("div", ff, w(s(o)("Show")), 1),
                i("div", vf, [
                  i("label", _f, [
                    xe(i("input", {
                      "onUpdate:modelValue": O[13] || (O[13] = (X) => m.value.filterKind = X),
                      type: "radio",
                      name: "filterKind",
                      value: "all",
                      class: "vuefinder__toolbar__radio"
                    }, null, 512), [
                      [pn, m.value.filterKind]
                    ]),
                    i("span", hf, w(s(o)("All items")), 1)
                  ]),
                  i("label", pf, [
                    xe(i("input", {
                      "onUpdate:modelValue": O[14] || (O[14] = (X) => m.value.filterKind = X),
                      type: "radio",
                      name: "filterKind",
                      value: "files",
                      class: "vuefinder__toolbar__radio"
                    }, null, 512), [
                      [pn, m.value.filterKind]
                    ]),
                    i("span", mf, w(s(o)("Files only")), 1)
                  ]),
                  i("label", gf, [
                    xe(i("input", {
                      "onUpdate:modelValue": O[15] || (O[15] = (X) => m.value.filterKind = X),
                      type: "radio",
                      name: "filterKind",
                      value: "folders",
                      class: "vuefinder__toolbar__radio"
                    }, null, 512), [
                      [pn, m.value.filterKind]
                    ]),
                    i("span", wf, w(s(o)("Folders only")), 1)
                  ])
                ])
              ]),
              i("div", yf, [
                i("label", bf, w(s(o)("Show hidden files")), 1),
                xe(i("input", {
                  id: "showHidden",
                  "onUpdate:modelValue": O[16] || (O[16] = (X) => m.value.showHidden = X),
                  type: "checkbox",
                  class: "vuefinder__toolbar__checkbox"
                }, null, 512), [
                  [Wt, m.value.showHidden]
                ])
              ]),
              i("div", kf, [
                i("button", {
                  class: "vuefinder__toolbar__reset-button",
                  onClick: L
                }, w(s(o)("Reset")), 1)
              ])
            ])
          ])) : V("", !0)
        ])) : V("", !0),
        s(t)("fullscreen") ? (c(), _("div", {
          key: 2,
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          title: s(o)("Toggle Full Screen"),
          onClick: O[17] || (O[17] = (X) => s(l).toggle("fullScreen"))
        }, [
          s(d).fullScreen ? (c(), Y(s(ku), {
            key: 0,
            class: "vf-toolbar-icon"
          })) : (c(), Y(s(wu), {
            key: 1,
            class: "vf-toolbar-icon"
          }))
        ], 8, xf)) : V("", !0),
        s(t)("viewToggle") ? (c(), _("button", {
          key: 3,
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          title: s(o)("Change View"),
          onClick: O[18] || (O[18] = (X) => b())
        }, [
          s(d).view === "grid" ? (c(), Y(s(Su), {
            key: 0,
            class: "vf-toolbar-icon"
          })) : V("", !0),
          s(d).view === "list" ? (c(), Y(s(Eu), {
            key: 1,
            class: "vf-toolbar-icon"
          })) : V("", !0)
        ], 8, $f)) : V("", !0),
        i("button", {
          type: "button",
          class: "vuefinder__toolbar__button vuefinder__toolbar__button--icon",
          disabled: q.value,
          title: s(o)("More actions"),
          onClick: ge(H, ["stop"])
        }, [
          j(s(sn), { class: "vf-toolbar-icon vuefinder__toolbar__more-icon" })
        ], 8, Sf),
        Ce(U.$slots, "toolbar-actions")
      ])
    ]));
  }
}), Cf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "vuefinder__breadcrumb__refresh-icon",
  viewBox: "-40 -40 580 580"
};
function Ff(n, e) {
  return c(), _("svg", Cf, [...e[0] || (e[0] = [
    i("path", { d: "M463.5 224h8.5c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2S461.9 48.1 455 55l-41.6 41.6c-87.6-86.5-228.7-86.2-315.8 1-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 224 344 224z" }, null, -1)
  ])]);
}
const ns = { render: Ff }, Ef = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Df(n, e) {
  return c(), _("svg", Ef, [...e[0] || (e[0] = [
    i("path", { d: "m6 15 6-6 6 6" }, null, -1)
  ])]);
}
const Pf = { render: Df }, If = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  class: "vuefinder__breadcrumb__close-icon",
  viewBox: "0 0 24 24"
};
function Tf(n, e) {
  return c(), _("svg", If, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    }, null, -1)
  ])]);
}
const Mf = { render: Tf }, Af = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Of(n, e) {
  return c(), _("svg", Af, [...e[0] || (e[0] = [
    i("path", {
      d: "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L4 10.414V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.586l.293.293a1 1 0 0 0 1.414-1.414z",
      class: "pointer-events-none"
    }, null, -1)
  ])]);
}
const zf = { render: Of }, Rf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  class: "w-6 h-6 cursor-pointer",
  viewBox: "0 0 24 24"
};
function Lf(n, e) {
  return c(), _("svg", Rf, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    }, null, -1)
  ])]);
}
const Vf = { render: Lf }, Bf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Nf(n, e) {
  return c(), _("svg", Bf, [...e[0] || (e[0] = [
    i("rect", {
      width: "18",
      height: "16",
      x: "3",
      y: "4",
      rx: "2"
    }, null, -1),
    i("path", { d: "M9 4v16m5-12-4 4 4 4" }, null, -1)
  ])]);
}
const Uf = { render: Nf }, Hf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function Kf(n, e) {
  return c(), _("svg", Hf, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 7h12m0 0-4-4m4 4-4 4m0 6H4m0 0 4 4m-4-4 4-4"
    }, null, -1)
  ])]);
}
const jf = { render: Kf };
function At(n, e = []) {
  const t = "vfDragEnterCounter", o = n.fs, r = Z(o.selectedItems);
  function l(h, v) {
    return !!(!h || h.type !== "dir" || h.read_only || o.isReadOnlyPath(h.path) || v && o.isReadOnly(v) || !v || jt(v, h.path) || r.value.some(
      (y) => jt(y, h.path)
    ));
  }
  function d(h, v) {
    if (h.isExternalDrag)
      return;
    if (!(n.features?.move ?? !1) || o.isFeatureDisabled("move")) {
      h.dataTransfer && (h.dataTransfer.dropEffect = "none", h.dataTransfer.effectAllowed = "none");
      return;
    }
    h.preventDefault();
    const y = o.getDraggedItem(), m = o.sortedFiles.get().find((b) => J(b) === y);
    l(v, m) ? h.dataTransfer && (h.dataTransfer.dropEffect = "none", h.dataTransfer.effectAllowed = "none") : (h.dataTransfer && (h.dataTransfer.dropEffect = "copy", h.dataTransfer.effectAllowed = "all"), h.currentTarget.classList.add(...e));
  }
  function a(h) {
    if (h.isExternalDrag || !(n.features?.move ?? !1) || o.isFeatureDisabled("move"))
      return;
    h.preventDefault();
    const x = h.currentTarget, y = Number(x.dataset[t] || 0);
    x.dataset[t] = String(y + 1);
  }
  function u(h) {
    if (h.isExternalDrag || !(n.features?.move ?? !1) || o.isFeatureDisabled("move"))
      return;
    h.preventDefault();
    const x = h.currentTarget, m = Number(x.dataset[t] || 0) - 1;
    m <= 0 ? (delete x.dataset[t], x.classList.remove(...e)) : x.dataset[t] = String(m);
  }
  function f(h, v) {
    if (h.isExternalDrag || !(n.features?.move ?? !1) || o.isFeatureDisabled("move") || !v) return;
    h.preventDefault();
    const y = h.currentTarget, m = o.getDraggedItem(), b = o.sortedFiles.get().find((p) => J(p) === m);
    if (l(v, b)) {
      delete y.dataset[t], y.classList.remove(...e), o.clearDraggedItem();
      return;
    }
    delete y.dataset[t], y.classList.remove(...e);
    const I = h.dataTransfer?.getData("items") || "[]", S = JSON.parse(I).map(
      (p) => o.sortedFiles.get().find((F) => J(F) === p)
    );
    o.clearDraggedItem(), n.modal.open(dt, { items: { from: S, to: v } });
  }
  function g(h) {
    return {
      dragover: (v) => d(v, h),
      dragenter: a,
      dragleave: u,
      drop: (v) => f(v, h)
    };
  }
  return { events: g };
}
const qf = { class: "vuefinder__breadcrumb__container" }, Gf = ["title"], Wf = ["title"], Yf = ["title"], Qf = ["title"], Xf = { class: "vuefinder__breadcrumb__path-container" }, Jf = { class: "vuefinder__breadcrumb__list" }, Zf = {
  key: 0,
  class: "vuefinder__breadcrumb__hidden-list"
}, ev = { class: "relative" }, tv = ["title", "onClick"], nv = ["title"], ov = { class: "vuefinder__breadcrumb__path-mode" }, sv = { class: "vuefinder__breadcrumb__path-mode-content" }, iv = ["title"], rv = { class: "vuefinder__breadcrumb__path-text" }, av = ["title"], lv = ["data-theme"], dv = ["onClick"], cv = { class: "vuefinder__breadcrumb__hidden-item-content" }, uv = { class: "vuefinder__breadcrumb__hidden-item-text" }, fv = /* @__PURE__ */ le({
  __name: "Breadcrumb",
  setup(n) {
    const e = fe(), { t } = e.i18n, o = e.fs, r = e.config, l = Z(r.state), d = Z(o.path), a = Z(o.loading), u = Z(o.mounts), f = B(
      () => Ao(
        d.value?.path,
        t,
        l.value.storageLabels || {},
        u.value
      )
    ), g = z(null), h = Bo(0, 100), v = z(5), x = z(!1), y = z(!1), m = B(() => d.value?.breadcrumb ?? []);
    function b(R, D) {
      return R.length > D ? [R.slice(-D), R.slice(0, -D)] : [R, []];
    }
    const I = B(
      () => b(m.value, v.value)[0]
    ), L = B(
      () => b(m.value, v.value)[1]
    ), S = (R) => Ue(R, e.i18n.t);
    me(h, () => {
      if (!g.value) return;
      const R = g.value.children;
      let D = 0, A = 0;
      const H = 5, U = 1;
      v.value = H, Ve(() => {
        for (let O = R.length - 1; O >= 0; O--) {
          const X = R[O];
          if (D + X.offsetWidth > h.value - 40)
            break;
          D += parseInt(X.offsetWidth.toString(), 10), A++;
        }
        A < U && (A = U), A > H && (A = H), v.value = A;
      });
    });
    const p = () => {
      g.value && (h.value = g.value.offsetWidth);
    }, F = z(null);
    Fe(() => {
      F.value = new ResizeObserver(p), g.value && F.value.observe(g.value);
    }), Te(() => {
      F.value && F.value.disconnect();
    });
    const C = At(e, ["vuefinder__drag-over"]);
    function E(R = null) {
      R ??= m.value.length - 2;
      const D = {
        basename: d.value?.storage ?? "local",
        extension: "",
        path: (d.value?.storage ?? "local") + "://",
        storage: d.value?.storage ?? "local",
        type: "dir",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: ""
      };
      return m.value[R] ?? D;
    }
    const P = () => {
      e.adapter.invalidateListQuery(d.value.path), e.adapter.open(d.value.path);
    }, N = () => {
      I.value.length > 0 && e.adapter.open(
        m.value[m.value.length - 2]?.path ?? (d.value?.storage ?? "local") + "://"
      );
    }, te = (R) => {
      e.adapter.open(R.path), x.value = !1;
    }, W = () => {
      x.value && (x.value = !1);
    }, se = {
      mounted(R, D) {
        R.clickOutsideEvent = function(A) {
          R === A.target || R.contains(A.target) || D.value();
        }, document.body.addEventListener("click", R.clickOutsideEvent);
      },
      beforeUnmount(R) {
        document.body.removeEventListener("click", R.clickOutsideEvent);
      }
    }, $ = () => {
      r.toggle("showTreeView");
    }, k = z({
      x: 0,
      y: 0
    }), T = (R, D = null) => {
      if (R.currentTarget instanceof HTMLElement) {
        const { x: A, y: H, height: U } = R.currentTarget.getBoundingClientRect();
        k.value = { x: A, y: H + U };
      }
      x.value = D ?? !x.value;
    }, M = () => {
      y.value = !y.value;
    }, q = () => on(e, [Ho(e)]), pe = () => {
      y.value = !1;
    };
    return (R, D) => (c(), _("div", qf, [
      i("span", {
        title: s(t)("Toggle Tree View")
      }, [
        j(s(Uf), {
          class: re(["vuefinder__breadcrumb__toggle-tree", s(l).showTreeView ? "vuefinder__breadcrumb__toggle-tree--active" : ""]),
          onClick: $
        }, null, 8, ["class"])
      ], 8, Gf),
      i("span", {
        title: s(t)("Go up a directory")
      }, [
        j(s(Pf), je({
          class: m.value.length ? "vuefinder__breadcrumb__go-up--active" : "vuefinder__breadcrumb__go-up--inactive"
        }, nt(m.value.length ? s(C).events(E()) : {}), { onClick: N }), null, 16, ["class"])
      ], 8, Wf),
      s(o).isLoading() ? (c(), _("span", {
        key: 1,
        title: s(t)("Cancel")
      }, [
        j(s(Mf), {
          onClick: D[0] || (D[0] = (A) => s(e).emitter.emit("vf-fetch-abort"))
        })
      ], 8, Qf)) : (c(), _("span", {
        key: 0,
        title: s(t)("Refresh")
      }, [
        j(s(ns), { onClick: P })
      ], 8, Yf)),
      xe(i("div", Xf, [
        i("div", null, [
          j(s(zf), je({ class: "vuefinder__breadcrumb__home-icon" }, nt(s(C).events(E(-1))), {
            onClick: D[1] || (D[1] = ge((A) => s(e).adapter.open(s(d).storage + "://"), ["stop"]))
          }), null, 16)
        ]),
        i("div", Jf, [
          L.value.length ? xe((c(), _("div", Zf, [
            D[3] || (D[3] = i("div", { class: "vuefinder__breadcrumb__separator" }, "/", -1)),
            i("div", ev, [
              i("span", {
                class: "vuefinder__breadcrumb__hidden-toggle",
                onDragenter: D[2] || (D[2] = (A) => T(A, !0)),
                onClick: ge(T, ["stop"])
              }, [
                j(s(sn), { class: "vuefinder__breadcrumb__hidden-toggle-icon" })
              ], 32)
            ])
          ])), [
            [se, W]
          ]) : V("", !0)
        ]),
        i("div", {
          ref_key: "breadcrumbContainer",
          ref: g,
          class: "vuefinder__breadcrumb__visible-list pointer-events-none"
        }, [
          (c(!0), _(he, null, ke(I.value, (A, H) => (c(), _("div", { key: H }, [
            D[4] || (D[4] = i("span", { class: "vuefinder__breadcrumb__separator" }, "/", -1)),
            i("span", je({
              class: "vuefinder__breadcrumb__item pointer-events-auto",
              title: S(A)
            }, nt(s(C).events(A), !0), {
              onClick: ge((U) => s(e).adapter.open(A.path), ["stop"])
            }), w(S(A)), 17, tv)
          ]))), 128))
        ], 512),
        s(r).get("loadingIndicator") === "circular" && s(a) ? (c(), Y(s(nn), { key: 0 })) : V("", !0),
        i("span", {
          title: s(t)("Toggle Path Copy Mode"),
          onClick: M
        }, [
          j(s(jf), { class: "vuefinder__breadcrumb__toggle-icon" })
        ], 8, nv)
      ], 512), [
        [ze, !y.value]
      ]),
      xe(i("div", ov, [
        i("div", sv, [
          i("div", {
            title: s(t)("Copy Path")
          }, [
            j(s(Tt), {
              class: "vuefinder__breadcrumb__copy-icon",
              onClick: q
            })
          ], 8, iv),
          i("div", rv, w(f.value), 1),
          i("div", {
            title: s(t)("Exit")
          }, [
            j(s(Vf), {
              class: "vuefinder__breadcrumb__exit-icon",
              onClick: pe
            })
          ], 8, av)
        ])
      ], 512), [
        [ze, y.value]
      ]),
      (c(), Y(Et, { to: "body" }, [
        i("div", null, [
          xe(i("div", {
            style: Be({
              position: "absolute",
              top: k.value.y + "px",
              left: k.value.x + "px"
            }),
            class: "vuefinder__themer vuefinder__breadcrumb__hidden-dropdown",
            "data-theme": s(e).theme.current
          }, [
            (c(!0), _(he, null, ke(L.value, (A, H) => (c(), _("div", je({
              key: H,
              class: "vuefinder__breadcrumb__hidden-item"
            }, nt(s(C).events(A), !0), {
              onClick: (U) => te(A)
            }), [
              i("div", cv, [
                i("span", null, [
                  j(s(et), { class: "vuefinder__breadcrumb__hidden-item-icon" })
                ]),
                i("span", uv, w(S(A)), 1)
              ])
            ], 16, dv))), 128))
          ], 12, lv), [
            [ze, x.value]
          ])
        ])
      ]))
    ]));
  }
}), vv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function _v(n, e) {
  return c(), _("svg", vv, [...e[0] || (e[0] = [
    i("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 21h10a2 2 0 0 0 2-2V9.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 12.586 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
    }, null, -1)
  ])]);
}
const ao = { render: _v }, hv = { class: "vuefinder__drag-item__container" }, pv = { class: "vuefinder__drag-item__count" }, mv = /* @__PURE__ */ le({
  __name: "DragItem",
  props: {
    count: {}
  },
  setup(n) {
    const e = n;
    return (t, o) => (c(), _("div", hv, [
      e.count > 1 ? (c(), Y(s(ao), {
        key: 0,
        class: "vuefinder__drag-item__icon translate-x-1 translate-y-1"
      })) : V("", !0),
      j(s(ao), { class: "vuefinder__drag-item__icon" }),
      i("div", pv, w(e.count), 1)
    ]));
  }
}), gv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
function wv(n, e) {
  return c(), _("svg", gv, [...e[0] || (e[0] = [
    i("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    i("path", { d: "M12 2a5 5 0 0 1 5 5v3a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3V7a5 5 0 0 1 5-5m0 12a2 2 0 0 0-1.995 1.85L10 16a2 2 0 1 0 2-2m0-10a3 3 0 0 0-3 3v3h6V7a3 3 0 0 0-3-3" }, null, -1)
  ])]);
}
const Dn = { render: wv }, yv = ["data-key", "data-row", "data-col", "draggable"], bv = { key: 0 }, kv = { class: "vuefinder__explorer__item-grid-content" }, xv = ["data-src", "alt"], $v = { class: "vuefinder__explorer__item-title" }, Sv = {
  key: 1,
  class: "vuefinder__explorer__item-list-content"
}, Cv = { class: "vuefinder__explorer__item-list-name" }, Fv = { class: "vuefinder__explorer__item-list-icon" }, Ev = { class: "vuefinder__explorer__item-name" }, Dv = {
  key: 0,
  class: "vuefinder__explorer__item-path"
}, Pv = {
  key: 1,
  class: "vuefinder__explorer__item-date"
}, Iv = {
  key: 2,
  class: "vuefinder__explorer__item-type"
}, Tv = {
  key: 3,
  class: "vuefinder__explorer__item-size"
}, Mv = { key: 0 }, Av = /* @__PURE__ */ le({
  __name: "FileItem",
  props: {
    item: {},
    view: {},
    showThumbnails: { type: Boolean },
    isSelected: { type: Boolean },
    isDragging: { type: Boolean },
    rowIndex: {},
    colIndex: {},
    showPath: { type: Boolean },
    explorerId: {}
  },
  emits: ["click", "dblclick", "contextmenu", "dragstart", "dragend"],
  setup(n, { emit: e }) {
    const t = n, o = e, r = fe(), l = r.fs, d = r.config, a = B(() => {
      const T = r.selectionFilterType;
      return !T || T === "both" ? !0 : T === "files" && t.item.type === "file" || T === "dirs" && t.item.type === "dir";
    }), u = B(() => {
      const T = r.selectionFilterMimeIncludes;
      return !T || !T.length || t.item.type === "dir" ? !0 : t.item.mime_type ? T.some((M) => t.item.mime_type?.startsWith(M)) : !1;
    }), f = B(() => a.value && u.value), g = B(() => [
      "file-item-" + t.explorerId,
      t.view === "grid" ? "vf-explorer-item-grid" : "vf-explorer-item-list",
      t.isSelected ? "vf-explorer-selected" : "",
      f.value ? "" : "vf-explorer-item--unselectable",
      t.item.is_trash_root ? "vf-explorer-item--trash-root" : ""
    ]), h = B(() => ({
      opacity: t.isDragging || l.isCut(J(t.item)) || !f.value ? 0.5 : ""
    })), v = B(() => kn(t.item, r.i18n.t)), x = B(() => xn(t.item.last_modified)), y = B(() => Ue(t.item, r.i18n.t)), m = z(null);
    let b = !1, I = null, L = null, S = !1;
    const { enabled: p } = st(), F = typeof window < "u" && ("ontouchstart" in window || navigator.maxTouchPoints > 0), C = B(() => F ? !1 : p("move")), E = () => {
      I && (clearTimeout(I), I = null), L = null;
    }, P = (T) => {
      E(), L = T, S = !1, T.stopPropagation(), I = setTimeout(() => {
        !L || I === null || (S = !0, L.cancelable && L.preventDefault(), L.stopPropagation(), o("contextmenu", L), E());
      }, 500);
    }, N = (T) => {
      if (S) {
        T.preventDefault(), T.stopPropagation(), E();
        return;
      }
      setTimeout(() => {
        S || (E(), $(T));
      }, 100);
    }, te = (T) => {
      if (!L) return;
      const M = L.touches[0] || L.changedTouches[0], q = T.touches[0] || T.changedTouches[0];
      if (M && q) {
        const pe = Math.abs(q.clientX - M.clientX), R = Math.abs(q.clientY - M.clientY);
        (pe > 15 || R > 15) && E();
      }
    }, W = (T) => {
      F && T.type !== "click" || o("click", T);
    }, se = (T) => {
      if (S)
        return T.preventDefault(), T.stopPropagation(), !1;
      o("dragstart", T);
    }, $ = (T) => {
      if (!b)
        b = !0, o("click", T), m.value = setTimeout(() => {
          b = !1;
        }, 300);
      else
        return b = !1, o("dblclick", T), !1;
    }, k = z(null);
    return (T, M) => (c(), _("div", {
      class: re(g.value),
      style: Be(h.value),
      "data-key": s(J)(n.item),
      "data-row": n.rowIndex,
      "data-col": n.colIndex,
      draggable: C.value,
      onTouchstartCapture: M[2] || (M[2] = (q) => P(q)),
      onTouchendCapture: M[3] || (M[3] = (q) => N(q)),
      onTouchmoveCapture: te,
      onTouchcancelCapture: M[4] || (M[4] = () => E()),
      onClick: W,
      onDblclick: M[5] || (M[5] = (q) => o("dblclick", q)),
      onContextmenu: M[6] || (M[6] = ge((q) => o("contextmenu", q), ["prevent", "stop"])),
      onDragstart: se,
      onDragend: M[7] || (M[7] = (q) => o("dragend", q))
    }, [
      n.view === "grid" ? (c(), _("div", bv, [
        s(l).isReadOnly(n.item) ? (c(), Y(s(Dn), {
          key: 0,
          class: "vuefinder__item--readonly vuefinder__item--readonly--left",
          title: "Read Only"
        })) : V("", !0),
        i("div", kv, [
          n.showThumbnails && s(qi)(n.item) && k.value !== s(J)(n.item) ? (c(), _("img", {
            key: 0,
            src: "data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
            class: "vuefinder__explorer__item-thumbnail lazy",
            "data-src": n.item.previewUrl ?? s(r).adapter.getPreviewUrl({ path: n.item.path, id: n.item.id }),
            alt: y.value,
            onTouchstart: M[0] || (M[0] = (q) => q.preventDefault()),
            onError: M[1] || (M[1] = (q) => k.value = s(J)(n.item))
          }, null, 40, xv)) : (c(), Y(wt, {
            key: 1,
            item: n.item,
            ext: !0,
            view: n.view
          }, {
            icon: ae((q) => [
              Ce(T.$slots, "icon", We(Ye(q)))
            ]),
            _: 3
          }, 8, ["item", "view"]))
        ]),
        i("span", $v, w(s(Fn)(y.value)), 1)
      ])) : (c(), _("div", Sv, [
        i("div", Cv, [
          i("div", Fv, [
            j(wt, {
              item: n.item,
              view: n.view
            }, {
              icon: ae((q) => [
                Ce(T.$slots, "icon", We(Ye(q)))
              ]),
              _: 3
            }, 8, ["item", "view"])
          ]),
          i("span", Ev, w(y.value), 1),
          i("div", null, [
            s(l).isReadOnly(n.item) ? (c(), Y(s(Dn), {
              key: 0,
              class: "vuefinder__item--readonly vuefinder__item--readonly--list",
              title: "Read Only"
            })) : V("", !0)
          ])
        ]),
        n.showPath ? (c(), _("div", Dv, w(n.item.path), 1)) : V("", !0),
        n.showPath ? V("", !0) : (c(), _("div", Pv, w(x.value), 1)),
        n.showPath ? V("", !0) : (c(), _("div", Iv, w(v.value), 1)),
        n.showPath ? V("", !0) : (c(), _("div", Tv, [
          n.item.file_size ? (c(), _("div", Mv, w(s(r).filesize(n.item.file_size)), 1)) : V("", !0)
        ]))
      ])),
      s(p)("pinned") && s(d).get("pinnedFolders").find((q) => q.path === n.item.path) ? (c(), Y(s(Vn), {
        key: 2,
        class: "vuefinder__item--pinned"
      })) : V("", !0)
    ], 46, yv));
  }
}), Ov = ["data-row"], lo = /* @__PURE__ */ le({
  __name: "FileRow",
  props: {
    rowIndex: {},
    rowHeight: {},
    view: {},
    itemsPerRow: {},
    items: {},
    showThumbnails: { type: Boolean },
    showPath: { type: Boolean },
    isDraggingItem: { type: Function },
    isSelected: { type: Function },
    dragNDropEvents: { type: Function },
    explorerId: {}
  },
  emits: ["click", "dblclick", "contextmenu", "dragstart", "dragend"],
  setup(n, { emit: e }) {
    const t = n, o = e, r = B(() => [
      t.view === "grid" ? "vf-explorer-item-grid-row" : "vf-explorer-item-list-row",
      "pointer-events-none"
    ]), l = B(() => ({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: `${t.rowHeight}px`,
      transform: `translateY(${t.rowIndex * t.rowHeight}px)`
    })), d = B(() => t.view === "grid" ? {
      gridTemplateColumns: `repeat(${t.itemsPerRow || 1}, minmax(0, 1fr))`,
      gap: "0px"
    } : {
      gridTemplateColumns: "1fr",
      gap: "0px"
    });
    return (a, u) => (c(), _("div", {
      class: re(r.value),
      "data-row": n.rowIndex,
      style: Be(l.value)
    }, [
      i("div", {
        class: "grid w-full",
        style: Be(d.value)
      }, [
        (c(!0), _(he, null, ke(n.items, (f, g) => (c(), Y(Av, je({
          key: s(J)(f),
          item: f,
          view: n.view,
          "show-thumbnails": n.showThumbnails,
          "show-path": n.showPath,
          "is-selected": n.isSelected(s(J)(f)),
          "is-dragging": n.isDraggingItem(s(J)(f)),
          "row-index": n.rowIndex,
          "col-index": g,
          "explorer-id": n.explorerId
        }, nt(n.dragNDropEvents(f)), {
          onClick: u[0] || (u[0] = (h) => o("click", h)),
          onDblclick: u[1] || (u[1] = (h) => o("dblclick", h)),
          onContextmenu: u[2] || (u[2] = (h) => o("contextmenu", h)),
          onDragstart: u[3] || (u[3] = (h) => o("dragstart", h)),
          onDragend: u[4] || (u[4] = (h) => o("dragend", h))
        }), {
          icon: ae((h) => [
            Ce(a.$slots, "icon", je({ ref_for: !0 }, h))
          ]),
          _: 3
        }, 16, ["item", "view", "show-thumbnails", "show-path", "is-selected", "is-dragging", "row-index", "col-index", "explorer-id"]))), 128))
      ], 4)
    ], 14, Ov));
  }
}), zv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Rv(n, e) {
  return c(), _("svg", zv, [...e[0] || (e[0] = [
    i("path", { d: "m8 14 4-4 4 4" }, null, -1)
  ])]);
}
const Lv = { render: Rv }, Vv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function Bv(n, e) {
  return c(), _("svg", Vv, [...e[0] || (e[0] = [
    i("path", { d: "m8 10 4 4 4-4" }, null, -1)
  ])]);
}
const Nv = { render: Bv }, ot = /* @__PURE__ */ le({
  __name: "SortIcon",
  props: {
    direction: {}
  },
  setup(n) {
    return (e, t) => (c(), _("div", null, [
      n.direction === "asc" ? (c(), Y(s(Lv), {
        key: 0,
        class: "vuefinder__explorer__sort-icon"
      })) : V("", !0),
      n.direction === "desc" ? (c(), Y(s(Nv), {
        key: 1,
        class: "vuefinder__explorer__sort-icon"
      })) : V("", !0)
    ]));
  }
}), Uv = { class: "vuefinder__explorer__header" }, Hv = /* @__PURE__ */ le({
  __name: "ExplorerHeader",
  setup(n) {
    const e = fe(), t = e.fs, { t: o } = e.i18n, r = Z(t.sort), l = Z(t.dateColumn);
    return (d, a) => (c(), _("div", Uv, [
      i("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--name vf-sort-button",
        onClick: a[0] || (a[0] = (u) => s(t).toggleSort("basename"))
      }, [
        ye(w(s(o)("Name")) + " ", 1),
        xe(j(ot, {
          direction: s(r).order
        }, null, 8, ["direction"]), [
          [ze, s(r).active && s(r).column === "basename"]
        ])
      ]),
      i("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--date vf-sort-button",
        onClick: a[1] || (a[1] = (u) => s(t).toggleSort("last_modified"))
      }, [
        ye(w(s(l) === "uploaded" ? s(o)("Date uploaded") : s(o)("Date modified")) + " ", 1),
        xe(j(ot, {
          direction: s(r).order
        }, null, 8, ["direction"]), [
          [ze, s(r).active && s(r).column === "last_modified"]
        ])
      ]),
      i("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--type vf-sort-button",
        onClick: a[2] || (a[2] = (u) => s(t).toggleSort("type"))
      }, [
        ye(w(s(o)("Type")) + " ", 1),
        xe(j(ot, {
          direction: s(r).order
        }, null, 8, ["direction"]), [
          [ze, s(r).active && s(r).column === "type"]
        ])
      ]),
      i("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--size vf-sort-button",
        onClick: a[3] || (a[3] = (u) => s(t).toggleSort("file_size"))
      }, [
        ye(w(s(o)("Size")) + " ", 1),
        xe(j(ot, {
          direction: s(r).order
        }, null, 8, ["direction"]), [
          [ze, s(r).active && s(r).column === "file_size"]
        ])
      ])
    ]));
  }
});
function Kv(n, e) {
  const {
    scrollContainer: t,
    itemWidth: o = 100,
    rowHeight: r,
    overscan: l = 2,
    containerPadding: d = 48,
    lockItemsPerRow: a
  } = e, u = n, f = () => typeof r == "number" ? r : r.value, g = () => o ? typeof o == "number" ? o : o.value : 100, h = () => d ? typeof d == "number" ? d : d.value : 0, v = z(0), x = z(6), y = z(600);
  let m = null;
  const b = B(() => Math.ceil(u.value.length / x.value)), I = B(() => b.value * f()), L = B(() => {
    const $ = f(), k = Math.max(0, Math.floor(v.value / $) - l), T = Math.min(
      b.value,
      Math.ceil((v.value + y.value) / $) + l
    );
    return { start: k, end: T };
  }), S = B(() => {
    const { start: $, end: k } = L.value;
    return Array.from({ length: k - $ }, (T, M) => $ + M);
  }), p = () => y.value, F = () => typeof a == "object" ? a.value : !1, C = () => {
    const $ = t.value;
    if (!$)
      return null;
    const k = $.querySelector(".os-viewport");
    return k instanceof HTMLElement ? k : $;
  }, E = () => {
    if (F()) {
      x.value = 1;
      return;
    }
    if (t.value) {
      const $ = h(), k = t.value.clientWidth - $, T = g();
      T > 0 && (x.value = Math.max(Math.floor(k / T), 2));
    }
  }, P = () => {
    const $ = C();
    if (!$)
      return;
    const k = $.clientHeight;
    k > 0 && (y.value = k), v.value = $.scrollTop, E();
  }, N = ($) => {
    const k = $.target;
    v.value = k.scrollTop;
  };
  me(
    () => u.value.length,
    () => {
      E(), Ve(() => P());
    }
  ), o && typeof o != "number" && me(o, () => {
    E();
  }), d && typeof d != "number" && me(d, () => {
    E();
  }), r && typeof r != "number" && me(r, () => {
  });
  const te = ($, k) => {
    if (!$ || !Array.isArray($))
      return [];
    const T = k * x.value;
    return $.slice(T, T + x.value);
  }, W = ($, k, T, M, q) => {
    if (!$ || !Array.isArray($))
      return [];
    const pe = [];
    for (let R = k; R <= T; R++)
      for (let D = M; D <= q; D++) {
        const A = R * x.value + D;
        A < $.length && $[A] && pe.push($[A]);
      }
    return pe;
  }, se = ($) => ({
    row: Math.floor($ / x.value),
    col: $ % x.value
  });
  return Fe(async () => {
    await Ve(), P(), window.addEventListener("resize", P), t.value && "ResizeObserver" in window && (m = new ResizeObserver(() => {
      P();
    }), m.observe(t.value));
  }), Te(() => {
    window.removeEventListener("resize", P), m && (m.disconnect(), m = null);
  }), {
    scrollTop: v,
    itemsPerRow: x,
    totalRows: b,
    totalHeight: I,
    visibleRange: L,
    visibleRows: S,
    updateItemsPerRow: E,
    remeasure: P,
    handleScroll: N,
    getRowItems: te,
    getItemsInRange: W,
    getItemPosition: se,
    getContainerHeight: p
  };
}
function jv(n) {
  const {
    itemsPerRow: e,
    totalHeight: t,
    getItemsInRange: o,
    getKey: r,
    selectionObject: l,
    rowHeight: d,
    itemWidth: a,
    osInstance: u
  } = n, f = () => typeof a == "number" ? a : a.value, g = Math.floor(Math.random() * 2 ** 32).toString(), h = fe(), v = h.fs, x = Z(v.selectedKeys), y = Z(v.sortedFiles), m = B(() => {
    const R = /* @__PURE__ */ new Map();
    return y.value && y.value.forEach((D) => {
      R.set(r(D), D);
    }), R;
  }), b = z(/* @__PURE__ */ new Set()), I = z(!1), L = z(!1), S = (R) => R.map((D) => D.getAttribute("data-key")).filter((D) => !!D), p = (R) => {
    R.selection.clearSelection(!0, !0);
  }, F = () => {
    window.getSelection()?.removeAllRanges();
  }, C = (R) => {
    if (x.value && x.value.size > 0) {
      const D = document.querySelectorAll(`.file-item-${g}[data-key]`), A = /* @__PURE__ */ new Map();
      D.forEach((U) => {
        const O = U.getAttribute("data-key");
        O && A.set(O, U);
      });
      const H = [];
      x.value.forEach((U) => {
        const O = A.get(U);
        O && E(U) && H.push(O);
      }), H.forEach((U) => {
        R.selection.select(U, !0);
      });
    }
  }, E = (R) => {
    const D = m.value.get(R);
    if (!D) return !1;
    const A = h.selectionFilterType, H = h.selectionFilterMimeIncludes;
    return A === "files" && D.type === "dir" || A === "dirs" && D.type === "file" ? !1 : H && Array.isArray(H) && H.length > 0 ? D.type === "dir" ? !0 : D.mime_type ? H.some((U) => D.mime_type?.startsWith(U)) : !1 : !0;
  }, P = (R) => {
    if (h.selectionMode === "single")
      return !1;
    F(), I.value = !1, !R.event?.metaKey && !R.event?.ctrlKey && (L.value = !0), R.selection.resolveSelectables(), p(R), C(R);
  }, N = z(0), te = ({ event: R, selection: D }) => {
    F(), N.value = (l.value?.getAreaLocation().y1 ?? 0) - (h.root.getBoundingClientRect().top ?? 0);
    const A = document.querySelector(
      ".selection-area-container"
    );
    if (A && (A.dataset.theme = h.theme.current), h.selectionMode === "single")
      return;
    const H = R;
    H && "type" in H && H.type === "touchend" && H.preventDefault();
    const U = R;
    !U?.ctrlKey && !U?.metaKey && (v.clearSelection(), D.clearSelection(!0, !0)), b.value.clear();
  }, W = (R) => {
    if (h.selectionMode === "single")
      return;
    const D = S(R.store.changed.added), A = S(R.store.changed.removed);
    L.value = !1, I.value = !0, D.forEach((H) => {
      x.value && !x.value.has(H) && E(H) && (b.value.add(H), v.select(H, h.selectionMode || "multiple"));
    }), A.forEach((H) => {
      document.querySelector(`[data-key="${H}"]`) && m.value.has(H) && b.value.delete(H), v.deselect(H);
    }), R.selection.resolveSelectables(), C(R);
  }, se = () => {
    b.value.clear();
  }, $ = (R) => {
    if (!R.event)
      return;
    const D = document.querySelector(".scroller-" + g);
    if (!D)
      return;
    const A = D.getBoundingClientRect(), H = A.left, U = A.top;
    let O = D.scrollTop;
    if (u?.value) {
      const { viewport: qe } = u.value.elements();
      qe && (O = qe.scrollTop);
    }
    const X = l.value?.getAreaLocation();
    if (!X)
      return;
    const ne = Math.min(X.x1, X.x2), ue = O + Math.min(X.y1, X.y2), _e = Math.max(X.x1, X.x2), K = O + Math.max(X.y1, X.y2), ee = 4, Q = f();
    let ce = Math.floor((ne - H - ee) / Q), Se = Math.floor((_e - H - ee) / Q);
    const Qe = ne - H - ee - ce * Q, He = _e - H - ee - Se * Q;
    Qe > Q - ee && (ce = ce + 1), He < ee && (Se = Se - 1);
    const tt = Math.max(0, ce), ie = Math.min(e.value - 1, Se);
    let be = Math.floor((ue - U - ee) / d.value), we = Math.floor((K - U - ee) / d.value);
    const Ie = ue - U - ee - be * d.value, it = K - U - ee - we * d.value, dn = Math.floor((t.value - ee) / d.value);
    Ie > d.value - ee && (be = be + 1), it < ee && (we = we - 1);
    const cn = Math.max(0, be), un = Math.min(we, dn), fn = o(
      y.value,
      cn,
      un,
      tt,
      ie
    ), vn = document.querySelectorAll(`.file-item-${g}[data-key]`), Ot = /* @__PURE__ */ new Map();
    vn.forEach((qe) => {
      const G = qe.getAttribute("data-key");
      G && Ot.set(G, qe);
    });
    const ct = [];
    if (fn.forEach((qe) => {
      const G = r(qe);
      Ot.get(G) || ct.push(G);
    }), ct.length > 0) {
      const qe = h.selectionMode || "multiple";
      v.selectMultiple(ct, qe);
    }
  }, k = (R) => {
    $(R), p(R), C(R), v.setSelectedCount(x.value?.size || 0), I.value = !1, F();
  }, T = () => {
    let R = [".scroller-" + g];
    if (u?.value) {
      const { viewport: D } = u.value.elements();
      D && (R = D);
    }
    l.value = new ks({
      selectables: [".file-item-" + g + ":not(.vf-explorer-item--unselectable)"],
      boundaries: R,
      selectionContainerClass: "selection-area-container",
      behaviour: {
        overlap: "invert",
        intersect: "touch",
        startThreshold: 0,
        triggers: [0],
        scrolling: {
          speedDivider: 10,
          manualSpeed: 750,
          startScrollMargins: { x: 0, y: 10 }
        }
      },
      features: {
        touch: !0,
        range: !0,
        deselectOnBlur: !0,
        singleTap: {
          allow: !1,
          intersect: "native"
        }
      }
    }), l.value.on("beforestart", P), l.value.on("start", te), l.value.on("move", W), l.value.on("stop", k);
  }, M = () => {
    l.value && (l.value.destroy(), l.value = null);
  }, q = () => {
    l.value && (Array.from(
      x.value ?? /* @__PURE__ */ new Set()
    ).forEach((D) => {
      E(D) || v.deselect(D);
    }), M(), T());
  }, pe = (R) => {
    F(), L.value && (l.value?.clearSelection(), se(), L.value = !1);
    const D = R;
    !b.value.size && !L.value && !D?.ctrlKey && !D?.metaKey && (v.clearSelection(), l.value?.clearSelection());
  };
  return Fe(() => {
    const R = (D) => {
      !D.buttons && I.value && (I.value = !1);
    };
    document.addEventListener("dragleave", R), Te(() => {
      document.removeEventListener("dragleave", R);
    });
  }), {
    explorerId: g,
    isDragging: I,
    initializeSelectionArea: T,
    updateSelectionArea: q,
    handleContentClick: pe
  };
}
function qv(n) {
  const e = (o) => {
    if (!o)
      return { typeAllowed: !1, mimeAllowed: !1 };
    const r = n.selectionFilterType, l = n.selectionFilterMimeIncludes, d = !r || r === "both" || r === "files" && o.type === "file" || r === "dirs" && o.type === "dir";
    let a = !0;
    return l && Array.isArray(l) && l.length > 0 && (o.type === "dir" ? a = !0 : o.mime_type ? a = l.some((u) => o.mime_type.startsWith(u)) : a = !1), { typeAllowed: d, mimeAllowed: a };
  };
  return {
    isItemSelectable: e,
    canSelectItem: (o) => {
      const { typeAllowed: r, mimeAllowed: l } = e(o);
      return r && l;
    }
  };
}
function Gv(n, e, t, o, r, l, d) {
  const a = n.fs, { canSelectItem: u } = qv(n), { openItem: f } = kt(n), g = (L) => {
    const S = L.target?.closest(".file-item-" + e);
    if (!S) return null;
    const p = String(S.getAttribute("data-key")), F = t.value?.find((C) => J(C) === p);
    return { key: p, item: F };
  }, h = () => {
    const L = o.value;
    return t.value?.filter((S) => L?.has(J(S))) || [];
  };
  let v = null;
  const x = (L, S) => {
    const p = t.value ?? [], F = p.findIndex((P) => J(P) === v), C = p.findIndex((P) => J(P) === L);
    if (F === -1 || C === -1) return !1;
    const E = p.slice(Math.min(F, C), Math.max(F, C) + 1).filter((P) => u(P)).map((P) => J(P));
    return S || (a.clearSelection(), r.value?.clearSelection(!0, !0)), a.selectMultiple(E), window.getSelection()?.removeAllRanges(), !0;
  };
  return {
    handleItemClick: (L) => {
      const S = g(L);
      if (!S) return;
      const { key: p, item: F } = S, C = L;
      if (!u(F))
        return;
      const E = n.selectionMode || "multiple";
      if (C?.shiftKey && E === "multiple" && x(p, C.ctrlKey || C.metaKey)) {
        a.setSelectedCount(o.value?.size || 0);
        return;
      }
      !C?.ctrlKey && !C?.metaKey && (L.type !== "touchstart" || !a.isSelected(p)) && (a.clearSelection(), r.value?.clearSelection(!0, !0)), r.value?.resolveSelectables(), L.type === "touchstart" && a.isSelected(p) ? a.select(p, E) : a.toggleSelect(p, E), v = p, a.setSelectedCount(o.value?.size || 0);
    },
    handleItemDblClick: (L) => {
      const S = g(L);
      if (!S) return;
      const { item: p } = S;
      u(p) && p && f(p, l, d);
    },
    handleItemContextMenu: (L) => {
      L.preventDefault(), L.stopPropagation();
      const S = g(L);
      if (!S) return;
      const { key: p, item: F } = S;
      u(F) && (o.value?.has(p) || (a.clearSelection(), a.select(p), a.setSelectedCount(1)), n.emitter.emit("vf-contextmenu-show", {
        event: L,
        items: h(),
        target: F
      }));
    },
    handleContentContextMenu: (L) => {
      L.preventDefault(), n.emitter.emit("vf-contextmenu-show", { event: L, items: h() });
    },
    getSelectedItems: h
  };
}
function Wv(n, e, t) {
  const o = z(null);
  return Fe(() => {
    if (Dt.plugin([bs]), n.value) {
      const r = Dt(
        n.value,
        {
          scrollbars: { theme: "vf-scrollbars-theme" }
        },
        {
          initialized: (l) => {
            o.value = l;
            const { viewport: d } = l.elements();
            d && d.addEventListener("scroll", e), t?.();
          },
          updated: (l) => {
            t?.();
          }
        }
      );
      o.value = r;
    }
  }), Te(() => {
    if (o.value) {
      const { viewport: r } = o.value.elements();
      r && r.removeEventListener("scroll", e), o.value.destroy(), o.value = null;
    }
  }), {
    osInstance: o
  };
}
function Yv(n, e) {
  const t = z(null);
  return Fe(() => {
    n.value && (t.value = new xs({
      elements_selector: ".lazy",
      container: n.value
    })), e?.emitter && e.emitter.on("vf-refresh-thumbnails", () => {
      t.value && t.value.update();
    });
  }), fs(() => {
    t.value && t.value.update();
  }), Te(() => {
    t.value && (t.value.destroy(), t.value = null);
  }), {
    vfLazyLoad: t
  };
}
const Qv = { class: "vuefinder__explorer__container" }, Xv = {
  key: 1,
  class: "vuefinder__trash-toolbar"
}, Jv = { class: "vuefinder__trash-toolbar__label" }, Zv = ["checked"], e_ = {
  key: 0,
  class: "vuefinder__linear-loader"
}, os = /* @__PURE__ */ le({
  __name: "Explorer",
  props: {
    onFileDclick: { type: Function },
    onFolderDclick: { type: Function }
  },
  setup(n) {
    const e = n, t = fe(), o = At(t, ["vuefinder__drag-over"]), r = Ft("dragImage"), l = co(null), d = Ft("scrollContainer"), a = Ft("scrollContent"), u = t.fs, f = t.config, g = Z(f.state), h = Z(u.sortedFiles), v = Z(u.selectedKeys), x = Z(u.loading), y = Z(u.path), m = Z(u.notice), b = (ie) => v.value?.has(ie) ?? !1, I = B(() => {
      if (g.value?.view === "grid") {
        const Ie = g.value?.gridItemHeight ?? 80, it = g.value?.gridItemGap ?? 8;
        return Ie + it * 2;
      }
      const be = g.value?.listItemHeight ?? 32, we = g.value?.listItemGap ?? 2;
      return be + we * 2;
    }), L = B(() => {
      if (g.value?.view === "grid") {
        const be = g.value?.gridItemWidth ?? 96, we = g.value?.gridItemGap ?? 8;
        return be + we * 2;
      }
      return 104;
    }), S = B(() => g.value?.view === "grid" ? (g.value?.gridItemGap ?? 8) * 2 : 0), { t: p } = t.i18n, F = B(() => {
      const ie = y.value?.path || "", be = ie.includes("://") ? ie.split("://").slice(1).join("://") : ie;
      return be === "Корзина" || be.startsWith("Корзина/");
    }), C = () => {
      window.getSelection()?.removeAllRanges();
    }, E = async (ie) => {
      const be = ie.target, we = y.value?.path || "";
      f.set("trashMineOnly", be.checked), t.adapter.invalidateListQuery(we);
      try {
        await t.adapter.open(we);
      } finally {
        u.setLoading(!1);
      }
    }, {
      itemsPerRow: P,
      totalHeight: N,
      visibleRows: te,
      handleScroll: W,
      getRowItems: se,
      getItemsInRange: $,
      updateItemsPerRow: k,
      remeasure: T
    } = Kv(
      B(() => h.value ?? []),
      {
        scrollContainer: d,
        itemWidth: L,
        rowHeight: I,
        overscan: 2,
        containerPadding: S,
        lockItemsPerRow: B(() => g.value.view === "list")
      }
    ), { osInstance: M } = Wv(d, W, T);
    function q() {
      T(), requestAnimationFrame(() => {
        T(), requestAnimationFrame(() => T());
      });
    }
    vs(() => {
      Ve(() => {
        q(), window.setTimeout(q, 50), window.setTimeout(q, 200);
      });
    });
    const { explorerId: pe, isDragging: R, initializeSelectionArea: D, updateSelectionArea: A, handleContentClick: H } = jv({
      itemsPerRow: P,
      totalHeight: N,
      getItemsInRange: $,
      getKey: (ie) => ie.path,
      selectionObject: l,
      rowHeight: I,
      itemWidth: L,
      osInstance: M
    }), U = z(null), O = (ie) => {
      if (!ie || !U.value) return !1;
      const be = v.value?.has(U.value) ?? !1;
      return R.value && (be ? v.value?.has(ie) ?? !1 : ie === U.value);
    };
    me(
      () => f.get("view"),
      (ie) => {
        ie === "list" ? P.value = 1 : k();
      },
      { immediate: !0 }
    ), me(P, (ie) => {
      f.get("view") === "list" && ie !== 1 && (P.value = 1);
    });
    const X = (ie) => h.value?.[ie];
    Yv(d, t);
    const { handleItemClick: ne, handleItemDblClick: ue, handleItemContextMenu: _e, handleContentContextMenu: K } = Gv(
      t,
      pe,
      h,
      v,
      l,
      e.onFileDclick,
      e.onFolderDclick
    );
    Fe(() => {
      const ie = () => {
        l.value || D(), l.value && l.value.on("beforestart", ({ event: be }) => {
          const we = be?.target === a.value;
          if (!be?.metaKey && !be?.ctrlKey && !we)
            return !1;
          C();
        });
      };
      if (M.value)
        ie();
      else {
        const be = setInterval(() => {
          M.value && (clearInterval(be), ie());
        }, 50);
        setTimeout(() => {
          clearInterval(be), l.value || ie();
        }, 500);
      }
      me(() => [t.selectionFilterType, t.selectionFilterMimeIncludes], A, {
        deep: !0
      });
    });
    const ee = (ie) => {
      if (!(t.features?.move ?? !1) || t.fs.isFeatureDisabled("move") || t.fs.getReadOnly() || ie.altKey || ie.ctrlKey || ie.metaKey)
        return ie.preventDefault(), !1;
      R.value = !0;
      const we = ie.target?.closest(
        ".file-item-" + pe
      );
      if (U.value = we ? String(we.dataset.key) : null, ie.dataTransfer && U.value) {
        ie.dataTransfer.setDragImage(r.value, 0, 15), ie.dataTransfer.effectAllowed = "all", ie.dataTransfer.dropEffect = "copy";
        const Ie = v.value?.has(U.value) ? Array.from(v.value) : [U.value];
        ie.dataTransfer.setData("items", JSON.stringify(Ie)), u.setDraggedItem(U.value);
      }
    }, Q = () => {
      U.value = null;
    };
    let ce = null, Se = null;
    const Qe = (ie) => {
      ie.target?.closest(".file-item-" + pe) || (Se = ie, ce && clearTimeout(ce), ce = setTimeout(() => {
        Se && (Se.cancelable && Se.preventDefault(), Se.stopPropagation(), K(Se)), Se = null, ce = null;
      }, 500));
    }, He = (ie) => {
      ce && (clearTimeout(ce), ce = null), Se = null;
    }, tt = (ie) => {
      if (!Se) return;
      const be = Se.touches[0] || Se.changedTouches[0], we = ie.touches[0] || ie.changedTouches[0];
      if (be && we) {
        const Ie = Math.abs(we.clientX - be.clientX), it = Math.abs(we.clientY - be.clientY);
        (Ie > 15 || it > 15) && (ce && (clearTimeout(ce), ce = null), Se = null);
      }
    };
    return (ie, be) => (c(), _("div", Qv, [
      s(m) ? (c(), _("div", {
        key: 0,
        class: re(["vuefinder__explorer__notice", `vuefinder__explorer__notice--${s(m).type}`]),
        role: "alert"
      }, w(s(m).text), 3)) : V("", !0),
      F.value ? (c(), _("div", Xv, [
        i("label", Jv, [
          i("input", {
            type: "checkbox",
            class: "vuefinder__trash-toolbar__checkbox",
            checked: s(g).trashMineOnly ?? !0,
            onChange: E
          }, null, 40, Zv),
          i("span", null, w(s(p)("My trash")), 1)
        ])
      ])) : V("", !0),
      s(g).view === "list" ? (c(), Y(Hv, { key: 2 })) : V("", !0),
      i("div", {
        ref_key: "scrollContainer",
        ref: d,
        class: re(["vuefinder__explorer__selector-area", "scroller-" + s(pe)])
      }, [
        s(f).get("loadingIndicator") === "linear" && s(x) ? (c(), _("div", e_)) : V("", !0),
        i("div", {
          ref_key: "scrollContent",
          ref: a,
          class: "scrollContent vuefinder__explorer__scroll-content",
          style: Be({ height: `${s(N)}px`, position: "relative", width: "100%" }),
          onContextmenu: be[0] || (be[0] = ge(
            //@ts-ignore
            (...we) => s(K) && s(K)(...we),
            ["self", "prevent"]
          )),
          onClick: be[1] || (be[1] = ge(
            //@ts-ignore
            (...we) => s(H) && s(H)(...we),
            ["self"]
          )),
          onTouchstartCapture: ge(Qe, ["self"]),
          onTouchendCapture: ge(He, ["self"]),
          onTouchmoveCapture: ge(tt, ["self"]),
          onTouchcancelCapture: ge(He, ["self"])
        }, [
          i("div", {
            ref_key: "dragImage",
            ref: r,
            class: "vuefinder__explorer__drag-item"
          }, [
            j(mv, {
              count: U.value && s(v).has(U.value) ? s(v).size : 1
            }, null, 8, ["count"])
          ], 512),
          s(g).view === "grid" ? (c(!0), _(he, { key: 0 }, ke(s(te), (we) => (c(), Y(lo, {
            key: we,
            "row-index": we,
            "row-height": I.value,
            view: "grid",
            "items-per-row": s(P),
            items: s(se)(s(h), we),
            "show-thumbnails": s(g).showThumbnails,
            "is-dragging-item": O,
            "is-selected": b,
            "drag-n-drop-events": (Ie) => s(o).events(Ie),
            "explorer-id": s(pe),
            onClick: s(ne),
            onDblclick: s(ue),
            onContextmenu: s(_e),
            onDragstart: ee,
            onDragend: Q
          }, {
            icon: ae((Ie) => [
              Ce(ie.$slots, "icon", je({ ref_for: !0 }, Ie))
            ]),
            _: 3
          }, 8, ["row-index", "row-height", "items-per-row", "items", "show-thumbnails", "drag-n-drop-events", "explorer-id", "onClick", "onDblclick", "onContextmenu"]))), 128)) : (c(!0), _(he, { key: 1 }, ke(s(te), (we) => (c(), Y(lo, {
            key: we,
            "row-index": we,
            "row-height": I.value,
            view: "list",
            items: X(we) ? [X(we)] : [],
            "is-dragging-item": O,
            "is-selected": b,
            "drag-n-drop-events": (Ie) => s(o).events(Ie),
            "explorer-id": s(pe),
            onClick: s(ne),
            onDblclick: s(ue),
            onContextmenu: s(_e),
            onDragstart: ee,
            onDragend: Q
          }, {
            icon: ae((Ie) => [
              Ce(ie.$slots, "icon", je({ ref_for: !0 }, Ie))
            ]),
            _: 3
          }, 8, ["row-index", "row-height", "items", "drag-n-drop-events", "explorer-id", "onClick", "onDblclick", "onContextmenu"]))), 128))
        ], 36)
      ], 2)
    ]));
  }
}), t_ = { class: "vuefinder__access-modal__content" }, n_ = {
  key: 0,
  class: "vuefinder__access-modal__empty"
}, o_ = {
  key: 1,
  class: "vuefinder__access-modal__subjects vf-scrollbar"
}, s_ = {
  key: 0,
  class: "vuefinder__access-modal__header"
}, i_ = { class: "vuefinder__access-modal__name" }, r_ = { class: "vuefinder__access-modal__checkbox-cell" }, a_ = ["checked", "disabled", "onChange"], l_ = { class: "vuefinder__access-modal__checkbox-cell" }, d_ = ["checked", "disabled", "onChange"], c_ = {
  key: 1,
  class: "vuefinder__access-modal__empty"
}, u_ = ["disabled"], f_ = /* @__PURE__ */ le({
  __name: "ModalAccess",
  setup(n) {
    const e = fe(), { t } = e.i18n, o = z(e.modal.data.items ?? []), r = B(() => e.config.get("accessSubjects") ?? []), l = ($) => String($.id), d = z(!0), a = z({
      read: /* @__PURE__ */ new Set(),
      edit: /* @__PURE__ */ new Set(),
      lockedRead: /* @__PURE__ */ new Set(),
      lockedEdit: /* @__PURE__ */ new Set()
    });
    Fe(async () => {
      try {
        const $ = await Promise.all(
          o.value.map(async (k) => {
            const T = await e.adapter.getAccess({ path: k.path, id: k.id });
            return { ...k, access: T.access };
          })
        );
        o.value = $, a.value = u();
      } catch {
        at(e, "error", t("Failed to load access settings")), e.modal.close();
      } finally {
        d.value = !1;
      }
    });
    function u() {
      const $ = {
        read: /* @__PURE__ */ new Set(),
        edit: /* @__PURE__ */ new Set(),
        lockedRead: /* @__PURE__ */ new Set(),
        lockedEdit: /* @__PURE__ */ new Set()
      };
      return r.value.forEach((k) => {
        const T = l(k);
        (k.checked || k.read || k.access === "read" || k.access === "edit") && $.read.add(T), (k.edit || k.access === "edit") && ($.edit.add(T), $.read.add(T)), o.value.forEach((M) => f($, k, M)), $.lockedEdit.has(T) ? ($.edit.add(T), $.read.add(T), $.lockedRead.add(T)) : $.lockedRead.has(T) && $.read.add(T);
      }), $;
    }
    function f($, k, T) {
      [
        ...T.access?.default ?? [],
        ...T.access?.direct ?? [],
        ...T.access?.effective ?? []
      ].forEach((q) => {
        if (!g(k, q))
          return;
        const pe = l(k), R = b(q, T);
        S(q.access, "read") && ($.read.add(pe), R && $.lockedRead.add(pe)), S(q.access, "edit") && ($.edit.add(pe), R && $.lockedEdit.add(pe));
      });
    }
    function g($, k) {
      if (k.user)
        return h($).some((T) => v(k).has(T));
      if (k.role) {
        const T = x($);
        return m(k.role).some((M) => T.has(M));
      }
      return !1;
    }
    function h($) {
      const k = [`id:${$.id}`];
      return $.username && k.push(`username:${$.username}`), $.email && k.push(`email:${$.email}`), k;
    }
    function v($) {
      const k = /* @__PURE__ */ new Set();
      return $.user?.id !== void 0 && k.add(`id:${$.user.id}`), $.user?.username && k.add(`username:${$.user.username}`), $.user?.email && k.add(`email:${$.user.email}`), k;
    }
    function x($) {
      const k = /* @__PURE__ */ new Set();
      return y($.roles ?? []).forEach((T) => {
        m(T).forEach((M) => k.add(M));
      }), k;
    }
    function y($) {
      const k = [];
      return $.forEach((T) => {
        k.push(T), T.children?.length && k.push(...y(T.children));
      }), k;
    }
    function m($) {
      const k = [];
      return $.id !== void 0 && k.push(`id:${$.id}`), $.name && (k.push(`name:${$.name}`), k.push(`${$.service || ""}:${$.name}`)), k;
    }
    function b($, k) {
      return $.default || $.locked ? !0 : !!($.item && I($.item) !== I(k.path));
    }
    function I($) {
      return String($ || "").replace(/\/+$/, "");
    }
    function L($) {
      return $ === "edit" ? "edit" : "read";
    }
    function S($, k) {
      return L($) === "edit" || k === "read";
    }
    function p() {
      return {
        read: new Set(a.value.read),
        edit: new Set(a.value.edit),
        lockedRead: new Set(a.value.lockedRead),
        lockedEdit: new Set(a.value.lockedEdit)
      };
    }
    function F($, k) {
      const T = l($);
      return k === "read" ? a.value.read.has(T) : a.value.edit.has(T);
    }
    function C($, k) {
      const T = l($);
      return k === "read" ? a.value.lockedRead.has(T) : a.value.lockedEdit.has(T);
    }
    const E = ($, k, T) => {
      if (C($, k))
        return;
      const M = l($), q = p();
      k === "read" ? T ? q.read.add(M) : (q.read.delete(M), q.lockedEdit.has(M) || q.edit.delete(M)) : T ? (q.edit.add(M), q.read.add(M)) : q.edit.delete(M), q.lockedEdit.has(M) ? (q.edit.add(M), q.read.add(M), q.lockedRead.add(M)) : q.lockedRead.has(M) && q.read.add(M), a.value = q;
    };
    function P($, k) {
      E($, "read", k.target.checked);
    }
    function N($, k) {
      E($, "edit", k.target.checked);
    }
    function te($) {
      const k = l($);
      return a.value.edit.has(k) ? "edit" : a.value.read.has(k) ? "read" : null;
    }
    function W($) {
      const k = l($);
      return a.value.lockedEdit.has(k) ? "edit" : a.value.lockedRead.has(k) ? "read" : null;
    }
    const se = () => {
      const $ = r.value.flatMap((k) => {
        const T = te(k);
        return !T || T === W(k) ? [] : [{ ...k, access: T, read: !0, edit: T === "edit" }];
      });
      e.emitter.emit("vf-access-change", {
        items: o.value,
        subjects: $
      }), e.modal.close();
    };
    return ($, k) => (c(), Y(Re, null, {
      buttons: ae(() => [
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: k[0] || (k[0] = (T) => s(e).modal.close())
        }, w(s(t)("Close")), 1),
        i("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: d.value,
          onClick: se
        }, w(s(t)("Save")), 9, u_)
      ]),
      default: ae(() => [
        i("div", null, [
          j(Le, {
            icon: s(Dn),
            title: s(t)("Access settings")
          }, null, 8, ["icon", "title"]),
          i("div", t_, [
            d.value ? (c(), _("div", n_, w(s(t)("Loading")) + "… ", 1)) : (c(), _("div", o_, [
              r.value.length ? (c(), _("div", s_, [
                k[1] || (k[1] = i("span", null, null, -1)),
                i("span", null, w(s(t)("Can read")), 1),
                i("span", null, w(s(t)("Can edit")), 1)
              ])) : V("", !0),
              (c(!0), _(he, null, ke(r.value, (T) => (c(), _("div", {
                key: T.id,
                class: "vuefinder__access-modal__subject"
              }, [
                i("span", i_, w(T.name), 1),
                i("label", r_, [
                  i("input", {
                    class: "vuefinder__access-modal__checkbox",
                    type: "checkbox",
                    checked: F(T, "read"),
                    disabled: C(T, "read"),
                    onChange: (M) => P(T, M)
                  }, null, 40, a_)
                ]),
                i("label", l_, [
                  i("input", {
                    class: "vuefinder__access-modal__checkbox",
                    type: "checkbox",
                    checked: F(T, "edit"),
                    disabled: C(T, "edit"),
                    onChange: (M) => N(T, M)
                  }, null, 40, d_)
                ])
              ]))), 128)),
              r.value.length ? V("", !0) : (c(), _("div", c_, w(s(t)("No access subjects")), 1))
            ]))
          ])
        ])
      ]),
      _: 1
    }));
  }
}), v_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function __(n, e) {
  return c(), _("svg", v_, [...e[0] || (e[0] = [
    i("path", { d: "M3 7h7l2 2h9v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }, null, -1),
    i("path", { d: "M3 7V5a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v2" }, null, -1)
  ])]);
}
const h_ = { render: __ }, p_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function m_(n, e) {
  return c(), _("svg", p_, [...e[0] || (e[0] = [
    i("path", { d: "M10 13a5 5 0 0 0 7.1.1l2-2A5 5 0 0 0 12 4l-1.1 1.1M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1" }, null, -1)
  ])]);
}
const g_ = { render: m_ }, w_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function y_(n, e) {
  return c(), _("svg", w_, [...e[0] || (e[0] = [
    i("path", { d: "M14 4h6v6m0-6-9 9M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }, null, -1)
  ])]);
}
const b_ = { render: y_ }, k_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function x_(n, e) {
  return c(), _("svg", k_, [...e[0] || (e[0] = [
    i("circle", {
      cx: "18",
      cy: "5",
      r: "3"
    }, null, -1),
    i("circle", {
      cx: "6",
      cy: "12",
      r: "3"
    }, null, -1),
    i("circle", {
      cx: "18",
      cy: "19",
      r: "3"
    }, null, -1),
    i("path", { d: "m8.6 13.5 6.8 4m0-11-6.8 4" }, null, -1)
  ])]);
}
const $_ = { render: x_ }, De = {
  access: "access",
  new_folder: "new_folder",
  new_word: "new_word",
  new_excel: "new_excel",
  selectAll: "selectAll",
  pinFolder: "pinFolder",
  unpinFolder: "unpinFolder",
  delete: "delete",
  refresh: "refresh",
  preview: "preview",
  open: "open",
  openDir: "openDir",
  download: "download",
  download_archive: "download_archive",
  archive: "archive",
  unarchive: "unarchive",
  rename: "rename",
  move: "move",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  upload_to_folder: "upload_to_folder",
  copy_path: "copy_path",
  history: "history",
  add_favorite: "add_favorite",
  remove_favorite: "remove_favorite"
}, S_ = [
  { id: "create", title: ({ t: n }) => n("Create"), icon: rn, section: 3, order: 10 },
  { id: "more", title: ({ t: n }) => n("More"), icon: sn, section: 4, order: 10 }
];
function ss(n, e) {
  return !!e.target && J(n) === J(e.target);
}
function Vt(n) {
  return n.items.length > 1 && n.items.some((e) => ss(e, n)) ? "many" : n.target ? "one" : "none";
}
function Ee(n) {
  const e = Object.assign(
    {
      needsSearchQuery: !1
    },
    n
  );
  return (t, o) => !(e.needsSearchQuery !== !!o.searchQuery || e.target !== void 0 && e.target !== Vt(o) || e.targetType !== void 0 && e.targetType !== o.target?.type || e.mimeType !== void 0 && e.mimeType !== o.target?.mime_type || e.feature !== void 0 && (!(t.features[e.feature] ?? !1) || t.fs.isFeatureDisabled(e.feature)));
}
function ft(...n) {
  return (e, t) => n.some((o) => o(e, t));
}
function Lt(...n) {
  return (e, t) => n.every((o) => o(e, t));
}
function Pn(n, e) {
  const t = n.fs.path.get(), o = e[0];
  if (o?.type === "dir")
    return o;
  const r = o?.dir || t.path || "";
  return {
    // Синтетическая папка-назначение (текущая папка): id = путь.
    id: r,
    storage: o?.storage || t.storage || "",
    path: r,
    basename: o?.dir?.split("/").pop() || t.path || "",
    dir: "",
    extension: "",
    type: "dir",
    file_size: null,
    last_modified: null,
    mime_type: null,
    visibility: "public"
  };
}
function wn(n, e) {
  return Pn(n, e).path;
}
function Bt(n) {
  return n.items.length > 1 && n.target && n.items.some((e) => ss(e, n)) ? n.items : n.target ? [n.target] : n.items;
}
function C_(n, e) {
  const t = n.config.get("favoriteItems") ?? [], o = e.filter((l) => !Pt(n, l)), r = [
    ...o,
    ...t.filter(
      (l) => !o.some((d) => J(d) === J(l))
    )
  ];
  Gn(n, r);
}
function F_(n, e) {
  const t = new Set(e.map((r) => J(r))), o = (n.config.get("favoriteItems") ?? []).filter(
    (r) => !t.has(J(r))
  );
  Gn(n, o);
}
function Ct(n = {}) {
  return ft(
    Ee({ target: "one", feature: n.feature }),
    Ee({ target: "many", feature: n.feature })
  );
}
function is(n, e) {
  return n.fs.getReadOnly() ? !0 : Bt(e).some((t) => n.fs.isReadOnly(t));
}
function vt(n) {
  return (e, t) => n(e, t) && !is(e, t);
}
function xt(n = {}) {
  return vt(Ct(n));
}
const rs = [
  {
    id: De.openDir,
    title: ({ t: n }) => n("Open containing folder"),
    action: (n, e) => {
      const t = e[0];
      t && n.adapter.open(t.dir);
    },
    show: Ee({ target: "one", needsSearchQuery: !0 }),
    section: 0,
    order: 5,
    icon: h_
  },
  {
    id: De.access,
    title: ({ t: n }) => n("Give access"),
    action: (n, e) => n.modal.open(f_, { items: e }),
    show: xt(),
    submenu: "more",
    order: 10,
    icon: $_
  },
  {
    id: De.open,
    title: ({ t: n }) => n("Open"),
    action: (n, e) => {
      const t = e[0];
      t && (t.type === "dir" ? n.adapter.open(t.path) : kt(n).openItem(t));
    },
    show: Ee({ target: "one" }),
    section: 1,
    order: 10,
    icon: b_,
    shortcut: "Space"
  },
  {
    id: De.rename,
    title: ({ t: n }) => n("Rename"),
    action: (n, e) => n.modal.open(Zt, { items: e }),
    show: vt(Ee({ target: "one", feature: "rename" })),
    section: 1,
    order: 20,
    icon: Ln,
    shortcut: "F2"
  },
  {
    id: De.move,
    title: ({ t: n }) => n("Move"),
    action: (n, e) => {
      const t = {
        storage: n.fs.path.get().storage || "",
        path: n.fs.path.get().path || "",
        type: "dir"
      };
      n.modal.open(dt, { items: { from: e, to: t } });
    },
    show: xt({ feature: "move" }),
    section: 2,
    order: 60,
    icon: Ro
  },
  {
    id: De.new_folder,
    title: ({ t: n }) => n("Folder (create)"),
    action: (n, e) => n.modal.open(qn, { targetPath: wn(n, e) }),
    show: vt(
      ft(
        Ee({ target: "none", feature: "newfolder" }),
        Ee({ target: "one", feature: "newfolder" }),
        Ee({ target: "many", feature: "newfolder" })
      )
    ),
    disabled: (n, e) => Vt(e) === "many",
    submenu: "create",
    order: 10,
    icon: rn
  },
  {
    id: De.new_word,
    title: ({ t: n }) => n("Word document (create)"),
    action: (n, e) => n.modal.open(qt, {
      targetPath: wn(n, e),
      extension: "docx",
      officeKind: "word"
    }),
    show: vt(
      ft(
        Ee({ target: "none", feature: "newfile" }),
        Ee({ target: "one", feature: "newfile" }),
        Ee({ target: "many", feature: "newfile" })
      )
    ),
    disabled: (n, e) => Vt(e) === "many",
    submenu: "create",
    order: 20,
    icon: Wo
  },
  {
    id: De.new_excel,
    title: ({ t: n }) => n("Excel workbook (create)"),
    action: (n, e) => n.modal.open(qt, {
      targetPath: wn(n, e),
      extension: "xlsx",
      officeKind: "excel"
    }),
    show: vt(
      ft(
        Ee({ target: "none", feature: "newfile" }),
        Ee({ target: "one", feature: "newfile" }),
        Ee({ target: "many", feature: "newfile" })
      )
    ),
    disabled: (n, e) => Vt(e) === "many",
    submenu: "create",
    order: 30,
    icon: Yo
  },
  {
    id: De.cut,
    title: ({ t: n }) => n("Cut"),
    action: (n, e) => {
      n.fs.setClipboardItems("cut", e);
    },
    show: xt({ feature: "move" }),
    section: 2,
    order: 30,
    icon: Qo,
    shortcut: "Ctrl+X"
  },
  {
    id: De.paste,
    title: ({ t: n }) => n("Paste"),
    action: (n, e) => {
      const t = n.fs.getClipboard();
      if (!t?.items?.size) return;
      const o = Pn(n, e);
      n.modal.open(t.type === "cut" ? dt : tn, {
        items: { from: Array.from(t.items), to: o },
        clearClipboardOnSuccess: t.type === "cut"
      });
    },
    show: (n, e) => is(n, e) ? !1 : n.fs.getClipboard()?.items?.size > 0,
    disabled: (n) => !n.fs.getClipboard()?.items?.size,
    section: 2,
    order: 50,
    icon: Xo,
    shortcut: "Ctrl+V"
  },
  {
    id: De.copy,
    title: ({ t: n }) => n("Copy"),
    action: (n, e) => {
      n.fs.setClipboardItems("copy", e);
    },
    show: xt({ feature: "copy" }),
    section: 2,
    order: 40,
    icon: Tt,
    shortcut: "Ctrl+C"
  },
  {
    id: De.download,
    title: ({ t: n }) => n("Download"),
    action: (n, e) => n.modal.open(qo, { items: e }),
    show: Lt(
      Ct({ feature: "download" }),
      (n, e) => jo(Bt(e), n.fs.isFeatureDisabled("archive"))
    ),
    submenu: "more",
    order: 20,
    icon: Jo
  },
  {
    id: De.upload_to_folder,
    title: ({ t: n }) => n("Upload to folder"),
    action: (n, e) => {
      const t = Pn(n, e);
      n.modal.open(ln, { target: t });
    },
    show: vt(
      ft(
        Ee({ target: "none", feature: "upload" }),
        Ee({ target: "one", feature: "upload" })
      )
    ),
    submenu: "more",
    order: 30,
    icon: an
  },
  {
    id: De.history,
    title: ({ t: n }) => n("History"),
    action: (n, e) => {
      n.emitter.emit("vf-history-request", { items: e });
    },
    show: Lt(Ee({ target: "one", feature: "history" }), (n, e) => {
      const t = e.target;
      if (!t || t.is_trash_root || String(t.id ?? "").startsWith("trash:"))
        return !1;
      const o = Number(t.id);
      return Number.isFinite(o) && o > 0;
    }),
    submenu: "more",
    order: 35,
    icon: ts
  },
  {
    id: De.delete,
    title: ({ t: n }) => n("Delete"),
    action: (n, e) => {
      n.modal.open(Jt, { items: e });
    },
    show: xt({ feature: "delete" }),
    section: 2,
    order: 70,
    icon: It,
    shortcut: "Delete",
    danger: !0
  },
  {
    id: De.copy_path,
    title: ({ t: n }) => n("Copy path"),
    action: (n, e) => on(n, e),
    show: Ct(),
    submenu: "more",
    order: 40,
    icon: g_
  },
  {
    id: De.add_favorite,
    title: ({ t: n }) => n("Add to favorites"),
    action: C_,
    show: Lt(Ct(), (n, e) => {
      const t = Bt(e);
      return En(n, t) && t.some((o) => !Pt(n, o));
    }),
    submenu: "more",
    order: 50,
    icon: Zo
  },
  {
    id: De.remove_favorite,
    title: ({ t: n }) => n("Remove from favorites"),
    action: F_,
    show: Lt(Ct(), (n, e) => {
      const t = Bt(e);
      return En(n, t) && t.every((o) => Pt(n, o));
    }),
    submenu: "more",
    order: 60,
    icon: es
  },
  {
    id: De.refresh,
    title: ({ t: n }) => n("Refresh"),
    action: (n) => {
      const e = n.fs.path.get().path || "";
      n.adapter.invalidateListQuery(e), n.adapter.open(e);
    },
    show: ft(
      Ee({ target: "none" }),
      Ee({ target: "one" }),
      Ee({ target: "many" })
    ),
    section: 2,
    order: 65,
    icon: ns,
    shortcut: "Ctrl+R"
  }
], E_ = 99;
function D_(n, e = S_) {
  const t = (a, u) => (a.order ?? 1 / 0) - (u.order ?? 1 / 0), o = [], r = new Set(e.map((a) => a.id));
  for (const a of e) {
    const u = n.filter((f) => f.submenu === a.id).sort(t);
    u.length && o.push({
      section: a.section,
      order: a.order,
      entry: { type: "submenu", key: `submenu-${a.id}`, submenu: a, children: u }
    });
  }
  for (const a of n)
    a.submenu && r.has(a.submenu) || o.push({
      section: a.section ?? E_,
      order: a.order ?? 1 / 0,
      entry: { type: "item", key: a.id, item: a }
    });
  o.sort((a, u) => a.section - u.section || a.order - u.order);
  const l = [];
  let d = null;
  for (const { section: a, entry: u } of o)
    d !== null && a !== d && l.push({ type: "separator", key: `separator-${a}` }), l.push(u), d = a;
  return l;
}
const P_ = {
  key: 0,
  class: "vuefinder__context-menu__divider",
  role: "separator"
}, I_ = ["onMouseenter"], T_ = ["onClick"], M_ = { class: "vuefinder__context-menu__title" }, A_ = ["href", "download"], O_ = { class: "vuefinder__context-menu__title" }, z_ = {
  key: 1,
  class: "vuefinder__context-menu__shortcut"
}, R_ = ["onClick"], L_ = { class: "vuefinder__context-menu__title" }, V_ = {
  key: 1,
  class: "vuefinder__context-menu__shortcut"
}, B_ = ["href", "download"], N_ = { class: "vuefinder__context-menu__title" }, U_ = {
  key: 1,
  class: "vuefinder__context-menu__shortcut"
}, H_ = ["onClick"], K_ = { class: "vuefinder__context-menu__title" }, j_ = {
  key: 1,
  class: "vuefinder__context-menu__shortcut"
}, q_ = /* @__PURE__ */ le({
  __name: "ContextMenu",
  setup(n) {
    const e = fe(), t = z(null), o = z([]);
    let r = null, l = null, d = null, a = [], u = null;
    const f = Gt({
      active: !1,
      items: [],
      entries: [],
      positions: {}
    }), g = z(null), h = z({}), v = z(null), x = {}, y = {};
    let m = null;
    const b = () => {
      m && (clearTimeout(m), m = null);
    }, I = () => {
      b(), g.value = null;
    }, L = () => {
      b(), m = setTimeout(I, 60);
    }, S = async (W) => {
      if (b(), g.value === W) return;
      v.value = null, h.value = { position: "fixed", left: "-9999px", top: "-9999px", visibility: "hidden" }, g.value = W, await Ve();
      const se = x[W], $ = y[W];
      if (!se || !$ || g.value !== W) return;
      const { x: k, y: T, placement: M } = await lt(se, $, {
        placement: "right-start",
        strategy: "fixed",
        middleware: [
          // -7/+7: выровнять первый/последний пункт подменю с триггером с учётом padding 7px;
          // у выравнивания -end (после flip у нижнего края) знак crossAxis обратный.
          pt(({ placement: q }) => ({ mainAxis: 4, crossAxis: q.endsWith("end") ? 7 : -7 })),
          mt({ padding: 8 }),
          gt({ padding: 8 }),
          p
        ]
      });
      g.value === W && (h.value = { position: "fixed", left: `${k}px`, top: `${T}px` }, v.value = M.startsWith("left") ? "left" : "right");
    }, p = {
      name: "keepSubmenuBottomBelowTrigger",
      fn: ({ y: W, rects: se }) => {
        const $ = se.reference.y + se.reference.height - se.floating.height;
        return W < $ ? { y: $ } : {};
      }
    }, F = (W) => {
      g.value === W ? I() : S(W);
    }, C = (W, se) => {
      se && (x[W] = se);
    }, E = (W, se) => {
      se && (y[W] = se);
    };
    e.emitter.on("vf-context-selected", (W) => {
      o.value = W;
    });
    const P = (W) => W.link(e, o.value), N = (W) => {
      W.disabled || (e.emitter.emit("vf-contextmenu-hide"), W.action(e, o.value));
    };
    e.emitter.on("vf-contextmenu-show", (W) => {
      const { event: se, target: $ = null } = W || {}, k = W?.items ?? [], T = {
        searchQuery: W?.searchQuery ?? "",
        items: k ?? [],
        target: $
      };
      if (f.items = (e.contextMenuItems || []).filter((M) => M.show(e, T)).map((M) => ({
        ...M,
        disabled: M.disabled?.(e, T) ?? !1
      })).sort((M, q) => {
        const pe = M.order ?? 1 / 0, R = q.order ?? 1 / 0;
        return pe - R;
      }), !f.items.length) {
        e.emitter.emit("vf-contextmenu-hide");
        return;
      }
      f.entries = D_(f.items), I(), $ ? k.length > 1 && k.some((M) => M.path === $.path) ? e.emitter.emit("vf-context-selected", k) : e.emitter.emit("vf-context-selected", [$]) : e.emitter.emit("vf-context-selected", []), te(se);
    }), e.emitter.on("vf-contextmenu-hide", () => {
      f.active = !1, I(), r && (r(), r = null), d && (a.forEach((W) => {
        W === window ? window.removeEventListener("scroll", d, !0) : W.removeEventListener("scroll", d, !0);
      }), d = null, a = []), u && (document.removeEventListener("mousedown", u, !0), document.removeEventListener("touchstart", u, !0), u = null), l = null, f.positions = {};
    });
    const te = async (W) => {
      r && (r(), r = null);
      const $ = ((D) => {
        if ("clientX" in D && "clientY" in D)
          return { x: D.clientX, y: D.clientY };
        const A = "touches" in D && D.touches[0] || "changedTouches" in D && D.changedTouches[0];
        return A ? { x: A.clientX, y: A.clientY } : { x: 0, y: 0 };
      })(W);
      if (l = {
        getBoundingClientRect: () => ({
          width: 0,
          height: 0,
          x: $.x,
          y: $.y,
          top: $.y,
          left: $.x,
          right: $.x,
          bottom: $.y
        })
      }, f.positions = {
        position: "fixed",
        zIndex: "10001",
        opacity: "0",
        visibility: "hidden",
        left: "-9999px",
        top: "-9999px"
      }, f.active = !0, await Ve(), !t.value || !l) return;
      await new Promise((D) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(D);
        });
      });
      const k = [
        pt(8),
        mt({
          padding: 16,
          fallbackPlacements: ["left-start", "right-end", "left-end", "top-start", "bottom-start"]
        }),
        gt({ padding: 16 })
      ];
      let T = 0, M = 0;
      try {
        const D = await lt(l, t.value, {
          placement: "right-start",
          strategy: "fixed",
          middleware: k
        });
        T = D.x, M = D.y;
      } catch (D) {
        console.warn("[ContextMenu] Floating UI initial positioning error:", D);
        return;
      }
      f.positions = {
        position: "fixed",
        zIndex: "10001",
        left: `${T}px`,
        top: `${M}px`,
        opacity: "0",
        visibility: "visible",
        transform: "translateY(-8px)",
        transition: "opacity 150ms ease-out, transform 150ms ease-out"
      }, requestAnimationFrame(() => {
        t.value && (f.positions = {
          ...f.positions,
          opacity: "1",
          // none, а не translateY(0): transform делает меню containing block для
          // position: fixed, и подменю позиционировалось бы от меню, а не от окна.
          transform: "none"
        });
      });
      const pe = ((D) => {
        const A = [];
        let H = D;
        for (; H && H !== document.body && H !== document.documentElement; ) {
          const U = window.getComputedStyle(H), O = U.overflow + U.overflowX + U.overflowY;
          (O.includes("scroll") || O.includes("auto")) && A.push(H), H = H.parentElement;
        }
        return A;
      })(t.value);
      a = [window, ...pe], d = () => {
        f.active && e.emitter.emit("vf-contextmenu-hide");
      };
      const R = d;
      R && a.forEach((D) => {
        D === window ? window.addEventListener("scroll", R, !0) : D.addEventListener("scroll", R, !0);
      }), u = (D) => {
        if (!f.active) return;
        const A = D.target;
        if (!A || t.value && t.value.contains(A))
          return;
        const H = e.root;
        H && H.contains(A) || e.emitter.emit("vf-contextmenu-hide");
      }, setTimeout(() => {
        u && (document.addEventListener("mousedown", u, !0), document.addEventListener("touchstart", u, !0));
      }, 100), setTimeout(() => {
        if (!(!t.value || !l))
          try {
            r = Tn(l, t.value, async () => {
              if (!(!l || !t.value))
                try {
                  const { x: D, y: A } = await lt(l, t.value, {
                    placement: "right-start",
                    strategy: "fixed",
                    middleware: k
                  });
                  f.positions = {
                    ...f.positions,
                    left: `${D}px`,
                    top: `${A}px`
                  };
                } catch (D) {
                  console.warn("Floating UI positioning error:", D);
                }
            });
          } catch (D) {
            console.warn("Floating UI autoUpdate setup error:", D), r = null;
          }
      }, 200);
    };
    return Te(() => {
      b(), r && (r(), r = null), d && (a.forEach((W) => {
        W === window ? window.removeEventListener("scroll", d, !0) : W.removeEventListener("scroll", d, !0);
      }), d = null, a = []), u && (document.removeEventListener("mousedown", u, !0), document.removeEventListener("touchstart", u, !0), u = null), l = null;
    }), (W, se) => xe((c(), _("ul", {
      ref_key: "contextmenu",
      ref: t,
      class: re([{
        "vuefinder__context-menu--active": f.active,
        "vuefinder__context-menu--inactive": !f.active
      }, "vuefinder__context-menu"]),
      style: Be(f.positions),
      role: "menu"
    }, [
      (c(!0), _(he, null, ke(f.entries, ($) => (c(), _(he, {
        key: $.key
      }, [
        $.type === "separator" ? (c(), _("li", P_)) : $.type === "submenu" ? (c(), _("li", {
          key: 1,
          ref_for: !0,
          ref: (k) => C($.submenu.id, k),
          class: re(["vuefinder__context-menu__item vuefinder__context-menu__item--submenu", { "vuefinder__context-menu__item--open": g.value === $.submenu.id }]),
          onMouseenter: (k) => S($.submenu.id),
          onMouseleave: L
        }, [
          i("div", {
            class: "vuefinder__context-menu__action",
            onClick: ge((k) => F($.submenu.id), ["stop"])
          }, [
            (c(), Y(Ge($.submenu.icon), { class: "vuefinder__context-menu__icon" })),
            i("span", M_, w($.submenu.title(s(e).i18n)), 1),
            j(s(Go), { class: "vuefinder__context-menu__arrow" })
          ], 8, T_),
          g.value === $.submenu.id ? (c(), _("ul", {
            key: 0,
            ref_for: !0,
            ref: (k) => E($.submenu.id, k),
            class: re(["vuefinder__context-menu vuefinder__context-menu__submenu", v.value && `vuefinder__context-menu__submenu--${v.value}`]),
            style: Be(h.value),
            role: "menu",
            onMouseenter: b
          }, [
            (c(!0), _(he, null, ke($.children, (k) => (c(), _("li", {
              key: k.id,
              class: re(["vuefinder__context-menu__item", {
                "vuefinder__context-menu__item--disabled": k.disabled,
                "vuefinder__context-menu__item--danger": k.danger
              }])
            }, [
              k.link && !k.disabled ? (c(), _("a", {
                key: 0,
                class: "vuefinder__context-menu__link",
                href: P(k),
                download: P(k),
                onClick: se[0] || (se[0] = (T) => s(e).emitter.emit("vf-contextmenu-hide"))
              }, [
                k.icon ? (c(), Y(Ge(k.icon), {
                  key: 0,
                  class: "vuefinder__context-menu__icon"
                })) : V("", !0),
                i("span", O_, w(k.title(s(e).i18n)), 1),
                k.shortcut ? (c(), _("span", z_, w(k.shortcut), 1)) : V("", !0)
              ], 8, A_)) : (c(), _("div", {
                key: 1,
                class: "vuefinder__context-menu__action",
                onClick: (T) => N(k)
              }, [
                k.icon ? (c(), Y(Ge(k.icon), {
                  key: 0,
                  class: "vuefinder__context-menu__icon"
                })) : V("", !0),
                i("span", L_, w(k.title(s(e).i18n)), 1),
                k.shortcut ? (c(), _("span", V_, w(k.shortcut), 1)) : V("", !0)
              ], 8, R_))
            ], 2))), 128))
          ], 38)) : V("", !0)
        ], 42, I_)) : (c(), _("li", {
          key: 2,
          class: re(["vuefinder__context-menu__item", {
            "vuefinder__context-menu__item--disabled": $.item.disabled,
            "vuefinder__context-menu__item--danger": $.item.danger
          }]),
          onMouseenter: I
        }, [
          $.item.link && !$.item.disabled ? (c(), _("a", {
            key: 0,
            class: "vuefinder__context-menu__link",
            href: P($.item),
            download: P($.item),
            onClick: se[1] || (se[1] = (k) => s(e).emitter.emit("vf-contextmenu-hide"))
          }, [
            $.item.icon ? (c(), Y(Ge($.item.icon), {
              key: 0,
              class: "vuefinder__context-menu__icon"
            })) : V("", !0),
            i("span", N_, w($.item.title(s(e).i18n)), 1),
            $.item.shortcut ? (c(), _("span", U_, w($.item.shortcut), 1)) : V("", !0)
          ], 8, B_)) : (c(), _("div", {
            key: 1,
            class: "vuefinder__context-menu__action",
            onClick: (k) => N($.item)
          }, [
            $.item.icon ? (c(), Y(Ge($.item.icon), {
              key: 0,
              class: "vuefinder__context-menu__icon"
            })) : V("", !0),
            i("span", K_, w($.item.title(s(e).i18n)), 1),
            $.item.shortcut ? (c(), _("span", j_, w($.item.shortcut), 1)) : V("", !0)
          ], 8, H_))
        ], 34))
      ], 64))), 128))
    ], 6)), [
      [ze, f.active]
    ]);
  }
}), G_ = { class: "vuefinder__status-bar__wrapper" }, W_ = { class: "vuefinder__status-bar__storage" }, Y_ = ["title"], Q_ = { class: "vuefinder__status-bar__storage-icon" }, X_ = ["value"], J_ = ["value"], Z_ = { class: "vuefinder__status-bar__info space-x-2" }, eh = { key: 0 }, th = { key: 1 }, nh = {
  key: 0,
  class: "vuefinder__status-bar__size"
}, oh = { class: "vuefinder__status-bar__actions" }, sh = /* @__PURE__ */ le({
  __name: "Statusbar",
  setup(n) {
    const e = fe(), { t } = e.i18n, o = e.fs, r = Z(o.sortedFiles), l = Z(o.path), d = Z(o.selectedCount), a = Z(o.rootStorages), u = Z(o.selectedItems), f = Z(o.path), g = (b) => {
      const I = b.target.value;
      e.adapter.open(I + "://");
    }, h = B(() => !u.value || u.value.length === 0 ? 0 : u.value.reduce((b, I) => b + (I.file_size || 0), 0)), v = B(() => a.value), x = B(() => r.value), y = B(() => d.value || 0), m = B(() => u.value || []);
    return (b, I) => (c(), _("div", G_, [
      i("div", W_, [
        i("div", {
          class: "vuefinder__status-bar__storage-container",
          title: s(t)("Storage")
        }, [
          i("div", Q_, [
            j(s(Bn))
          ]),
          i("select", {
            name: "vuefinder-media-selector",
            value: s(l).storage,
            class: "vuefinder__status-bar__storage-select",
            tabindex: "-1",
            onChange: g
          }, [
            (c(!0), _(he, null, ke(v.value, (L) => (c(), _("option", {
              key: L,
              value: L
            }, w(L), 9, J_))), 128))
          ], 40, X_),
          I[0] || (I[0] = i("span", {
            class: "vuefinder__status-bar__storage-caret",
            "aria-hidden": "true"
          }, null, -1))
        ], 8, Y_),
        i("div", Z_, [
          y.value === 0 ? (c(), _("span", eh, w(x.value.length) + " " + w(s(t)("items")), 1)) : (c(), _("span", th, [
            ye(w(y.value) + " " + w(s(t)("selected")) + " ", 1),
            h.value ? (c(), _("span", nh, w(s(e).filesize(h.value)), 1)) : V("", !0)
          ]))
        ])
      ]),
      i("div", oh, [
        Ce(b.$slots, "actions", {
          path: s(f).path,
          count: y.value || 0,
          selected: m.value
        })
      ])
    ]));
  }
}), ih = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "h-5 w-5",
  viewBox: "0 0 24 24"
};
function rh(n, e) {
  return c(), _("svg", ih, [...e[0] || (e[0] = [
    i("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    i("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m3.6 5.2a1 1 0 0 0-1.4.2L12 10.333 9.8 7.4a1 1 0 1 0-1.6 1.2l2.55 3.4-2.55 3.4a1 1 0 1 0 1.6 1.2l2.2-2.933 2.2 2.933a1 1 0 0 0 1.6-1.2L13.25 12l2.55-3.4a1 1 0 0 0-.2-1.4" }, null, -1)
  ])]);
}
const ah = { render: rh };
function as(n, e) {
  const t = n.findIndex((o) => o.path === e.path);
  t > -1 ? n[t] = e : n.push(e);
}
const lh = { class: "vuefinder__folder-loader-indicator" }, dh = {
  key: 1,
  class: "vuefinder__folder-loader-indicator--icon"
}, ls = /* @__PURE__ */ le({
  __name: "FolderLoaderIndicator",
  props: /* @__PURE__ */ _s({
    storage: {},
    path: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = fe(), o = vo(n, "modelValue"), r = z(!1);
    me(
      () => o.value,
      () => l()
    );
    const l = async () => {
      r.value = !0;
      try {
        const a = (await t.adapter.list(e.path)).files.filter((u) => u.type === "dir");
        as(t.treeViewData, { path: e.path, type: "dir", folders: a });
      } catch (d) {
        Ae(d, "Failed to fetch subfolders");
      } finally {
        r.value = !1;
      }
    };
    return (d, a) => (c(), _("div", lh, [
      r.value ? (c(), Y(s(nn), {
        key: 0,
        class: "vuefinder__folder-loader-indicator--loading"
      })) : (c(), _("div", dh, [
        o.value ? (c(), Y(s(en), {
          key: 0,
          class: "vuefinder__folder-loader-indicator--minus"
        })) : V("", !0),
        o.value ? V("", !0) : (c(), Y(s(Mt), {
          key: 1,
          class: "vuefinder__folder-loader-indicator--plus"
        }))
      ]))
    ]));
  }
}), ch = { key: 0 }, uh = { class: "vuefinder__treesubfolderlist__no-folders" }, fh = { class: "vuefinder__treesubfolderlist__item-content" }, vh = ["onClick"], _h = ["title", "onDblclick", "onClick"], hh = { class: "vuefinder__treesubfolderlist__item-icon" }, ph = ["src"], mh = { class: "vuefinder__treesubfolderlist__subfolder" }, gh = {
  key: 1,
  class: "vuefinder__treesubfolderlist__more-note"
}, wh = /* @__PURE__ */ le({
  __name: "TreeSubfolderList",
  props: {
    storage: {},
    path: {}
  },
  setup(n) {
    const e = fe(), t = e.fs, o = At(e, ["vuefinder__drag-over"]), r = z({}), l = e.config, d = Z(l.state), { t: a } = e.i18n, u = Z(t.path), f = n, g = z(null), h = z(50);
    Fe(() => {
      f.path === f.storage + "://" && g.value && Dt(g.value, {
        scrollbars: {
          theme: "vf-scrollbars-theme"
        }
      });
    });
    const v = B(() => {
      const p = e.treeViewData.find((F) => F.path === f.path)?.folders || [];
      return p.length > h.value ? p.slice(0, h.value) : p;
    }), x = B(() => e.treeViewData.find((p) => p.path === f.path)?.folders?.length || 0), y = B(() => x.value > h.value), m = B(() => `${f.storage}://`), b = (S, p) => S === p || S.startsWith(`${p}/`);
    me(
      v,
      (S) => {
        const p = d.value.expandTreeByDefault && f.path === m.value, F = d.value.expandedTreePaths || [];
        S.forEach((C) => {
          const E = F.some(
            (P) => b(P, C.path)
          );
          (p || E) && r.value[C.path] === void 0 && (r.value[C.path] = !0);
        });
      },
      { immediate: !0 }
    );
    const I = () => {
      h.value += 50;
    }, L = (S) => Ue(S, e.i18n.t);
    return (S, p) => {
      const F = uo("TreeSubfolderList", !0);
      return c(), _("ul", {
        ref_key: "parentSubfolderList",
        ref: g,
        class: "vuefinder__treesubfolderlist__container"
      }, [
        v.value.length ? V("", !0) : (c(), _("li", ch, [
          i("div", uh, w(s(a)("No folders")), 1)
        ])),
        (c(!0), _(he, null, ke(v.value, (C) => (c(), _("li", {
          key: C.path,
          class: "vuefinder__treesubfolderlist__item"
        }, [
          i("div", fh, [
            i("div", {
              class: "vuefinder__treesubfolderlist__item-toggle",
              onClick: (E) => r.value[C.path] = !r.value[C.path]
            }, [
              j(ls, {
                modelValue: r.value[C.path],
                "onUpdate:modelValue": (E) => r.value[C.path] = E,
                storage: n.storage,
                path: C.path
              }, null, 8, ["modelValue", "onUpdate:modelValue", "storage", "path"])
            ], 8, vh),
            i("div", je({
              class: "vuefinder__treesubfolderlist__item-link",
              title: C.path
            }, nt(
              s(o).events({
                ...C,
                dir: C.path,
                extension: "",
                file_size: null,
                last_modified: null,
                mime_type: null,
                visibility: "public"
              }),
              !0
            ), {
              onDblclick: (E) => r.value[C.path] = !r.value[C.path],
              onClick: (E) => s(e).adapter.open(C.path)
            }), [
              i("div", hh, [
                C.icon_url ? (c(), _("img", {
                  key: 0,
                  src: C.icon_url,
                  alt: "",
                  class: "vuefinder__treesubfolderlist__item-icon-custom"
                }, null, 8, ph)) : C.is_trash_root ? (c(), Y(s(It), {
                  key: 1,
                  class: "vuefinder__item-icon__trash"
                })) : s(u)?.path === C.path ? (c(), Y(s(Nn), {
                  key: 2,
                  class: "vuefinder__item-icon__folder--open"
                })) : (c(), Y(s(et), {
                  key: 3,
                  class: "vuefinder__item-icon__folder"
                }))
              ]),
              i("div", {
                class: re(["vuefinder__treesubfolderlist__item-text", {
                  "vuefinder__treesubfolderlist__item-text--active": s(u).path === C.path,
                  "vuefinder__treesubfolderlist__item-text--trash-root": C.is_trash_root
                }])
              }, w(L(C)), 3)
            ], 16, _h)
          ]),
          i("div", mh, [
            xe(j(F, {
              storage: f.storage,
              path: C.path
            }, null, 8, ["storage", "path"]), [
              [ze, r.value[C.path]]
            ])
          ])
        ]))), 128)),
        y.value ? (c(), _("li", gh, [
          i("div", {
            class: "vuefinder__treesubfolderlist__load-more",
            onClick: I
          }, w(s(a)("load more")), 1)
        ])) : V("", !0)
      ], 512);
    };
  }
}), yh = /* @__PURE__ */ le({
  __name: "TreeStorageItem",
  props: {
    storage: {}
  },
  setup(n) {
    const e = fe(), t = e.fs, o = e.config, { t: r } = e.i18n, l = n, d = Z(o.state), a = B(() => {
      const m = d.value.expandedTreePaths || [], b = `${l.storage}://`;
      return m.some(
        (I) => I === b || I.startsWith(`${b}`)
      );
    }), u = z(d.value.expandTreeByDefault || a.value), f = At(e, ["vuefinder__drag-over"]), g = Z(t.path), h = B(() => l.storage === g.value?.storage), v = B(
      () => Xt(l.storage, r, d.value.storageLabels || {})
    );
    me(
      () => ({
        expandTreeByDefault: d.value.expandTreeByDefault,
        hasExpandedPathInStorage: a.value
      }),
      (m) => {
        (m.expandTreeByDefault || m.hasExpandedPathInStorage) && (u.value = !0);
      }
    );
    const x = {
      storage: l.storage,
      path: l.storage + "://",
      dir: l.storage + "://",
      type: "dir",
      basename: l.storage,
      extension: "",
      file_size: null,
      last_modified: null,
      mime_type: null,
      visibility: "public"
    };
    function y(m) {
      m === g.value?.storage ? u.value = !u.value : e.adapter.open(m + "://");
    }
    return (m, b) => (c(), _(he, null, [
      i("div", {
        class: "vuefinder__treestorageitem__header",
        onClick: b[2] || (b[2] = (I) => y(n.storage))
      }, [
        i("div", je({
          class: ["vuefinder__treestorageitem__info", h.value ? "vuefinder__treestorageitem__info--active" : ""]
        }, nt(s(f).events(x), !0)), [
          i("div", {
            class: re(["vuefinder__treestorageitem__icon", h.value ? "vuefinder__treestorageitem__icon--active" : ""])
          }, [
            j(s(Bn))
          ], 2),
          i("div", null, w(v.value), 1)
        ], 16),
        i("div", {
          class: "vuefinder__treestorageitem__loader",
          onClick: b[1] || (b[1] = ge((I) => u.value = !u.value, ["stop"]))
        }, [
          j(ls, {
            modelValue: u.value,
            "onUpdate:modelValue": b[0] || (b[0] = (I) => u.value = I),
            storage: n.storage,
            path: n.storage + "://"
          }, null, 8, ["modelValue", "storage", "path"])
        ])
      ]),
      xe(j(wh, {
        storage: n.storage,
        path: n.storage + "://",
        class: "vuefinder__treestorageitem__subfolder"
      }, null, 8, ["storage", "path"]), [
        [ze, u.value]
      ])
    ], 64));
  }
}), bh = { class: "vuefinder__folder-indicator" }, kh = { class: "vuefinder__folder-indicator--icon" }, xh = /* @__PURE__ */ le({
  __name: "FolderIndicator",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(n) {
    const e = vo(n, "modelValue");
    return (t, o) => (c(), _("div", bh, [
      i("div", kh, [
        e.value ? (c(), Y(s(en), {
          key: 0,
          class: "vuefinder__folder-indicator--minus"
        })) : V("", !0),
        e.value ? V("", !0) : (c(), Y(s(Mt), {
          key: 1,
          class: "vuefinder__folder-indicator--plus"
        }))
      ])
    ]));
  }
}), $h = {
  key: 0,
  class: "vuefinder__treeview__header"
}, Sh = { class: "vuefinder__treeview__pinned-label" }, Ch = { class: "vuefinder__treeview__pin-text text-nowrap" }, Fh = {
  key: 0,
  class: "vuefinder__treeview__pinned-list"
}, Eh = ["onClick"], Dh = ["title"], Ph = ["onClick"], Ih = { key: 0 }, Th = { class: "vuefinder__treeview__no-pinned" }, Mh = /* @__PURE__ */ le({
  __name: "TreeView",
  setup(n) {
    const e = fe(), { enabled: t } = st(), { t: o } = e.i18n, { getStore: r, setStore: l } = e.storage, d = e.fs, a = e.config, u = Z(a.state), f = Z(d.sortedFiles), g = Z(d.rootStorages), h = B(() => g.value || []), v = Z(d.path), x = (p) => Ue(p, e.i18n.t), y = At(e, ["vuefinder__drag-over"]), m = z(190), b = z(r("pinned-folders-opened", !0));
    me(b, (p) => l("pinned-folders-opened", p));
    const I = (p) => {
      const F = a.get("pinnedFolders");
      a.set("pinnedFolders", F.filter((C) => C.path !== p.path));
    }, L = (p) => {
      const F = p.clientX, C = p.target.parentElement;
      if (!C) return;
      const E = C.getBoundingClientRect().width;
      C.classList.remove("transition-[width]"), C.classList.add("transition-none");
      const P = (te) => {
        m.value = E + te.clientX - F, m.value < 50 && (m.value = 0, a.set("showTreeView", !1)), m.value > 50 && a.set("showTreeView", !0);
      }, N = () => {
        const te = C.getBoundingClientRect();
        m.value = te.width, C.classList.add("transition-[width]"), C.classList.remove("transition-none"), window.removeEventListener("mousemove", P), window.removeEventListener("mouseup", N);
      };
      window.addEventListener("mousemove", P), window.addEventListener("mouseup", N);
    }, S = z(null);
    return Fe(() => {
      S.value && Dt(S.value, {
        overflow: {
          x: "hidden"
        },
        scrollbars: {
          theme: "vf-scrollbars-theme"
        }
      });
    }), me(f, (p) => {
      const F = p.filter((C) => C.type === "dir");
      as(e.treeViewData, {
        path: v.value.path || "",
        folders: F.map((C) => ({
          storage: C.storage,
          path: C.path,
          basename: C.basename,
          type: "dir",
          read_only: C.read_only,
          is_trash_root: C.is_trash_root,
          icon_url: C.icon_url
        }))
      });
    }), (p, F) => (c(), _(he, null, [
      i("div", {
        class: re(["vuefinder__treeview__overlay", s(u).showTreeView ? "vuefinder__treeview__backdrop" : "hidden"]),
        onClick: F[0] || (F[0] = (C) => s(a).toggle("showTreeView"))
      }, null, 2),
      i("div", {
        style: Be(
          s(u).showTreeView ? "min-width:100px;max-width:75%; width: " + m.value + "px" : "width: 0"
        ),
        class: "vuefinder__treeview__container"
      }, [
        i("div", {
          ref_key: "treeViewScrollElement",
          ref: S,
          class: "vuefinder__treeview__scroll"
        }, [
          s(t)("pinned") ? (c(), _("div", $h, [
            i("div", {
              class: "vuefinder__treeview__pinned-toggle",
              onClick: F[2] || (F[2] = (C) => b.value = !b.value)
            }, [
              i("div", Sh, [
                j(s(Vn), { class: "vuefinder__treeview__pin-icon" }),
                i("div", Ch, w(s(o)("Pinned Folders")), 1)
              ]),
              j(xh, {
                modelValue: b.value,
                "onUpdate:modelValue": F[1] || (F[1] = (C) => b.value = C)
              }, null, 8, ["modelValue"])
            ]),
            b.value ? (c(), _("ul", Fh, [
              (c(!0), _(he, null, ke(s(u).pinnedFolders, (C) => (c(), _("li", {
                key: C.path,
                class: "vuefinder__treeview__pinned-item"
              }, [
                i("div", je({ class: "vuefinder__treeview__pinned-folder" }, nt(s(y).events(C), !0), {
                  onClick: (E) => s(e).adapter.open(C.path)
                }), [
                  s(v).path !== C.path ? (c(), Y(s(et), {
                    key: 0,
                    class: "vuefinder__treeview__folder-icon vuefinder__item-icon__folder"
                  })) : V("", !0),
                  s(v).path === C.path ? (c(), Y(s(Nn), {
                    key: 1,
                    class: "vuefinder__item-icon__folder--open vuefinder__treeview__open-folder-icon"
                  })) : V("", !0),
                  i("div", {
                    title: C.path,
                    class: re(["vuefinder__treeview__folder-name", {
                      "vuefinder__treeview__folder-name--active": s(v).path === C.path
                    }])
                  }, w(x(C)), 11, Dh)
                ], 16, Eh),
                i("div", {
                  class: "vuefinder__treeview__remove-folder",
                  onClick: (E) => I(C)
                }, [
                  j(s(ah), { class: "vuefinder__treeview__remove-icon" })
                ], 8, Ph)
              ]))), 128)),
              s(u).pinnedFolders.length ? V("", !0) : (c(), _("li", Ih, [
                i("div", Th, w(s(o)("No folders pinned")), 1)
              ]))
            ])) : V("", !0)
          ])) : V("", !0),
          (c(!0), _(he, null, ke(h.value, (C) => (c(), _("div", {
            key: C,
            class: "vuefinder__treeview__storage"
          }, [
            j(yh, { storage: C }, null, 8, ["storage"])
          ]))), 128))
        ], 512),
        i("div", {
          class: "vuefinder__treeview__resize-handle",
          onMousedown: L
        }, null, 32)
      ], 4)
    ], 64));
  }
}), Ah = { class: "vuefinder__favorites-panel" }, Oh = { class: "vuefinder__favorites-panel__title" }, zh = { class: "vuefinder__favorites-panel__list" }, Rh = ["title", "onClick", "onDblclick", "onContextmenu"], Lh = { class: "vuefinder__favorites-panel__name" }, Vh = {
  key: 0,
  class: "vuefinder__favorites-panel__empty"
}, Bh = /* @__PURE__ */ le({
  __name: "FavoritePanel",
  setup(n) {
    const e = fe(), t = e.fs, { t: o } = e.i18n, { openItem: r } = kt(e), l = Z(e.config.state), d = Z(t.selectedKeys), a = B(() => l.value.favoriteItems ?? []), u = B(() => a.value.map((m, b) => ({ item: m, index: b })).slice().sort((m, b) => m.item.type !== b.item.type ? m.item.type === "dir" ? -1 : 1 : m.index - b.index).map(({ item: m }) => m)), f = (y) => d.value?.has(J(y)) ?? !1, g = (y) => Ue(y, e.i18n.t), h = () => {
      const y = d.value ?? /* @__PURE__ */ new Set();
      return a.value.filter((m) => y.has(J(m)));
    }, v = (y, m) => {
      m.ctrlKey || m.metaKey || t.clearSelection(), t.toggleSelect(J(y), e.selectionMode || "multiple"), t.setSelectedCount(t.selectedKeys.get().size);
    }, x = (y, m) => {
      m.preventDefault(), m.stopPropagation(), f(y) || (t.clearSelection(), t.select(J(y)), t.setSelectedCount(1));
      const b = h();
      e.emitter.emit("vf-contextmenu-show", {
        event: m,
        items: b.length ? b : [y],
        target: y
      });
    };
    return (y, m) => (c(), _("aside", Ah, [
      i("div", Oh, w(s(o)("Favorites")), 1),
      i("div", zh, [
        (c(!0), _(he, null, ke(u.value, (b) => (c(), _("div", {
          key: s(J)(b),
          class: re(["vuefinder__favorites-panel__item", { "vuefinder__favorites-panel__item--selected": f(b) }]),
          title: b.path,
          onClick: (I) => v(b, I),
          onDblclick: (I) => s(r)(b),
          onContextmenu: (I) => x(b, I)
        }, [
          j(wt, {
            item: b,
            small: "",
            view: "list"
          }, null, 8, ["item"]),
          i("span", Lh, w(g(b)), 1)
        ], 42, Rh))), 128)),
        u.value.length ? V("", !0) : (c(), _("div", Vh, w(s(o)("No favorites")), 1))
      ])
    ]));
  }
}), Nh = { class: "vuefinder__windows-layout" }, Uh = { class: "vuefinder__windows-layout__workspace" }, Hh = { class: "vuefinder__windows-layout__path" }, Kh = { class: "vuefinder__windows-layout__path-value" }, jh = ["onClick"], qh = /* @__PURE__ */ le({
  __name: "WindowsExplorerLayout",
  props: {
    onFileDclick: { type: Function },
    onFolderDclick: { type: Function }
  },
  setup(n) {
    const e = n, t = fe(), { t: o } = t.i18n, r = Z(t.config.state), l = Z(t.fs.path), d = z(r.value.favoritePanelWidth || 180), a = B(() => l.value.storage ? `${l.value.storage}://` : l.value.path), u = B(
      () => r.value.storageLabels || {}
    ), f = B(
      () => Xt(l.value.storage, o, u.value)
    ), g = B(() => l.value.breadcrumb ?? []), h = (m) => Ue(m, t.i18n.t), v = () => {
      a.value && t.adapter.open(a.value);
    }, x = (m) => {
      t.adapter.open(m);
    }, y = (m) => {
      const b = m.clientX, I = d.value, L = (p) => {
        const F = Math.min(Math.max(I + p.clientX - b, 120), 420);
        d.value = F;
      }, S = () => {
        t.config.set("favoritePanelWidth", d.value), window.removeEventListener("mousemove", L), window.removeEventListener("mouseup", S);
      };
      window.addEventListener("mousemove", L), window.addEventListener("mouseup", S);
    };
    return (m, b) => (c(), _("div", Nh, [
      i("div", {
        class: "vuefinder__windows-layout__favorites",
        style: Be({ width: `${d.value}px` })
      }, [
        j(Bh)
      ], 4),
      i("div", {
        class: "vuefinder__windows-layout__resize",
        onMousedown: y
      }, null, 32),
      i("section", Uh, [
        Ce(m.$slots, "toolbar"),
        i("div", Hh, [
          i("button", {
            type: "button",
            class: "vuefinder__windows-layout__path-label",
            onClick: v
          }, w(s(o)("Path")) + ": ", 1),
          i("div", Kh, [
            i("button", {
              type: "button",
              class: "vuefinder__windows-layout__path-segment",
              onClick: v
            }, w(f.value), 1),
            (c(!0), _(he, null, ke(g.value, (I) => (c(), _(he, {
              key: I.path
            }, [
              b[0] || (b[0] = i("span", { class: "vuefinder__windows-layout__path-separator" }, "/", -1)),
              i("button", {
                type: "button",
                class: "vuefinder__windows-layout__path-segment",
                onClick: (L) => x(I.path)
              }, w(h(I)), 9, jh)
            ], 64))), 128))
          ])
        ]),
        j(os, {
          "on-file-dclick": e.onFileDclick,
          "on-folder-dclick": e.onFolderDclick
        }, {
          icon: ae((I) => [
            Ce(m.$slots, "icon", We(Ye(I)))
          ]),
          _: 3
        }, 8, ["on-file-dclick", "on-folder-dclick"])
      ])
    ]));
  }
}), Gh = ["data-theme"], Wh = {
  key: 0,
  class: "vuefinder__external-drop-overlay vuefinder__external-drop-overlay--relative"
}, Yh = { class: "vuefinder__external-drop-message" }, Qh = {
  key: 4,
  class: "vuefinder__main__content"
}, Xh = {
  key: 5,
  class: "vuefinder__main__content vuefinder__main__content--windows"
}, Jh = ["data-theme"], Zh = /* @__PURE__ */ le({
  __name: "VueFinderView",
  props: {
    id: {},
    driver: {},
    config: {},
    features: {},
    debug: { type: Boolean },
    locale: {},
    contextMenuItems: {},
    copyPath: { type: Function },
    selectionMode: {},
    selectionFilterType: {},
    selectionFilterMimeIncludes: {},
    onError: { type: Function },
    onSelect: { type: Function },
    onPathChange: { type: Function },
    onUploadComplete: { type: Function },
    onDeleteComplete: { type: Function },
    onAccessChange: { type: Function },
    onDownloadRequested: { type: Function },
    onOfficeFileCreated: { type: Function },
    onFavoritesChange: { type: Function },
    onNotify: { type: Function },
    onReady: { type: Function },
    onFileDclick: { type: Function },
    onFolderDclick: { type: Function },
    customUploader: { type: Function }
  },
  emits: [
    "select",
    "path-change",
    "upload-complete",
    "delete-complete",
    "access-change",
    "download-requested",
    "office-file-created",
    "favorites-change",
    "history-request",
    "notify",
    "error",
    "ready",
    "file-dclick",
    "folder-dclick",
    "update:locale"
  ],
  setup(n, { emit: e }) {
    const t = e, o = n, r = fe(), l = Ft("root"), d = r.config;
    me(
      () => o.features,
      (S) => {
        const p = po(S);
        Object.keys(r.features).forEach((F) => {
          delete r.features[F];
        }), Object.assign(r.features, p);
      },
      { deep: !0 }
    );
    const a = r.fs, u = Z(r.i18n.localeAtom), f = Z(d.state);
    me(
      () => f.value.favoriteItems,
      (S) => {
        a.setSelectionPool(S ?? []);
      },
      { immediate: !0, deep: !0 }
    );
    const g = B(() => {
      const S = f.value;
      return {
        "--vf-grid-item-width": `${S.gridItemWidth}px`,
        "--vf-grid-item-height": `${S.gridItemHeight}px`,
        "--vf-grid-item-gap": `${S.gridItemGap}px`,
        "--vf-grid-icon-size": `${S.gridIconSize}px`,
        "--vf-list-item-height": `${S.listItemHeight}px`,
        "--vf-list-item-gap": `${S.listItemGap}px`,
        "--vf-list-icon-size": `${S.listIconSize}px`
      };
    }), h = B(() => !!f.value.windowsExplorer);
    Cl();
    const { isDraggingExternal: v, handleDragEnter: x, handleDragOver: y, handleDragLeave: m, handleDrop: b } = Fl();
    function I(S) {
      a.setPath(S.dirname), d.get("persist") && d.set("path", S.dirname), a.setReadOnly(S.read_only ?? !1), r.modal.close(), a.setFiles(S.files), a.clearSelection(), a.setSelectedCount(0), a.setStorages(S.storages), a.setMounts(S.mounts), a.setDisabledFeatures(S.disabled_features), a.setNotice(S.notice), a.setDateColumn(S.date_column);
    }
    r.adapter.onBeforeOpen = () => {
      a.setLoading(!0);
    }, r.adapter.onAfterOpen = (S) => {
      I(S), a.setLoading(!1);
    }, r.emitter.on("vf-upload-complete", (S) => {
      t("upload-complete", S);
    }), r.emitter.on("vf-delete-complete", (S) => {
      t("delete-complete", S);
    }), r.emitter.on("vf-access-change", (S) => {
      t("access-change", S);
    }), r.emitter.on("vf-download-requested", (S) => {
      t("download-requested", S);
    }), r.emitter.on("vf-office-file-created", (S) => {
      t("office-file-created", S);
    }), r.emitter.on("vf-favorites-change", (S) => {
      t("favorites-change", S);
    }), r.emitter.on("vf-history-request", (S) => {
      t("history-request", S);
    }), r.emitter.on("vf-notify", (S) => {
      t("notify", S);
    }), r.emitter.on("vf-file-dclick", (S) => {
      t("file-dclick", S);
    }), r.emitter.on("vf-folder-dclick", (S) => {
      t("folder-dclick", S);
    }), me(
      () => o.config?.theme,
      (S) => {
        S && d.set("theme", s(S));
      },
      { immediate: !0 }
    ), me(
      u,
      (S, p) => {
        S !== p && t("update:locale", String(S));
      },
      { immediate: !1 }
    ), Fe(() => {
      r.root = l.value;
      const S = d.get("initialPath") ?? "", p = d.get("persist") ? d.get("path") : "", F = S || p || "";
      d.get("persist") && S && p !== S && d.set("path", S), d.get("trashMineOnly") !== !0 && d.set("trashMineOnly", !0), me(
        () => d.get("path"),
        (C) => {
          r.adapter.open(C);
        }
      ), a.setPath(F), r.adapter.open(F), a.path.listen((C) => {
        t("path-change", C.path);
      }), a.selectedItems.listen((C) => {
        t("select", C);
      }), t("ready");
    });
    const L = async (S) => {
      const p = await b(S);
      !(r.features.upload && !a.isFeatureDisabled("upload")) || a.getReadOnly() || a.isReadOnlyPath(a.path.get().path) || p.length > 0 && (r.modal.open(ln), setTimeout(() => {
        r.emitter.emit(
          "vf-external-files-dropped",
          p.map((C) => C.file)
        );
      }, 100));
    };
    return (S, p) => (c(), _("div", {
      ref_key: "root",
      ref: l,
      tabindex: "0",
      class: re(["vuefinder vuefinder__main vuefinder__themer", {
        "vuefinder--dragging-external": s(v),
        "vuefinder--windows-explorer": h.value
      }]),
      "data-theme": s(r).theme.current,
      style: Be(g.value),
      onDragenter: p[2] || (p[2] = //@ts-ignore
      (...F) => s(x) && s(x)(...F)),
      onDragover: p[3] || (p[3] = //@ts-ignore
      (...F) => s(y) && s(y)(...F)),
      onDragleave: p[4] || (p[4] = //@ts-ignore
      (...F) => s(m) && s(m)(...F)),
      onDrop: L
    }, [
      i("div", {
        class: re(s(r).theme.current),
        style: { height: "100%", width: "100%" }
      }, [
        i("div", {
          class: re([
            s(f)?.fullScreen ? "vuefinder__main__fixed" : "vuefinder__main__relative",
            "vuefinder__main__container"
          ]),
          onMousedown: p[0] || (p[0] = (F) => s(r).emitter.emit("vf-contextmenu-hide")),
          onTouchstart: p[1] || (p[1] = (F) => s(r).emitter.emit("vf-contextmenu-hide"))
        }, [
          s(v) ? (c(), _("div", Wh, [
            i("div", Yh, w(s(r).i18n.t("Drag and drop the files/folders to here.")), 1)
          ])) : V("", !0),
          s(f).showMenuBar && !h.value ? (c(), Y(Hc, { key: 1 })) : V("", !0),
          s(f).showToolbar && !h.value ? (c(), Y(ro, { key: 2 }, {
            "toolbar-actions": ae(() => [
              Ce(S.$slots, "toolbar-actions")
            ]),
            _: 3
          })) : V("", !0),
          h.value ? V("", !0) : (c(), Y(fv, { key: 3 })),
          h.value ? (c(), _("div", Xh, [
            j(qh, {
              "on-file-dclick": o.onFileDclick,
              "on-folder-dclick": o.onFolderDclick
            }, hs({
              icon: ae((F) => [
                Ce(S.$slots, "icon", We(Ye(F)))
              ]),
              _: 2
            }, [
              s(f).showToolbar ? {
                name: "toolbar",
                fn: ae(() => [
                  j(ro, null, {
                    "toolbar-actions": ae(() => [
                      Ce(S.$slots, "toolbar-actions")
                    ]),
                    _: 3
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["on-file-dclick", "on-folder-dclick"])
          ])) : (c(), _("div", Qh, [
            j(Mh),
            j(os, {
              "on-file-dclick": o.onFileDclick,
              "on-folder-dclick": o.onFolderDclick
            }, {
              icon: ae((F) => [
                Ce(S.$slots, "icon", We(Ye(F)))
              ]),
              _: 3
            }, 8, ["on-file-dclick", "on-folder-dclick"])
          ])),
          s(f).showStatusBar && !h.value ? (c(), Y(sh, { key: 6 }, {
            actions: ae((F) => [
              Ce(S.$slots, "status-bar", We(Ye(F)))
            ]),
            _: 3
          })) : V("", !0)
        ], 34),
        (c(), Y(Et, { to: "body" }, [
          j(ps, { name: "fade" }, {
            default: ae(() => [
              s(r).modal.visible ? (c(), Y(Ge(s(r).modal.type), { key: 0 })) : V("", !0)
            ]),
            _: 1
          })
        ])),
        j(q_, { items: s(rs) }, null, 8, ["items"]),
        (c(), Y(Et, { to: "body" }, [
          i("div", {
            class: "vuefinder__themer",
            "data-theme": s(r).theme.current
          }, [
            s(f).notificationsEnabled ? (c(), Y(s(ws), {
              key: 0,
              position: s(f).notificationPosition,
              duration: s(f).notificationDuration,
              "visible-toasts": s(f).notificationVisibleToasts,
              "rich-colors": s(f).notificationRichColors
            }, null, 8, ["position", "duration", "visible-toasts", "rich-colors"])) : V("", !0)
          ], 8, Jh)
        ]))
      ], 2)
    ], 46, Gh));
  }
}), ep = /* @__PURE__ */ le({
  __name: "VueFinderProvider",
  props: {
    id: {},
    driver: {},
    config: {},
    features: {},
    debug: { type: Boolean, default: !1 },
    locale: {},
    contextMenuItems: { default: () => rs },
    copyPath: {},
    selectionMode: { default: "multiple" },
    selectionFilterType: { default: "both" },
    selectionFilterMimeIncludes: { default: () => [] },
    onError: {},
    onSelect: {},
    onPathChange: {},
    onUploadComplete: {},
    onDeleteComplete: {},
    onAccessChange: {},
    onDownloadRequested: {},
    onOfficeFileCreated: {},
    onFavoritesChange: {},
    onNotify: {},
    onReady: {},
    onFileDclick: {},
    onFolderDclick: {},
    customUploader: {}
  },
  setup(n) {
    const e = n, t = e.id ?? ht(bn);
    if (!t)
      throw new Error('VueFinderProvider requires an "id" prop.');
    const o = qs(e, ht("VueFinderOptions") || {});
    return me(
      () => e.config,
      (r) => {
        if (r) {
          const l = {};
          for (const d in r) {
            const a = s(r[d]);
            a !== void 0 && (l[d] = a);
          }
          o.config.init(l);
        }
      },
      { deep: !0, immediate: !0 }
    ), me(
      () => e.locale,
      (r) => {
        r && o.i18n.localeAtom && o.i18n.localeAtom.get() !== r && o.i18n.localeAtom.set(r);
      },
      { immediate: !0 }
    ), Ss(t, o), ms(bn, t), fo(() => {
      Cs(t);
    }), (r, l) => (c(), Y(Zh, We(Ye(e)), {
      icon: ae((d) => [
        Ce(r.$slots, "icon", We(Ye(d)))
      ]),
      "status-bar": ae((d) => [
        Ce(r.$slots, "status-bar", We(Ye(d)))
      ]),
      "toolbar-actions": ae(() => [
        Ce(r.$slots, "toolbar-actions")
      ]),
      _: 3
    }, 16));
  }
}), tp = "vuefinder_picker_last_path";
function np(n) {
  return In(`${tp}_${n}`, "", {
    encode: JSON.stringify,
    decode: JSON.parse
  });
}
const op = { class: "finder-picker vuefinder vuefinder__themer" }, sp = { class: "vuefinder__windows-layout__path finder-picker__path" }, ip = { class: "vuefinder__windows-layout__path-value" }, rp = ["onClick"], ap = {
  key: 0,
  class: "finder-picker__status"
}, lp = {
  key: 1,
  class: "finder-picker__status finder-picker__status--error"
}, dp = {
  key: 2,
  class: "finder-picker__list"
}, cp = { class: "vuefinder__explorer__header finder-picker__header" }, up = ["onClick", "onDblclick"], fp = { class: "vuefinder__explorer__item-list-content" }, vp = { class: "vuefinder__explorer__item-list-name" }, _p = { class: "vuefinder__explorer__item-list-icon" }, hp = { class: "vuefinder__explorer__item-name" }, pp = { class: "vuefinder__explorer__item-date" }, mp = { class: "vuefinder__explorer__item-type" }, gp = ["onClick", "onDblclick", "onAnimationend"], wp = { class: "vuefinder__explorer__item-list-content" }, yp = { class: "vuefinder__explorer__item-list-name" }, bp = { class: "vuefinder__explorer__item-list-icon" }, kp = { class: "vuefinder__explorer__item-name" }, xp = { class: "vuefinder__explorer__item-date" }, $p = { class: "vuefinder__explorer__item-type" }, Sp = { class: "vuefinder__explorer__item-size" }, Cp = {
  key: 0,
  class: "finder-picker__status"
}, Fp = {
  key: 3,
  class: "finder-picker__filename"
}, Ep = { class: "finder-picker__filename-label" }, Dp = { class: "finder-picker__footer" }, Pp = {
  key: 0,
  class: "finder-picker__selection-count"
}, Ip = { key: 0 }, Tp = ["disabled"], Mp = ["disabled"], Ap = /* @__PURE__ */ le({
  __name: "FinderPickerModal",
  props: {
    driver: {},
    initialPath: {},
    extensions: {},
    mode: {},
    multiple: { type: Boolean },
    maxSelection: {},
    locale: {},
    storageKey: {},
    defaultFilename: {}
  },
  emits: ["select", "select-multiple", "cancel"],
  setup(n, { emit: e }) {
    const t = n, o = e, r = ht(
      "VueFinderOptions",
      {}
    ), l = { emit: () => {
    } }, d = On(
      An("picker"),
      t.locale ?? r.locale ?? "",
      l,
      r.i18n ?? {}
    ), { t: a } = d, u = np(t.storageKey ?? t.mode ?? "file"), f = B(() => t.mode === "folder" && t.defaultFilename !== void 0), g = z(t.defaultFilename ?? ""), h = z(t.initialPath), v = z([]), x = z(!1), y = z(null), m = B(() => h.value.split("://")[0] || ""), b = B(() => Xt(m.value, a)), I = B(() => {
      const ee = (h.value.split("://")[1] || "").split("/").filter(Boolean);
      let Q = "";
      return ee.map((ce) => (Q = Q ? `${Q}/${ce}` : ce, { basename: ce, name: ce, path: `${m.value}://${Q}` }));
    }), L = B(() => v.value.filter((K) => K.type === "dir")), S = B(
      () => v.value.filter((K) => {
        if (K.type !== "file") return !1;
        if (t.mode === "folder" || !t.extensions || t.extensions.length === 0) return !0;
        const ee = (K.extension || "").toLowerCase().replace(/^\./, "");
        return t.extensions.map((Q) => Q.toLowerCase()).includes(ee);
      })
    ), p = z("basename"), F = z("asc");
    function C(K) {
      F.value = bo(p.value === K, F.value), p.value = K;
    }
    const E = B(() => Ht(L.value, p.value, F.value)), P = B(() => Ht(S.value, p.value, F.value));
    async function N() {
      x.value = !0, y.value = null;
      try {
        const K = await t.driver.list({ path: h.value });
        v.value = K.files || [], to(h.value) || u.set(h.value);
      } catch (K) {
        y.value = K instanceof Error ? K.message : String(K), v.value = [];
      } finally {
        x.value = !1;
      }
    }
    function te(K) {
      k.value = null, h.value = K.path, N();
    }
    function W(K) {
      h.value = K, N();
    }
    function se() {
      h.value = `${m.value}://`, N();
    }
    const $ = z(/* @__PURE__ */ new Map()), k = z(null), T = z(null), M = z(/* @__PURE__ */ new Set());
    let q = null;
    function pe(K) {
      o("select", K);
    }
    function R(K) {
      return $.value.has(J(K));
    }
    function D(K) {
      k.value = K.path;
    }
    function A(K) {
      te(K);
    }
    function H(K) {
      const ee = P.value.findIndex((ie) => J(ie) === T.value), Q = P.value.findIndex((ie) => J(ie) === J(K));
      if (ee === -1 || Q === -1)
        return /* @__PURE__ */ new Map([[J(K), K]]);
      const [ce, Se] = ee < Q ? [ee, Q] : [Q, ee], Qe = P.value.slice(ce, Se + 1), He = /* @__PURE__ */ new Map();
      for (const ie of Qe) {
        if (t.maxSelection && He.size >= t.maxSelection) break;
        He.set(J(ie), ie);
      }
      const tt = Qe.slice(He.size);
      return tt.length && U(tt), He;
    }
    function U(K) {
      q !== null && cancelAnimationFrame(q), M.value = /* @__PURE__ */ new Set(), q = requestAnimationFrame(() => {
        q = null, M.value = new Set(K.map((ee) => J(ee)));
      });
    }
    function O(K, ee) {
      if (ee.target !== ee.currentTarget || !ee.animationName.includes("finder-picker-selection-limit")) return;
      const Q = J(K);
      if (!M.value.has(Q)) return;
      const ce = new Set(M.value);
      ce.delete(Q), M.value = ce;
    }
    Te(() => {
      q !== null && cancelAnimationFrame(q);
    });
    function X(K, ee) {
      if (t.mode === "folder") {
        f.value && (g.value = K.basename || K.name || "");
        return;
      }
      if (!t.multiple) {
        pe(K);
        return;
      }
      if (ee.shiftKey) {
        $.value = H(K);
        return;
      }
      if (ee.ctrlKey || ee.metaKey) {
        const Q = new Map($.value), ce = J(K);
        Q.has(ce) ? Q.delete(ce) : (!t.maxSelection || Q.size < t.maxSelection) && Q.set(ce, K), $.value = Q;
      } else
        $.value = /* @__PURE__ */ new Map([[J(K), K]]);
      T.value = J(K);
    }
    function ne(K) {
      if (t.mode === "folder") {
        f.value && (g.value = K.basename || K.name || "");
        return;
      }
      if (!t.multiple) {
        pe(K);
        return;
      }
      $.value = /* @__PURE__ */ new Map(), o("select-multiple", [K]);
    }
    function ue() {
      o("select-multiple", Array.from($.value.values())), $.value = /* @__PURE__ */ new Map();
    }
    function _e() {
      if (f.value && !g.value.trim()) return;
      const K = h.value, ee = K.split("://")[0] ?? "", Q = K.split("://")[1]?.split("/").filter(Boolean) || [];
      o("select", {
        // Синтетическая папка-назначение: id = путь.
        id: K,
        dir: Q.slice(0, -1).join("/"),
        basename: Q[Q.length - 1] || ee,
        path: K,
        storage: ee,
        type: "dir",
        extension: "",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: "public",
        ...f.value ? { saveFilename: g.value.trim() } : {}
      });
    }
    return Fe(async () => {
      const K = u.get();
      if (K && to(K))
        u.set("");
      else if (K) {
        h.value = K, await N(), y.value && (h.value = t.initialPath, await N());
        return;
      }
      await N();
    }), (K, ee) => (c(), _("div", op, [
      i("div", sp, [
        i("div", ip, [
          i("button", {
            type: "button",
            class: "vuefinder__windows-layout__path-segment",
            onClick: se
          }, w(b.value), 1),
          (c(!0), _(he, null, ke(I.value, (Q) => (c(), _(he, {
            key: Q.path
          }, [
            ee[6] || (ee[6] = i("span", { class: "vuefinder__windows-layout__path-separator" }, "/", -1)),
            i("button", {
              type: "button",
              class: "vuefinder__windows-layout__path-segment",
              onClick: (ce) => W(Q.path)
            }, w(s(Ue)(Q, s(a))), 9, rp)
          ], 64))), 128))
        ])
      ]),
      x.value ? (c(), _("div", ap, w(s(a)("Loading")) + "… ", 1)) : y.value ? (c(), _("div", lp, w(y.value), 1)) : (c(), _("div", dp, [
        i("div", cp, [
          i("div", {
            class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--name",
            onClick: ee[0] || (ee[0] = (Q) => C("basename"))
          }, [
            ye(w(s(a)("Name")) + " ", 1),
            xe(j(ot, { direction: F.value }, null, 8, ["direction"]), [
              [ze, p.value === "basename"]
            ])
          ]),
          i("div", {
            class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--date",
            onClick: ee[1] || (ee[1] = (Q) => C("last_modified"))
          }, [
            ye(w(s(a)("Date modified")) + " ", 1),
            xe(j(ot, { direction: F.value }, null, 8, ["direction"]), [
              [ze, p.value === "last_modified"]
            ])
          ]),
          i("div", {
            class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--type",
            onClick: ee[2] || (ee[2] = (Q) => C("type"))
          }, [
            ye(w(s(a)("Type")) + " ", 1),
            xe(j(ot, { direction: F.value }, null, 8, ["direction"]), [
              [ze, p.value === "type"]
            ])
          ]),
          i("div", {
            class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--size",
            onClick: ee[3] || (ee[3] = (Q) => C("file_size"))
          }, [
            ye(w(s(a)("Size")) + " ", 1),
            xe(j(ot, { direction: F.value }, null, 8, ["direction"]), [
              [ze, p.value === "file_size"]
            ])
          ])
        ]),
        (c(!0), _(he, null, ke(E.value, (Q) => (c(), _("div", {
          key: Q.path,
          class: re(["vf-explorer-item-list finder-picker__row", { "vf-explorer-selected": k.value === Q.path }]),
          onClick: (ce) => D(Q),
          onDblclick: (ce) => A(Q)
        }, [
          i("div", fp, [
            i("div", vp, [
              i("div", _p, [
                (c(), Y(Ge(s(Sn)(Q)), {
                  class: re(s(Qt)(Q) ? "vuefinder__item-icon__trash" : "vuefinder__item-icon__folder")
                }, null, 8, ["class"]))
              ]),
              i("span", hp, w(s(Ue)(Q, s(a))), 1)
            ]),
            i("div", pp, w(s(xn)(Q.last_modified)), 1),
            i("div", mp, w(s(kn)(Q, s(a))), 1),
            ee[7] || (ee[7] = i("div", { class: "vuefinder__explorer__item-size" }, null, -1))
          ])
        ], 42, up))), 128)),
        (c(!0), _(he, null, ke(P.value, (Q) => (c(), _("div", {
          key: s(J)(Q),
          class: re(["vf-explorer-item-list finder-picker__row", {
            "vf-explorer-selected": n.multiple && R(Q) || f.value && g.value === (Q.basename || Q.name),
            "finder-picker__row--file-selected": n.multiple && R(Q),
            "finder-picker__row--selection-limit": M.value.has(s(J)(Q))
          }]),
          onClick: (ce) => X(Q, ce),
          onDblclick: (ce) => ne(Q),
          onAnimationend: (ce) => O(Q, ce)
        }, [
          i("div", wp, [
            i("div", yp, [
              i("div", bp, [
                (c(), Y(Ge(s(Sn)(Q)), { class: "vuefinder__item-icon__format" }))
              ]),
              i("span", kp, w(s(Ue)(Q, s(a))), 1)
            ]),
            i("div", xp, w(s(xn)(Q.last_modified)), 1),
            i("div", $p, w(s(kn)(Q, s(a))), 1),
            i("div", Sp, w(Q.file_size ? s(Yt)(Q.file_size) : ""), 1)
          ])
        ], 42, gp))), 128)),
        !L.value.length && !S.value.length ? (c(), _("div", Cp, w(s(a)("This folder is empty.")), 1)) : V("", !0)
      ])),
      f.value ? (c(), _("div", Fp, [
        i("label", Ep, w(s(a)("File Name")) + ":", 1),
        xe(i("input", {
          "onUpdate:modelValue": ee[4] || (ee[4] = (Q) => g.value = Q),
          type: "text",
          class: "finder-picker__filename-input",
          onKeyup: yt(_e, ["enter"])
        }, null, 544), [
          [bt, g.value]
        ])
      ])) : V("", !0),
      i("div", Dp, [
        n.multiple && n.mode !== "folder" ? (c(), _("div", Pp, [
          i("span", null, [
            ye(w(s(a)("Selected")) + ": " + w($.value.size), 1),
            n.maxSelection ? (c(), _("span", Ip, " / " + w(n.maxSelection), 1)) : V("", !0)
          ]),
          i("span", null, w(s(a)("Ctrl/Cmd + click to add files; Shift + click to select a range")), 1)
        ])) : V("", !0),
        i("button", {
          type: "button",
          class: "finder-picker__cancel",
          onClick: ee[5] || (ee[5] = (Q) => o("cancel"))
        }, w(s(a)("Cancel")), 1),
        n.mode === "folder" ? (c(), _("button", {
          key: 1,
          type: "button",
          class: "finder-picker__select-folder",
          disabled: f.value && !g.value.trim(),
          onClick: _e
        }, w(f.value ? s(a)("Save") : s(a)("Select this folder")), 9, Tp)) : V("", !0),
        n.multiple && n.mode !== "folder" ? (c(), _("button", {
          key: 2,
          type: "button",
          class: "finder-picker__confirm",
          disabled: $.value.size === 0,
          onClick: ue
        }, w(s(a)("Select")) + " (" + w($.value.size) + ") ", 9, Mp)) : V("", !0)
      ])
    ]));
  }
}), Qp = /* @__PURE__ */ Ko(Ap, [["__scopeId", "data-v-80e7708b"]]);
function Xp(n) {
  const e = fe(n), t = (d) => d || e.fs.path.get().path || "", o = (d) => {
    const a = new Map(
      (e.fs.files.get() || []).map((u) => [u.path, u])
    );
    return (d || []).map((u) => a.get(u)).filter((u) => !!u);
  }, r = (d) => {
    const a = o(d);
    if (a.length !== (d || []).length)
      throw new Error("Item not found in the current folder.");
    return a;
  }, l = (d) => {
    Array.isArray(d.files) && e.fs.setFiles(d.files);
  };
  return {
    async refresh() {
      const d = e.fs.path.get().path || "";
      e.adapter.invalidateListQuery(d), await e.adapter.open(d);
    },
    async open(d) {
      await e.adapter.open(d);
    },
    notify(d, a) {
      at(e, d, a);
    },
    getPath() {
      return e.fs.path.get().path || "";
    },
    select(d) {
      e.fs.setSelection(o(d).map(J));
    },
    selectOne(d) {
      const [a] = o([d]);
      a && e.fs.setSelection([J(a)]);
    },
    clearSelection() {
      e.fs.clearSelection();
    },
    getSelectedPaths() {
      return (e.fs.selectedItems.get() || []).map((d) => d.path);
    },
    async createFolder(d, a) {
      const u = await e.adapter.createFolder({ path: t(a), name: d });
      l(u);
    },
    async createFile(d, a) {
      const u = await e.adapter.createFile({ path: t(a), name: d });
      l(u);
    },
    async delete(d, a) {
      const u = t(a), f = o(d).map(_t), g = await e.adapter.delete({ path: u, items: f });
      l(g);
    },
    async rename(d, a, u) {
      const [f] = o([d]);
      if (!f)
        throw new Error("Item not found in the current folder.");
      if (f.type === "file" && dr(f.basename, a))
        throw new Error("File extension cannot be changed.");
      const g = await e.adapter.rename({
        path: t(u),
        item: d,
        id: f.id,
        name: a
      });
      l(g);
    },
    async copy(d, a, u) {
      const f = await e.adapter.copy({
        path: t(u),
        sources: r(d).map(_t),
        destination: a
      });
      l(f);
    },
    async move(d, a, u) {
      const f = await e.adapter.move({
        path: t(u),
        sources: r(d).map(_t),
        destination: a
      });
      l(f);
    },
    updateItem(d) {
      const a = J(d), u = e.fs.files.get() || [];
      u.some((f) => J(f) === a) && e.fs.setFiles(u.map((f) => J(f) === a ? d : f)), e.adapter.invalidateListQuery(d.dir);
    },
    getFiles() {
      return e.fs.files.get() || [];
    },
    getStorages() {
      return e.fs.storages.get() || [];
    },
    isLoading() {
      return e.fs.isLoading();
    },
    isReadOnly() {
      return e.fs.getReadOnly();
    }
  };
}
function Jp(n) {
  const { driver: e, getTargetPath: t, debug: o = !1 } = n;
  if (!e.configureUploader)
    throw new Error("Driver does not support configureUploader");
  const r = new _o({ debug: o, autoProceed: !1 }), l = /* @__PURE__ */ new Map();
  let d = "error";
  const a = {
    getTargetPath: t,
    getConflictAction: () => d
  };
  e.configureUploader(r, a), r.on("upload-error", (x, y, m) => {
    x && l.set(x.id, {
      name: x.name,
      error: y.message || "Upload failed",
      statusCode: m?.status
    });
  });
  const u = (x) => {
    x.forEach((y) => {
      r.addFile({ name: y.name, type: y.type, data: y, source: "Local" });
    });
  }, f = async () => {
    const { conflicts: x } = await e.checkUploadConflicts({
      path: t(),
      names: r.getFiles().map((y) => y.name)
    });
    return x;
  }, g = async (x = "error") => {
    d = x, l.clear();
    const y = await r.upload();
    return {
      successful: (y?.successful ?? []).map((m) => m.name),
      failed: (y?.failed ?? []).map(
        (m) => l.get(m.id) ?? {
          name: m.name,
          error: m.error || "Upload failed"
        }
      )
    };
  }, h = () => {
    r.cancelAll(), l.clear(), r.getFiles().forEach((x) => r.removeFile(x.id));
  };
  return { uppy: r, addFiles: u, getConflictingNames: f, upload: g, clear: h, destroy: () => {
    h(), r.destroy();
  } };
}
const Zp = {
  install(n, e = {}) {
    e.i18n = e.i18n ?? {};
    const [t] = Object.keys(e.i18n);
    e.locale = e.locale ?? t ?? "en", n.provide("VueFinderOptions", e), n.component("VueFinder", ep);
  }
};
export {
  Us as ArrayDriver,
  zn as BaseAdapter,
  De as ContextMenuIds,
  Qp as FinderPickerModal,
  Yp as IndexedDBDriver,
  $o as RemoteDriver,
  td as UploadConflictDialog,
  ep as VueFinder,
  Zp as VueFinderPlugin,
  ep as VueFinderProvider,
  rs as contextMenuItems,
  Fs as createLocaleAtom,
  Zp as default,
  Wp as parseBackendError,
  $t as parseBackendErrorPayload,
  Jp as useHeadlessUploader,
  Xp as useVueFinder
};
